// DO NOT EDIT THIS FILE.
// THIS IS A GENERATED FILE AND ANY EDIT WILL BE REPLACED
// Home: github.com/00-team/argon
import * as ud from './user_defined';
export const API_VERSION = '0.2.0';

interface _Map<V> { [key: string]: V }

export type AbzarClearSsrCacheBody = { eateries:(boolean),main:(boolean),restart_ssr_service:(boolean), };
export const ABZAR_CLEAR_SSR_CACHE_BODY_DEF: AbzarClearSsrCacheBody = {eateries:(false),main:(false),restart_ssr_service:(false),};
export type AbzarWheatFetchBody = { id:(string), };
export const ABZAR_WHEAT_FETCH_BODY_DEF: AbzarWheatFetchBody = {id:(''),};
export type Gene = ((string) | null);
export const GENE_DEF: Gene = null;
export type AddDishBody = { eatery:Gene, };
export const ADD_DISH_BODY_DEF: AddDishBody = {eatery:GENE_DEF,};
export type KhabarNewReview = { review:Gene, };
export const KHABAR_NEW_REVIEW_DEF: KhabarNewReview = {review:GENE_DEF,};
export type KhabarNewEatery = { eatery:Gene, };
export const KHABAR_NEW_EATERY_DEF: KhabarNewEatery = {eatery:GENE_DEF,};
export type KhabarSuggest = { suggest:Gene, };
export const KHABAR_SUGGEST_DEF: KhabarSuggest = {suggest:GENE_DEF,};
export type KhabarKind = ({ kind:("unknown"), })|(KhabarNewReview&({ kind:("new_review"), }))|(KhabarNewEatery&({ kind:("new_eatery"), }))|(KhabarSuggest&({ kind:("suggest"), }));
export const KHABAR_KIND_DEF: KhabarKind = ({kind:('unknown'),});
export type AddKhabar = { kind:KhabarKind, };
export const ADD_KHABAR_DEF: AddKhabar = {kind:KHABAR_KIND_DEF,};
export type AddReviewBody = { detail:(string),star_food:(number),star_service:(number),star_vibe:(number), };
export const ADD_REVIEW_BODY_DEF: AddReviewBody = {detail:(''),star_food:(0),star_service:(0),star_vibe:(0),};
export type AddTipBody = { detail:(string),is_anonymous?:(((boolean) | null)), };
export const ADD_TIP_BODY_DEF: AddTipBody = {detail:(''),};
export type EntityFlags = { is_alive:(boolean), };
export const ENTITY_FLAGS_DEF: EntityFlags = {is_alive:(false),};
export type ShahString = string;
export const SHAH_STRING_DEF: ShahString = '';
export type Cabbage = { content:Gene,eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),issue:Gene,likes:(number),pond:Gene,star_food:(number),star_service:(number),star_vibe:(number),summary:ShahString,timestamp:(number),user_id:ShahString,username:ShahString, };
export const CABBAGE_DEF: Cabbage = {content:GENE_DEF,eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),issue:GENE_DEF,likes:(0),pond:GENE_DEF,star_food:(0),star_service:(0),star_vibe:(0),summary:SHAH_STRING_DEF,timestamp:(0),user_id:SHAH_STRING_DEF,username:SHAH_STRING_DEF,};
export type GeneId = number;
export const GENE_ID_DEF: GeneId = 0;
export type ShahPond = { alive:(number),empty:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),next:Gene,origin:Gene,past:Gene,stack:GeneId, };
export const SHAH_POND_DEF: ShahPond = {alive:(0),empty:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),next:GENE_DEF,origin:GENE_DEF,past:GENE_DEF,stack:GENE_ID_DEF,};
export type AdminCabbageList = { list:((Cabbage[])),pond:ShahPond, };
export const ADMIN_CABBAGE_LIST_DEF: AdminCabbageList = {list:([]),pond:SHAH_POND_DEF,};
export type DishKind = "unknown"|"food"|"pizza"|"burger"|"dessert"|"pasta"|"icecream"|"seafood"|"soup"|"ash"|"kabab"|"polo"|"chicken"|"steak"|"sandwich"|"salad"|"fried"|"___fish"|"sushi"|"sides"|"noodle"|"meat"|"waffle"|"croissant"|"bread"|"cake"|"cookie"|"omelette"|"friedegg"|"sandwich_hotdog"|"appetizer"|"drink"|"tea"|"coffee"|"soda"|"sharbat"|"milk"|"juice"|"chocolate"|"milkshake"|"smoothie"|"tea_herbal"|"coffee_ice"|"tea_ice"|"other"|"qelyan"|"cigar"|"service";
export const DISH_KIND = ["unknown","food","pizza","burger","dessert","pasta","icecream","seafood","soup","ash","kabab","polo","chicken","steak","sandwich","salad","fried","___fish","sushi","sides","noodle","meat","waffle","croissant","bread","cake","cookie","omelette","friedegg","sandwich_hotdog","appetizer","drink","tea","coffee","soda","sharbat","milk","juice","chocolate","milkshake","smoothie","tea_herbal","coffee_ice","tea_ice","other","qelyan","cigar","service",] as const;
export function is_dish_kind(value: string): value is DishKind {
    return DISH_KIND.includes(value as DishKind)
}
;
export const DISH_KIND_DEF: DishKind = 'unknown';
export type FilterEnum_DishKind = ({ opt:("eq"),value:DishKind, })|({ opt:("ne"),value:DishKind, })|({ opt:("in"),value:((DishKind[])), })|({ opt:("not_in"),value:((DishKind[])), });
export const FILTER_ENUM__DISH_KIND_DEF: FilterEnum_DishKind = ({opt:('eq'),value:DISH_KIND_DEF,});
export type FilterNumber_f64 = ({ opt:("gt"),value:(number), })|({ opt:("lt"),value:(number), })|({ opt:("eq"),value:(number), })|({ opt:("ne"),value:(number), })|({ opt:("in"),value:(((number)[])), })|({ opt:("not_in"),value:(((number)[])), });
export const FILTER_NUMBER_F64_DEF: FilterNumber_f64 = ({opt:('gt'),value:(0),});
export type FilterNumber_f32 = ({ opt:("gt"),value:(number), })|({ opt:("lt"),value:(number), })|({ opt:("eq"),value:(number), })|({ opt:("ne"),value:(number), })|({ opt:("in"),value:(((number)[])), })|({ opt:("not_in"),value:(((number)[])), });
export const FILTER_NUMBER_F32_DEF: FilterNumber_f32 = ({opt:('gt'),value:(0),});
export type GeoRadius = { distance_in_meters:(number),lat:(number),lng:(number), };
export const GEO_RADIUS_DEF: GeoRadius = {distance_in_meters:(0),lat:(0),lng:(0),};
export type AdminDishFilter = ({ kind:("is_hidden"),value:(boolean), })|({ kind:("kind"),value:FilterEnum_DishKind, })|({ kind:("eatery"),value:Gene, })|({ kind:("price"),value:FilterNumber_f64, })|({ kind:("stars"),value:FilterNumber_f32, })|({ kind:("photo"),value:(boolean), })|({ kind:("geo_radius"),value:GeoRadius, })|({ kind:("or"), })|({ kind:("and"), })|({ kind:("group"),value:((AdminDishFilter[])), });
export const ADMIN_DISH_FILTER_DEF: AdminDishFilter = ({kind:('is_hidden'),value:(false),});
export type ShahEnum_u16_DishKind = "unknown"|"food"|"pizza"|"burger"|"dessert"|"pasta"|"icecream"|"seafood"|"soup"|"ash"|"kabab"|"polo"|"chicken"|"steak"|"sandwich"|"salad"|"fried"|"___fish"|"sushi"|"sides"|"noodle"|"meat"|"waffle"|"croissant"|"bread"|"cake"|"cookie"|"omelette"|"friedegg"|"sandwich_hotdog"|"appetizer"|"drink"|"tea"|"coffee"|"soda"|"sharbat"|"milk"|"juice"|"chocolate"|"milkshake"|"smoothie"|"tea_herbal"|"coffee_ice"|"tea_ice"|"other"|"qelyan"|"cigar"|"service";
export const SHAH_ENUM_U16__DISH_KIND = ["unknown","food","pizza","burger","dessert","pasta","icecream","seafood","soup","ash","kabab","polo","chicken","steak","sandwich","salad","fried","___fish","sushi","sides","noodle","meat","waffle","croissant","bread","cake","cookie","omelette","friedegg","sandwich_hotdog","appetizer","drink","tea","coffee","soda","sharbat","milk","juice","chocolate","milkshake","smoothie","tea_herbal","coffee_ice","tea_ice","other","qelyan","cigar","service",] as const;
export function is_shah_enum_u16__dish_kind(value: string): value is ShahEnum_u16_DishKind {
    return SHAH_ENUM_U16__DISH_KIND.includes(value as ShahEnum_u16_DishKind)
}
;
export const SHAH_ENUM_U16__DISH_KIND_DEF: ShahEnum_u16_DishKind = 'unknown';
export type DishDaily = { in_friday:(boolean),in_monday:(boolean),in_saturday:(boolean),in_sunday:(boolean),in_thursday:(boolean),in_tuesday:(boolean),in_wednesday:(boolean),is_daily:(boolean), };
export const DISH_DAILY_DEF: DishDaily = {in_friday:(false),in_monday:(false),in_saturday:(false),in_sunday:(false),in_thursday:(false),in_tuesday:(false),in_wednesday:(false),is_daily:(false),};
export type DishFlags = { is_hidden:(boolean), };
export const DISH_FLAGS_DEF: DishFlags = {is_hidden:(false),};
export type Flag2 = "idk"|"yes"|"no";
export const FLAG2 = ["idk","yes","no",] as const;
export function is_flag2(value: string): value is Flag2 {
    return FLAG2.includes(value as Flag2)
}
;
export const FLAG2_DEF: Flag2 = 'idk';
export type DishTags = { _is_offering:Flag2,_is_spot_rate_price:Flag2,is_available:Flag2,is_breakfast:Flag2,is_dinner:Flag2,is_free:Flag2,is_lunch:Flag2, };
export const DISH_TAGS_DEF: DishTags = {_is_offering:FLAG2_DEF,_is_spot_rate_price:FLAG2_DEF,is_available:FLAG2_DEF,is_breakfast:FLAG2_DEF,is_dinner:FLAG2_DEF,is_free:FLAG2_DEF,is_lunch:FLAG2_DEF,};
export type Dish = { combo:ShahEnum_u16_DishKind,daily:DishDaily,eatery:Gene,entity_flags:EntityFlags,flags:DishFlags,gene:Gene,growth:(number),kind:ShahEnum_u16_DishKind,name:ShahString,note:ShahString,photos:((Gene[])),pond:Gene,price:(number),tags:DishTags, };
export const DISH_DEF: Dish = {combo:SHAH_ENUM_U16__DISH_KIND_DEF,daily:DISH_DAILY_DEF,eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,flags:DISH_FLAGS_DEF,gene:GENE_DEF,growth:(0),kind:SHAH_ENUM_U16__DISH_KIND_DEF,name:SHAH_STRING_DEF,note:SHAH_STRING_DEF,photos:([]),pond:GENE_DEF,price:(0),tags:DISH_TAGS_DEF,};
export type DishForm = "unknown"|"food"|"drink"|"other";
export const DISH_FORM = ["unknown","food","drink","other",] as const;
export function is_dish_form(value: string): value is DishForm {
    return DISH_FORM.includes(value as DishForm)
}
;
export const DISH_FORM_DEF: DishForm = 'unknown';
export type DishInfo = Dish&({ form:DishForm, });
export const DISH_INFO_DEF: DishInfo = {...DISH_DEF,...({form:DISH_FORM_DEF,}),};
export type AdminDishList = { list:((DishInfo[])),pond:ShahPond, };
export const ADMIN_DISH_LIST_DEF: AdminDishList = {list:([]),pond:SHAH_POND_DEF,};
export type DishSort = ({ kind:("price"), })|({ kind:("geo_point"),lat:(number),lng:(number), })|({ kind:("review_count"), })|({ kind:("star_sum"), })|({ kind:("stars"), })|({ kind:("random_id"), });
export const DISH_SORT_DEF: DishSort = ({kind:('price'),});
export type SortOrder = "desc"|"asc";
export const SORT_ORDER = ["desc","asc",] as const;
export function is_sort_order(value: string): value is SortOrder {
    return SORT_ORDER.includes(value as SortOrder)
}
;
export const SORT_ORDER_DEF: SortOrder = 'desc';
export type DishSortItem = { by:DishSort,od?:((SortOrder | null)), };
export const DISH_SORT_ITEM_DEF: DishSortItem = {by:DISH_SORT_DEF,};
export type AdminDishSearchBody = { filters:((AdminDishFilter[])),name:(string),sort:((DishSortItem[])), };
export const ADMIN_DISH_SEARCH_BODY_DEF: AdminDishSearchBody = {filters:([]),name:(''),sort:([]),};
export type AdminEateryBulkBody = { list:((Gene[])), };
export const ADMIN_EATERY_BULK_BODY_DEF: AdminEateryBulkBody = {list:([]),};
export type EateryTagsInput = { allows_long_stays?:((Flag2 | null)),can_smoke_indoor?:((Flag2 | null)),has_breakfast?:((Flag2 | null)),has_delivery?:((Flag2 | null)),has_dine_in?:((Flag2 | null)),has_dinner?:((Flag2 | null)),has_dj?:((Flag2 | null)),has_drive_through?:((Flag2 | null)),has_good_view?:((Flag2 | null)),has_halal_food?:((Flag2 | null)),has_indoor_seating?:((Flag2 | null)),has_live_music?:((Flag2 | null)),has_lunch?:((Flag2 | null)),has_outdoor_seating?:((Flag2 | null)),has_parking?:((Flag2 | null)),has_private_dining?:((Flag2 | null)),has_qelyan?:((Flag2 | null)),has_reservations?:((Flag2 | null)),has_self_service?:((Flag2 | null)),has_solo_dining?:((Flag2 | null)),has_takeaway?:((Flag2 | null)),has_toilet?:((Flag2 | null)),has_tv?:((Flag2 | null)),has_vegan_food?:((Flag2 | null)),has_vegetarian_food?:((Flag2 | null)),has_wifi?:((Flag2 | null)),is_photogenic?:((Flag2 | null)),is_suitable_for_children?:((Flag2 | null)),is_suitable_for_large_groups?:((Flag2 | null)),is_suitable_for_pets?:((Flag2 | null)),is_suitable_for_reading?:((Flag2 | null)),is_suitable_for_social_working?:((Flag2 | null)),is_tourist_friendly?:((Flag2 | null)),is_wheelchair_accessible?:((Flag2 | null)), };
export const EATERY_TAGS_INPUT_DEF: EateryTagsInput = {};
export type EateryFlagsInput = { has_content_in_1_month?:(((boolean) | null)),has_content_in_1_year?:(((boolean) | null)),has_content_in_3_months?:(((boolean) | null)),has_employee?:(((boolean) | null)),holds_birthday_parties?:(((boolean) | null)),is_24_7?:(((boolean) | null)),is_address_custom?:(((boolean) | null)),is_address_google?:(((boolean) | null)),is_address_parsimap?:(((boolean) | null)),is_brand?:(((boolean) | null)),is_close?:(((boolean) | null)),is_famous?:(((boolean) | null)),is_for_guest?:(((boolean) | null)),is_hidden?:(((boolean) | null)),is_low_quality?:(((boolean) | null)),is_perma_close?:(((boolean) | null)),is_tender?:(((boolean) | null)),is_tourist_attraction?:(((boolean) | null)),is_unique?:(((boolean) | null)),trailer_m3u8_rendered?:(((boolean) | null)),trailer_preview_rendered?:(((boolean) | null)), };
export const EATERY_FLAGS_INPUT_DEF: EateryFlagsInput = {};
export type EateryGroup = "unknown"|"cafe"|"restaurant"|"fast_food"|"dessert";
export const EATERY_GROUP = ["unknown","cafe","restaurant","fast_food","dessert",] as const;
export function is_eatery_group(value: string): value is EateryGroup {
    return EATERY_GROUP.includes(value as EateryGroup)
}
;
export const EATERY_GROUP_DEF: EateryGroup = 'unknown';
export type FilterEnum_EateryGroup = ({ opt:("eq"),value:EateryGroup, })|({ opt:("ne"),value:EateryGroup, })|({ opt:("in"),value:((EateryGroup[])), })|({ opt:("not_in"),value:((EateryGroup[])), });
export const FILTER_ENUM__EATERY_GROUP_DEF: FilterEnum_EateryGroup = ({opt:('eq'),value:EATERY_GROUP_DEF,});
export type EateryDomain = "none"|"cafe"|"bakery"|"teahouse"|"restaurant"|"seafood"|"dizi"|"ash"|"kababi"|"kalle_pache"|"liver"|"fast_food"|"hot_dog"|"sandwich"|"falafel"|"fried"|"dessert"|"ice_cream"|"juicery"|"gelato";
export const EATERY_DOMAIN = ["none","cafe","bakery","teahouse","restaurant","seafood","dizi","ash","kababi","kalle_pache","liver","fast_food","hot_dog","sandwich","falafel","fried","dessert","ice_cream","juicery","gelato",] as const;
export function is_eatery_domain(value: string): value is EateryDomain {
    return EATERY_DOMAIN.includes(value as EateryDomain)
}
;
export const EATERY_DOMAIN_DEF: EateryDomain = 'none';
export type FilterEnum_EateryDomain = ({ opt:("eq"),value:EateryDomain, })|({ opt:("ne"),value:EateryDomain, })|({ opt:("in"),value:((EateryDomain[])), })|({ opt:("not_in"),value:((EateryDomain[])), });
export const FILTER_ENUM__EATERY_DOMAIN_DEF: FilterEnum_EateryDomain = ({opt:('eq'),value:EATERY_DOMAIN_DEF,});
export type EateryDecor = "none"|"bookish"|"cultural"|"traditional"|"fantasy"|"musical"|"nature"|"game"|"minimal"|"modern"|"luxury"|"street";
export const EATERY_DECOR = ["none","bookish","cultural","traditional","fantasy","musical","nature","game","minimal","modern","luxury","street",] as const;
export function is_eatery_decor(value: string): value is EateryDecor {
    return EATERY_DECOR.includes(value as EateryDecor)
}
;
export const EATERY_DECOR_DEF: EateryDecor = 'none';
export type FilterEnum_EateryDecor = ({ opt:("eq"),value:EateryDecor, })|({ opt:("ne"),value:EateryDecor, })|({ opt:("in"),value:((EateryDecor[])), })|({ opt:("not_in"),value:((EateryDecor[])), });
export const FILTER_ENUM__EATERY_DECOR_DEF: FilterEnum_EateryDecor = ({opt:('eq'),value:EATERY_DECOR_DEF,});
export type EateryAudience = "none"|"family"|"friends"|"couples"|"business";
export const EATERY_AUDIENCE = ["none","family","friends","couples","business",] as const;
export function is_eatery_audience(value: string): value is EateryAudience {
    return EATERY_AUDIENCE.includes(value as EateryAudience)
}
;
export const EATERY_AUDIENCE_DEF: EateryAudience = 'none';
export type FilterEnum_EateryAudience = ({ opt:("eq"),value:EateryAudience, })|({ opt:("ne"),value:EateryAudience, })|({ opt:("in"),value:((EateryAudience[])), })|({ opt:("not_in"),value:((EateryAudience[])), });
export const FILTER_ENUM__EATERY_AUDIENCE_DEF: FilterEnum_EateryAudience = ({opt:('eq'),value:EATERY_AUDIENCE_DEF,});
export type EateryGenderSpecific = "none"|"male"|"female";
export const EATERY_GENDER_SPECIFIC = ["none","male","female",] as const;
export function is_eatery_gender_specific(value: string): value is EateryGenderSpecific {
    return EATERY_GENDER_SPECIFIC.includes(value as EateryGenderSpecific)
}
;
export const EATERY_GENDER_SPECIFIC_DEF: EateryGenderSpecific = 'none';
export type FilterEnum_EateryGenderSpecific = ({ opt:("eq"),value:EateryGenderSpecific, })|({ opt:("ne"),value:EateryGenderSpecific, })|({ opt:("in"),value:((EateryGenderSpecific[])), })|({ opt:("not_in"),value:((EateryGenderSpecific[])), });
export const FILTER_ENUM__EATERY_GENDER_SPECIFIC_DEF: FilterEnum_EateryGenderSpecific = ({opt:('eq'),value:EATERY_GENDER_SPECIFIC_DEF,});
export type FilterEnum_Gene = ({ opt:("eq"),value:Gene, })|({ opt:("ne"),value:Gene, })|({ opt:("in"),value:((Gene[])), })|({ opt:("not_in"),value:((Gene[])), });
export const FILTER_ENUM__GENE_DEF: FilterEnum_Gene = ({opt:('eq'),value:GENE_DEF,});
export type EateryEvent = "none"|"halloween"|"christmas"|"yalda"|"norooz"|"valentine"|"scarlet_wednesday"|"fifa_world_cup";
export const EATERY_EVENT = ["none","halloween","christmas","yalda","norooz","valentine","scarlet_wednesday","fifa_world_cup",] as const;
export function is_eatery_event(value: string): value is EateryEvent {
    return EATERY_EVENT.includes(value as EateryEvent)
}
;
export const EATERY_EVENT_DEF: EateryEvent = 'none';
export type FilterEnum_EateryEvent = ({ opt:("eq"),value:EateryEvent, })|({ opt:("ne"),value:EateryEvent, })|({ opt:("in"),value:((EateryEvent[])), })|({ opt:("not_in"),value:((EateryEvent[])), });
export const FILTER_ENUM__EATERY_EVENT_DEF: FilterEnum_EateryEvent = ({opt:('eq'),value:EATERY_EVENT_DEF,});
export type FilterNumber_u64 = ({ opt:("gt"),value:(number), })|({ opt:("lt"),value:(number), })|({ opt:("eq"),value:(number), })|({ opt:("ne"),value:(number), })|({ opt:("in"),value:(((number)[])), })|({ opt:("not_in"),value:(((number)[])), });
export const FILTER_NUMBER_U64_DEF: FilterNumber_u64 = ({opt:('gt'),value:(0),});
export type FilterNumber_u16 = ({ opt:("gt"),value:(number), })|({ opt:("lt"),value:(number), })|({ opt:("eq"),value:(number), })|({ opt:("ne"),value:(number), })|({ opt:("in"),value:(((number)[])), })|({ opt:("not_in"),value:(((number)[])), });
export const FILTER_NUMBER_U16_DEF: FilterNumber_u16 = ({opt:('gt'),value:(0),});
export type FilterNumber_u8 = ({ opt:("gt"),value:(number), })|({ opt:("lt"),value:(number), })|({ opt:("eq"),value:(number), })|({ opt:("ne"),value:(number), })|({ opt:("in"),value:(((number)[])), })|({ opt:("not_in"),value:(((number)[])), });
export const FILTER_NUMBER_U8_DEF: FilterNumber_u8 = ({opt:('gt'),value:(0),});
export type String = string;
export const STRING_DEF: String = '';
export type FilterEnum_String = ({ opt:("eq"),value:String, })|({ opt:("ne"),value:String, })|({ opt:("in"),value:((String[])), })|({ opt:("not_in"),value:((String[])), });
export const FILTER_ENUM__STRING_DEF: FilterEnum_String = ({opt:('eq'),value:STRING_DEF,});
export type AdminEateryFilter = ({ kind:("tags"),value:EateryTagsInput, })|({ kind:("flags"),value:EateryFlagsInput, })|({ kind:("has_address"),value:(boolean), })|({ kind:("has_photo"),value:(boolean), })|({ kind:("has_trailer"),value:(boolean), })|({ kind:("has_active_staff"),value:(boolean), })|({ kind:("eatery_group"),value:FilterEnum_EateryGroup, })|({ kind:("domain"),value:FilterEnum_EateryDomain, })|({ kind:("decor"),value:FilterEnum_EateryDecor, })|({ kind:("audience"),value:FilterEnum_EateryAudience, })|({ kind:("gender_specific"),value:FilterEnum_EateryGenderSpecific, })|({ kind:("gene"),value:FilterEnum_Gene, })|({ kind:("event"),value:FilterEnum_EateryEvent, })|({ kind:("stars"),value:FilterNumber_f32, })|({ kind:("review_count"),value:FilterNumber_u64, })|({ kind:("verified_until"),value:FilterNumber_u64, })|({ kind:("last_activity"),value:FilterNumber_u64, })|({ kind:("score"),value:FilterNumber_f32, })|({ kind:("quality_score"),value:FilterNumber_f32, })|({ kind:("price_range_min"),value:FilterNumber_f64, })|({ kind:("price_range_max"),value:FilterNumber_f64, })|({ kind:("price_range_avg"),value:FilterNumber_f64, })|({ kind:("dish_count"),value:FilterNumber_u16, })|({ kind:("geo_radius"),value:GeoRadius, })|({ kind:("discount_percentage"),value:FilterNumber_u8, })|({ kind:("discount_expires_at"),value:FilterNumber_u64, })|({ kind:("sector_nation"),value:FilterEnum_String, })|({ kind:("sector_region"),value:FilterEnum_String, })|({ kind:("sector_canton"),value:FilterEnum_String, })|({ kind:("or"), })|({ kind:("and"), })|({ kind:("group"),value:((AdminEateryFilter[])), });
export const ADMIN_EATERY_FILTER_DEF: AdminEateryFilter = ({kind:('tags'),value:EATERY_TAGS_INPUT_DEF,});
export type CabbageOrigin = { cabbage_count:(number),eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,pond_count:(number),tail:Gene, };
export const CABBAGE_ORIGIN_DEF: CabbageOrigin = {cabbage_count:(0),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,pond_count:(0),tail:GENE_DEF,};
export type StarRate = { food:([ (number),(number),(number),(number),(number), ]),service:([ (number),(number),(number),(number),(number), ]),vibe:([ (number),(number),(number),(number),(number), ]), };
export const STAR_RATE_DEF: StarRate = {food:([(0),(0),(0),(0),(0),]),service:([(0),(0),(0),(0),(0),]),vibe:([(0),(0),(0),(0),(0),]),};
export type CompactGene = ((string) | null);
export const COMPACT_GENE_DEF: CompactGene = null;
export type EateryFlagsInfo = { has_content_in_1_month:(boolean),has_content_in_1_year:(boolean),has_content_in_3_months:(boolean),has_employee:(boolean),holds_birthday_parties:(boolean),is_24_7:(boolean),is_address_custom:(boolean),is_address_google:(boolean),is_address_parsimap:(boolean),is_brand:(boolean),is_close:(boolean),is_famous:(boolean),is_for_guest:(boolean),is_hidden:(boolean),is_low_quality:(boolean),is_perma_close:(boolean),is_tender:(boolean),is_tourist_attraction:(boolean),is_unique:(boolean),trailer_m3u8_rendered:(boolean),trailer_preview_rendered:(boolean), };
export const EATERY_FLAGS_INFO_DEF: EateryFlagsInfo = {has_content_in_1_month:(false),has_content_in_1_year:(false),has_content_in_3_months:(false),has_employee:(false),holds_birthday_parties:(false),is_24_7:(false),is_address_custom:(false),is_address_google:(false),is_address_parsimap:(false),is_brand:(false),is_close:(false),is_famous:(false),is_for_guest:(false),is_hidden:(false),is_low_quality:(false),is_perma_close:(false),is_tender:(false),is_tourist_attraction:(false),is_unique:(false),trailer_m3u8_rendered:(false),trailer_preview_rendered:(false),};
export type SectorInfo = { canton_id:(string),canton_name:(string),nation_id:(string),nation_name:(string),region_id:(string),region_name:(string), };
export const SECTOR_INFO_DEF: SectorInfo = {canton_id:(''),canton_name:(''),nation_id:(''),nation_name:(''),region_id:(''),region_name:(''),};
export type LocationInfo = { altitude:(number),latitude:(number),level:(number),longitude:(number),sector:SectorInfo, };
export const LOCATION_INFO_DEF: LocationInfo = {altitude:(0),latitude:(0),level:(0),longitude:(0),sector:SECTOR_INFO_DEF,};
export type DishOrigin = { dish_count:(number),eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,pond_count:(number),tail:Gene, };
export const DISH_ORIGIN_DEF: DishOrigin = {dish_count:(0),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,pond_count:(0),tail:GENE_DEF,};
export type PriceRange = { avg:(number),max:(number),min:(number), };
export const PRICE_RANGE_DEF: PriceRange = {avg:(0),max:(0),min:(0),};
export type ReviewOrigin = { eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,pond_count:(number),review_count:(number),tail:Gene, };
export const REVIEW_ORIGIN_DEF: ReviewOrigin = {eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,pond_count:(0),review_count:(0),tail:GENE_DEF,};
export type EateryTagsInfo = { allows_long_stays:Flag2,can_smoke_indoor:Flag2,has_breakfast:Flag2,has_delivery:Flag2,has_dine_in:Flag2,has_dinner:Flag2,has_dj:Flag2,has_drive_through:Flag2,has_good_view:Flag2,has_halal_food:Flag2,has_indoor_seating:Flag2,has_live_music:Flag2,has_lunch:Flag2,has_outdoor_seating:Flag2,has_parking:Flag2,has_private_dining:Flag2,has_qelyan:Flag2,has_reservations:Flag2,has_self_service:Flag2,has_solo_dining:Flag2,has_takeaway:Flag2,has_toilet:Flag2,has_tv:Flag2,has_vegan_food:Flag2,has_vegetarian_food:Flag2,has_wifi:Flag2,is_photogenic:Flag2,is_suitable_for_children:Flag2,is_suitable_for_large_groups:Flag2,is_suitable_for_pets:Flag2,is_suitable_for_reading:Flag2,is_suitable_for_social_working:Flag2,is_tourist_friendly:Flag2,is_wheelchair_accessible:Flag2, };
export const EATERY_TAGS_INFO_DEF: EateryTagsInfo = {allows_long_stays:FLAG2_DEF,can_smoke_indoor:FLAG2_DEF,has_breakfast:FLAG2_DEF,has_delivery:FLAG2_DEF,has_dine_in:FLAG2_DEF,has_dinner:FLAG2_DEF,has_dj:FLAG2_DEF,has_drive_through:FLAG2_DEF,has_good_view:FLAG2_DEF,has_halal_food:FLAG2_DEF,has_indoor_seating:FLAG2_DEF,has_live_music:FLAG2_DEF,has_lunch:FLAG2_DEF,has_outdoor_seating:FLAG2_DEF,has_parking:FLAG2_DEF,has_private_dining:FLAG2_DEF,has_qelyan:FLAG2_DEF,has_reservations:FLAG2_DEF,has_self_service:FLAG2_DEF,has_solo_dining:FLAG2_DEF,has_takeaway:FLAG2_DEF,has_toilet:FLAG2_DEF,has_tv:FLAG2_DEF,has_vegan_food:FLAG2_DEF,has_vegetarian_food:FLAG2_DEF,has_wifi:FLAG2_DEF,is_photogenic:FLAG2_DEF,is_suitable_for_children:FLAG2_DEF,is_suitable_for_large_groups:FLAG2_DEF,is_suitable_for_pets:FLAG2_DEF,is_suitable_for_reading:FLAG2_DEF,is_suitable_for_social_working:FLAG2_DEF,is_tourist_friendly:FLAG2_DEF,is_wheelchair_accessible:FLAG2_DEF,};
export type SeedPhone = { cc:(number),phone:ShahString, };
export const SEED_PHONE_DEF: SeedPhone = {cc:(0),phone:SHAH_STRING_DEF,};
export type EateryImpression = { count:(number),impression:(number), };
export const EATERY_IMPRESSION_DEF: EateryImpression = {count:(0),impression:(0),};
export type EateryDiscountFlags = { is_active:(boolean), };
export const EATERY_DISCOUNT_FLAGS_DEF: EateryDiscountFlags = {is_active:(false),};
export type EateryDiscount = { available:(number),expires_at:(number),flags:EateryDiscountFlags,max_amount:(number),min_order:(number),percentage:(number),rob_price:(number),starts_at:(number), };
export const EATERY_DISCOUNT_DEF: EateryDiscount = {available:(0),expires_at:(0),flags:EATERY_DISCOUNT_FLAGS_DEF,max_amount:(0),min_order:(0),percentage:(0),rob_price:(0),starts_at:(0),};
export type ShahOrigin = { entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,item_count:(number),pond_count:(number),tail:Gene, };
export const SHAH_ORIGIN_DEF: ShahOrigin = {entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,item_count:(0),pond_count:(0),tail:GENE_DEF,};
export type ShahBuckle = { belt_count:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,tail:Gene, };
export const SHAH_BUCKLE_DEF: ShahBuckle = {belt_count:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,tail:GENE_DEF,};
export type ShahEnum_u8_EaterySubscriptionKind = "free"|"vip";
export const SHAH_ENUM_U8__EATERY_SUBSCRIPTION_KIND = ["free","vip",] as const;
export function is_shah_enum_u8__eatery_subscription_kind(value: string): value is ShahEnum_u8_EaterySubscriptionKind {
    return SHAH_ENUM_U8__EATERY_SUBSCRIPTION_KIND.includes(value as ShahEnum_u8_EaterySubscriptionKind)
}
;
export const SHAH_ENUM_U8__EATERY_SUBSCRIPTION_KIND_DEF: ShahEnum_u8_EaterySubscriptionKind = 'free';
export type EaterySubscription = { expires_at:(number),kind:ShahEnum_u8_EaterySubscriptionKind, };
export const EATERY_SUBSCRIPTION_DEF: EaterySubscription = {expires_at:(0),kind:SHAH_ENUM_U8__EATERY_SUBSCRIPTION_KIND_DEF,};
export type EateryTipBuckle = { eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,read_count:(number),tail:Gene,tips_count:(number), };
export const EATERY_TIP_BUCKLE_DEF: EateryTipBuckle = {eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,read_count:(0),tail:GENE_DEF,tips_count:(0),};
export type EateryVerificationRequest = { issue:Gene,response_at:(number),user:Gene, };
export const EATERY_VERIFICATION_REQUEST_DEF: EateryVerificationRequest = {issue:GENE_DEF,response_at:(0),user:GENE_DEF,};
export type EateryVerificationRequestStatus = "none"|"pending"|"resolved"|"rejected";
export const EATERY_VERIFICATION_REQUEST_STATUS = ["none","pending","resolved","rejected",] as const;
export function is_eatery_verification_request_status(value: string): value is EateryVerificationRequestStatus {
    return EATERY_VERIFICATION_REQUEST_STATUS.includes(value as EateryVerificationRequestStatus)
}
;
export const EATERY_VERIFICATION_REQUEST_STATUS_DEF: EateryVerificationRequestStatus = 'none';
export type EateryWallet = { irr:(number),rob:(number), };
export const EATERY_WALLET_DEF: EateryWallet = {irr:(0),rob:(0),};
export type AdminWarehouseInfo = { discount:EateryDiscount,discounts_active?:((ShahOrigin | null)),discounts_applied?:((ShahOrigin | null)),discounts_holding?:((ShahOrigin | null)),employees?:((ShahBuckle | null)),experience:(number),gene:Gene,recruit_links?:((ShahOrigin | null)),subscription:EaterySubscription,tips?:((EateryTipBuckle | null)),transactions?:((ShahOrigin | null)),verification_request:EateryVerificationRequest,verification_request_status:EateryVerificationRequestStatus,wallet:EateryWallet, };
export const ADMIN_WAREHOUSE_INFO_DEF: AdminWarehouseInfo = {discount:EATERY_DISCOUNT_DEF,experience:(0),gene:GENE_DEF,subscription:EATERY_SUBSCRIPTION_DEF,verification_request:EATERY_VERIFICATION_REQUEST_DEF,verification_request_status:EATERY_VERIFICATION_REQUEST_STATUS_DEF,wallet:EATERY_WALLET_DEF,};
export type AdminEateryInfo = { address:(string),alias:(string),audience:EateryAudience,best_dish:([ Gene,Gene,Gene,Gene,Gene, ]),cabbage?:((CabbageOrigin | null)),cabbage_stars:StarRate,calc_zoom:(number),compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,embers:Gene,entity_flags:EntityFlags,event:EateryEvent,extra:Gene,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,impressions:Gene,last_activity:(number),location:LocationInfo,menu?:((DishOrigin | null)),name:(string),opening_hours?:(((string) | null)),photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),popular_times?:(((string) | null)),price_range:PriceRange,priority:(number),quality_score:(number),review?:((ReviewOrigin | null)),review_count:(number),score:(number),stars:(number),stars_rate:StarRate,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,updated_at:(number),verified_until:(number),warehouse?:((AdminWarehouseInfo | null)),zoom:(number), };
export const ADMIN_EATERY_INFO_DEF: AdminEateryInfo = {address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,best_dish:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),cabbage_stars:STAR_RATE_DEF,calc_zoom:(0),compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,embers:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,event:EATERY_EVENT_DEF,extra:GENE_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,impressions:GENE_DEF,last_activity:(0),location:LOCATION_INFO_DEF,name:(''),photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,priority:(0),quality_score:(0),review_count:(0),score:(0),stars:(0),stars_rate:STAR_RATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,updated_at:(0),verified_until:(0),zoom:(0),};
export type AdminEateryItem = { address:(string),alias:(string),audience:EateryAudience,best_dish:([ Gene,Gene,Gene,Gene,Gene, ]),cabbage:Gene,cabbage_stars:StarRate,calc_zoom:(number),compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,embers:Gene,entity_flags:EntityFlags,event:EateryEvent,extra:Gene,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,impressions:Gene,last_activity:(number),location:LocationInfo,menu:Gene,name:(string),opening_hours?:(((string) | null)),photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),popular_times?:(((string) | null)),price_range:PriceRange,priority:(number),quality_score:(number),review:Gene,review_count:(number),score:(number),stars:(number),stars_rate:StarRate,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,updated_at:(number),verified_until:(number),warehouse:Gene,zoom:(number), };
export const ADMIN_EATERY_ITEM_DEF: AdminEateryItem = {address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,best_dish:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),cabbage:GENE_DEF,cabbage_stars:STAR_RATE_DEF,calc_zoom:(0),compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,embers:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,event:EATERY_EVENT_DEF,extra:GENE_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,impressions:GENE_DEF,last_activity:(0),location:LOCATION_INFO_DEF,menu:GENE_DEF,name:(''),photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,priority:(0),quality_score:(0),review:GENE_DEF,review_count:(0),score:(0),stars:(0),stars_rate:STAR_RATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,updated_at:(0),verified_until:(0),warehouse:GENE_DEF,zoom:(0),};
export type AdminEateryReorderPhotosBody = { photos:([ ((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)), ]), };
export const ADMIN_EATERY_REORDER_PHOTOS_BODY_DEF: AdminEateryReorderPhotosBody = {photos:([(null),(null),(null),(null),(null),(null),(null),]),};
export type EateryCard = { address:(string),audience:EateryAudience,compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,gene:Gene,group:EateryGroup,location:LocationInfo,name:(string),photo:Gene,review_count:(number),stars:(number),tables:(number),verified_until:(number), };
export const EATERY_CARD_DEF: EateryCard = {address:(''),audience:EATERY_AUDIENCE_DEF,compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,location:LOCATION_INFO_DEF,name:(''),photo:GENE_DEF,review_count:(0),stars:(0),tables:(0),verified_until:(0),};
export type ReviewState = "default"|"golem_censored"|"golem_verified"|"staff_censored"|"staff_verified"|"admin_censored"|"admin_verified"|"user_deleted";
export const REVIEW_STATE = ["default","golem_censored","golem_verified","staff_censored","staff_verified","admin_censored","admin_verified","user_deleted",] as const;
export function is_review_state(value: string): value is ReviewState {
    return REVIEW_STATE.includes(value as ReviewState)
}
;
export const REVIEW_STATE_DEF: ReviewState = 'default';
export type UserFlags = { has_password:(boolean),is_banned:(boolean),is_invited:(boolean),is_jailed:(boolean), };
export const USER_FLAGS_DEF: UserFlags = {has_password:(false),is_banned:(false),is_invited:(false),is_jailed:(false),};
export type UserCard = { entity_flags:EntityFlags,flags:UserFlags,gene:Gene,growth:(number),name:ShahString,online_at:(number),photo:Gene,username:ShahString, };
export const USER_CARD_DEF: UserCard = {entity_flags:ENTITY_FLAGS_DEF,flags:USER_FLAGS_DEF,gene:GENE_DEF,growth:(0),name:SHAH_STRING_DEF,online_at:(0),photo:GENE_DEF,username:SHAH_STRING_DEF,};
export type AdminEateryReviewFull = { detail?:(((string) | null)),eatery?:((EateryCard | null)),gene:Gene,issue:Gene,pond:Gene,star_food:(number),star_service:(number),star_vibe:(number),state:ReviewState,summary:(string),timestamp:(number),user?:((UserCard | null)),user_review:Gene, };
export const ADMIN_EATERY_REVIEW_FULL_DEF: AdminEateryReviewFull = {gene:GENE_DEF,issue:GENE_DEF,pond:GENE_DEF,star_food:(0),star_service:(0),star_vibe:(0),state:REVIEW_STATE_DEF,summary:(''),timestamp:(0),user_review:GENE_DEF,};
export type EateryReviewItem = { detail:Gene,eatery:Gene,entity_flags:EntityFlags,gene:Gene,issue:Gene,pond:Gene,star_food:(number),star_service:(number),star_vibe:(number),state:ReviewState,summary:(string),timestamp:(number),user:Gene,user_review:Gene, };
export const EATERY_REVIEW_ITEM_DEF: EateryReviewItem = {detail:GENE_DEF,eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,issue:GENE_DEF,pond:GENE_DEF,star_food:(0),star_service:(0),star_vibe:(0),state:REVIEW_STATE_DEF,summary:(''),timestamp:(0),user:GENE_DEF,user_review:GENE_DEF,};
export type AdminEateryReviewList = { list:((EateryReviewItem[])),pond:ShahPond, };
export const ADMIN_EATERY_REVIEW_LIST_DEF: AdminEateryReviewList = {list:([]),pond:SHAH_POND_DEF,};
export type EaterySort = ({ kind:("is_unique"), })|({ kind:("is_brand"), })|({ kind:("is_tender"), })|({ kind:("is_famous"), })|({ kind:("is_tourist_attraction"), })|({ kind:("review_count"), })|({ kind:("verified_until"), })|({ kind:("last_activity"), })|({ kind:("star_sum"), })|({ kind:("stars"), })|({ kind:("score"), })|({ kind:("quality_score"), })|({ kind:("price_range_min"), })|({ kind:("price_range_max"), })|({ kind:("price_range_avg"), })|({ kind:("dish_count"), })|({ kind:("geo_point"),lat:(number),lng:(number), })|({ kind:("random_id"), });
export const EATERY_SORT_DEF: EaterySort = ({kind:('is_unique'),});
export type EaterySortItem = { by:EaterySort,order?:((SortOrder | null)), };
export const EATERY_SORT_ITEM_DEF: EaterySortItem = {by:EATERY_SORT_DEF,};
export type AdminEaterySearchBody = { filters:((AdminEateryFilter[])),name:(string),sort:((EaterySortItem[])), };
export const ADMIN_EATERY_SEARCH_BODY_DEF: AdminEaterySearchBody = {filters:([]),name:(''),sort:([]),};
export type AdminEaterySetTrailer = { video:(File), };
export const ADMIN_EATERY_SET_TRAILER_DEF: AdminEaterySetTrailer = {video:(new File([], '')),};
export type ShahEnum_u16_RecordMime = "unknown"|"app_wasm"|"app_elf"|"app_exe"|"app_java"|"app_bc"|"app_mach"|"app_dex"|"app_dey"|"app_pem"|"book_epub"|"book_mobi"|"image_webp"|"image_jpeg"|"image_jp2"|"image_png"|"image_gif"|"image_cr2"|"image_tiff"|"image_bmp"|"image_jxr"|"image_psd"|"image_ico"|"image_heif"|"image_avif"|"image_jxl"|"image_ora"|"image_djvu"|"video_mp4"|"video_m4v"|"video_mkv"|"video_webm"|"video_mov"|"video_avi"|"video_wmv"|"video_mpg"|"video_flv"|"audio_opus"|"audio_midi"|"audio_mp3"|"audio_m4a"|"audio_ogg"|"audio_flac"|"audio_wav"|"audio_amr"|"audio_aac"|"audio_aiff"|"audio_dsf"|"audio_ape"|"font_ttf"|"font_woff"|"doc_open_text"|"doc_open_spreadsheet"|"doc_open_presentation"|"doc_ms_word"|"doc_word"|"doc_ms_excel"|"doc_excel"|"doc_ms_powerpoint"|"doc_powerpoint"|"archive_zip"|"archive_tar"|"archive_par2"|"archive_rar"|"archive_gzip"|"archive_bz2"|"archive_bz3"|"archive_zip7"|"archive_xz"|"archive_pdf"|"archive_swf"|"archive_rtf"|"archive_eot"|"archive_ps"|"archive_sqlite"|"archive_nes"|"archive_crx"|"archive_cab"|"archive_deb"|"archive_ar"|"archive_z"|"archive_lz"|"archive_rpm"|"archive_dcm"|"archive_zst"|"archive_lz4"|"archive_msi"|"archive_cpio"|"text_html"|"text_xml"|"text_sh"|"text_plain";
export const SHAH_ENUM_U16__RECORD_MIME = ["unknown","app_wasm","app_elf","app_exe","app_java","app_bc","app_mach","app_dex","app_dey","app_pem","book_epub","book_mobi","image_webp","image_jpeg","image_jp2","image_png","image_gif","image_cr2","image_tiff","image_bmp","image_jxr","image_psd","image_ico","image_heif","image_avif","image_jxl","image_ora","image_djvu","video_mp4","video_m4v","video_mkv","video_webm","video_mov","video_avi","video_wmv","video_mpg","video_flv","audio_opus","audio_midi","audio_mp3","audio_m4a","audio_ogg","audio_flac","audio_wav","audio_amr","audio_aac","audio_aiff","audio_dsf","audio_ape","font_ttf","font_woff","doc_open_text","doc_open_spreadsheet","doc_open_presentation","doc_ms_word","doc_word","doc_ms_excel","doc_excel","doc_ms_powerpoint","doc_powerpoint","archive_zip","archive_tar","archive_par2","archive_rar","archive_gzip","archive_bz2","archive_bz3","archive_zip7","archive_xz","archive_pdf","archive_swf","archive_rtf","archive_eot","archive_ps","archive_sqlite","archive_nes","archive_crx","archive_cab","archive_deb","archive_ar","archive_z","archive_lz","archive_rpm","archive_dcm","archive_zst","archive_lz4","archive_msi","archive_cpio","text_html","text_xml","text_sh","text_plain",] as const;
export function is_shah_enum_u16__record_mime(value: string): value is ShahEnum_u16_RecordMime {
    return SHAH_ENUM_U16__RECORD_MIME.includes(value as ShahEnum_u16_RecordMime)
}
;
export const SHAH_ENUM_U16__RECORD_MIME_DEF: ShahEnum_u16_RecordMime = 'unknown';
export type ShahEnum_u8_RecordUsage = "unknown"|"user_photo"|"eatery_photos"|"dish_photos"|"loose"|"feedback"|"suggest"|"suggest_menu"|"suggest_dish"|"eatery_trailer"|"topic_voice"|"topic_media"|"issue_request_eatery_ownership"|"topic_document";
export const SHAH_ENUM_U8__RECORD_USAGE = ["unknown","user_photo","eatery_photos","dish_photos","loose","feedback","suggest","suggest_menu","suggest_dish","eatery_trailer","topic_voice","topic_media","issue_request_eatery_ownership","topic_document",] as const;
export function is_shah_enum_u8__record_usage(value: string): value is ShahEnum_u8_RecordUsage {
    return SHAH_ENUM_U8__RECORD_USAGE.includes(value as ShahEnum_u8_RecordUsage)
}
;
export const SHAH_ENUM_U8__RECORD_USAGE_DEF: ShahEnum_u8_RecordUsage = 'unknown';
export type Record = { checksum:(string),created_at:(number),duration:(number),entity_flags:EntityFlags,file_timestamp:(number),gene:Gene,growth:(number),height:(number),issue:Gene,latitude:(number),longitude:(number),mime:ShahEnum_u16_RecordMime,name:ShahString,server:(number),size:(number),updated_at:(number),usage:ShahEnum_u8_RecordUsage,width:(number), };
export const RECORD_DEF: Record = {checksum:(''),created_at:(0),duration:(0),entity_flags:ENTITY_FLAGS_DEF,file_timestamp:(0),gene:GENE_DEF,growth:(0),height:(0),issue:GENE_DEF,latitude:(0),longitude:(0),mime:SHAH_ENUM_U16__RECORD_MIME_DEF,name:SHAH_STRING_DEF,server:(0),size:(0),updated_at:(0),usage:SHAH_ENUM_U8__RECORD_USAGE_DEF,width:(0),};
export type EateryTrailerRenderTask = { eatery:Gene,frames:(number),has_audio:(boolean),height:(number),progress:(number),record:Gene,width:(number), };
export const EATERY_TRAILER_RENDER_TASK_DEF: EateryTrailerRenderTask = {eatery:GENE_DEF,frames:(0),has_audio:(false),height:(0),progress:(0),record:GENE_DEF,width:(0),};
export type EateryTrailerPreviewTask = { duration:(number),eatery:Gene,fps:(number),frames:(number),height:(number),progress:(number),record:Gene,width:(number), };
export const EATERY_TRAILER_PREVIEW_TASK_DEF: EateryTrailerPreviewTask = {duration:(0),eatery:GENE_DEF,fps:(0),frames:(0),height:(0),progress:(0),record:GENE_DEF,width:(0),};
export type SequentialTaskData = (EateryTrailerRenderTask&({ kind:("eatery_trailer_render"), }))|(EateryTrailerPreviewTask&({ kind:("eatery_trailer_preview"), }));
export const SEQUENTIAL_TASK_DATA_DEF: SequentialTaskData = ({...EATERY_TRAILER_RENDER_TASK_DEF,...({kind:('eatery_trailer_render'),}),});
export type SeedError = "unknown"|"bad_request"|"forbidden"|"bad_auth"|"not_found"|"server_error"|"database_error"|"change_while_reordering"|"index_out_of_bounds"|"invalid_image"|"encode_webp_error"|"invalid_ipv4"|"end_point_under_maintenance"|"clone_from_self"|"rate_limited"|"password_mismatch"|"clone_in_progress"|"bad_phone"|"user_banned"|"buckle_gene_is_none"|"golem_permission"|"golem_banned"|"invalid_state_unknown_kind"|"cannot_change_kind"|"image_download_failed"|"detail_too_long"|"not_draft"|"not_pending"|"too_many_dish"|"duplicate_khabar"|"not_for_guest"|"bad_username"|"username_in_use"|"associated_eateries_full"|"permission_denied"|"not_associated"|"unknown_impression"|"subscription_limit_reached"|"insufficient_money"|"insufficient_rob"|"payment_processor_failed"|"already_exists"|"expired"|"limit_reached"|"topic_record_media_mismatch"|"associated_topics_full"|"member_list_full"|"not_member"|"saved_full"|"empty_message"|"request_pending"|"invalid_task_id"|"invalid_audio"|"invalid_video"|"video_conversion"|"video_too_short"|"video_too_long"|"bad_video_size"|"bad_feedback_status"|"rob_not_available"|"storage_limit"|"wheat"|"already_reported"|"not_invitable"|"no_discount_available"|"not_started"|"not_appliable"|"invalid_code"|"bad_compact_gene"|"incompatible_domain"|"spice_build"|"preference_too_big"|"spark_target_unknown"|"zstd_compress_failed"|"bad_kind_unknown";
export const SEED_ERROR = ["unknown","bad_request","forbidden","bad_auth","not_found","server_error","database_error","change_while_reordering","index_out_of_bounds","invalid_image","encode_webp_error","invalid_ipv4","end_point_under_maintenance","clone_from_self","rate_limited","password_mismatch","clone_in_progress","bad_phone","user_banned","buckle_gene_is_none","golem_permission","golem_banned","invalid_state_unknown_kind","cannot_change_kind","image_download_failed","detail_too_long","not_draft","not_pending","too_many_dish","duplicate_khabar","not_for_guest","bad_username","username_in_use","associated_eateries_full","permission_denied","not_associated","unknown_impression","subscription_limit_reached","insufficient_money","insufficient_rob","payment_processor_failed","already_exists","expired","limit_reached","topic_record_media_mismatch","associated_topics_full","member_list_full","not_member","saved_full","empty_message","request_pending","invalid_task_id","invalid_audio","invalid_video","video_conversion","video_too_short","video_too_long","bad_video_size","bad_feedback_status","rob_not_available","storage_limit","wheat","already_reported","not_invitable","no_discount_available","not_started","not_appliable","invalid_code","bad_compact_gene","incompatible_domain","spice_build","preference_too_big","spark_target_unknown","zstd_compress_failed","bad_kind_unknown",] as const;
export function is_seed_error(value: string): value is SeedError {
    return SEED_ERROR.includes(value as SeedError)
}
;
export const SEED_ERROR_DEF: SeedError = 'unknown';
export type TaskId = string;
export const TASK_ID_DEF: TaskId = '';
export type SequentialTask = { abort:(boolean),created_at:(number),data:SequentialTaskData,done_at:(number),error?:((SeedError | null)),id:TaskId,start_at:(number), };
export const SEQUENTIAL_TASK_DEF: SequentialTask = {abort:(false),created_at:(0),data:SEQUENTIAL_TASK_DATA_DEF,done_at:(0),id:TASK_ID_DEF,start_at:(0),};
export type AdminEaterySetTrailerResult = { record:Record,tasks:((SequentialTask[])), };
export const ADMIN_EATERY_SET_TRAILER_RESULT_DEF: AdminEaterySetTrailerResult = {record:RECORD_DEF,tasks:([]),};
export type OpenDuration = { close:(number),open:(number), };
export const OPEN_DURATION_DEF: OpenDuration = {close:(0),open:(0),};
export type AdminEateryUpdateInfoBody = { address?:(((string) | null)),alias?:(((string) | null)),audience?:((EateryAudience | null)),best_dish?:((([ ((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)), ]) | null)),decor?:((EateryDecor | null)),domain?:((EateryDomain | null)),event?:((EateryEvent | null)),flags?:((EateryFlagsInput | null)),gender_specific?:((EateryGenderSpecific | null)),group?:((EateryGroup | null)),name?:(((string) | null)),opening_hours?:((([ ((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])), ]) | null)),popular_times?:((([ (((number)[])),(((number)[])),(((number)[])),(((number)[])),(((number)[])),(((number)[])),(((number)[])), ]) | null)),tables?:(((number) | null)),tags?:((EateryTagsInput | null)),telephone?:((SeedPhone | null)),verified_until?:(((number) | null)), };
export const ADMIN_EATERY_UPDATE_INFO_BODY_DEF: AdminEateryUpdateInfoBody = {};
export type LocationInput = { altitude:(number),latitude:(number),level:(number),longitude:(number), };
export const LOCATION_INPUT_DEF: LocationInput = {altitude:(0),latitude:(0),level:(0),longitude:(0),};
export type AdminEateryUpdateLocationBody = { location:LocationInput,zoom:(number), };
export const ADMIN_EATERY_UPDATE_LOCATION_BODY_DEF: AdminEateryUpdateLocationBody = {location:LOCATION_INPUT_DEF,zoom:(0),};
export type CropPercentage = { bottom:(number),left:(number),right:(number),top:(number), };
export const CROP_PERCENTAGE_DEF: CropPercentage = {bottom:(0),left:(0),right:(0),top:(0),};
export type SetWheatPhoto = { crop?:((CropPercentage | null)),pdx:(number),url:(string), };
export const SET_WHEAT_PHOTO_DEF: SetWheatPhoto = {pdx:(0),url:(''),};
export type AdminEateryWheatPhotosBody = { photos:((SetWheatPhoto[])), };
export const ADMIN_EATERY_WHEAT_PHOTOS_BODY_DEF: AdminEateryWheatPhotosBody = {photos:([]),};
export type AdminFeedbackChattingBody = { topic?:((Gene | null)), };
export const ADMIN_FEEDBACK_CHATTING_BODY_DEF: AdminFeedbackChattingBody = {};
export type AdminGiftRobBody = { amount:(number),from?:((Gene | null)),user:Gene, };
export const ADMIN_GIFT_ROB_BODY_DEF: AdminGiftRobBody = {amount:(0),user:GENE_DEF,};
export type IssueKey = "unknown"|"dense_area"|"censored_review"|"nsfw_photo"|"manual_merge"|"request_eatery_ownership"|"request_ticket"|"request_eatery_verification"|"eatery_report"|"eatery_review_report"|"eatery_cabbage_report"|"user_report";
export const ISSUE_KEY = ["unknown","dense_area","censored_review","nsfw_photo","manual_merge","request_eatery_ownership","request_ticket","request_eatery_verification","eatery_report","eatery_review_report","eatery_cabbage_report","user_report",] as const;
export function is_issue_key(value: string): value is IssueKey {
    return ISSUE_KEY.includes(value as IssueKey)
}
;
export const ISSUE_KEY_DEF: IssueKey = 'unknown';
export type AdminIssueTakeBody = { kind:IssueKey, };
export const ADMIN_ISSUE_TAKE_BODY_DEF: AdminIssueTakeBody = {kind:ISSUE_KEY_DEF,};
export type KhabarFlagsInfo = { is_hidden:(boolean), };
export const KHABAR_FLAGS_INFO_DEF: KhabarFlagsInfo = {is_hidden:(false),};
export type AdminKhabarInfo = KhabarKind&({ ef:EntityFlags,flags:KhabarFlagsInfo,gene:Gene,growth:(number),timestamp:(number), });
export const ADMIN_KHABAR_INFO_DEF: AdminKhabarInfo = {...KHABAR_KIND_DEF,...({ef:ENTITY_FLAGS_DEF,flags:KHABAR_FLAGS_INFO_DEF,gene:GENE_DEF,growth:(0),timestamp:(0),}),};
export type RecruitLink = { created_at:(number),eatery:Gene,entity_flags:EntityFlags,expires_at:(number),gene:Gene,growth:(number),limit:(number),perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),pond:Gene,recruited:(number), };
export const RECRUIT_LINK_DEF: RecruitLink = {created_at:(0),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,expires_at:(0),gene:GENE_DEF,growth:(0),limit:(0),perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),pond:GENE_DEF,recruited:(0),};
export type AdminRecruitLinkList = { list:((RecruitLink[])),pond:ShahPond, };
export const ADMIN_RECRUIT_LINK_LIST_DEF: AdminRecruitLinkList = {list:([]),pond:SHAH_POND_DEF,};
export type RobRewardReason = "unknown"|"suggest_add"|"suggest_edit"|"suggest_removal"|"friend_invite"|"joined_invite";
export const ROB_REWARD_REASON = ["unknown","suggest_add","suggest_edit","suggest_removal","friend_invite","joined_invite",] as const;
export function is_rob_reward_reason(value: string): value is RobRewardReason {
    return ROB_REWARD_REASON.includes(value as RobRewardReason)
}
;
export const ROB_REWARD_REASON_DEF: RobRewardReason = 'unknown';
export type AdminRobRewardBody = { amount:(number),reason:RobRewardReason,user:Gene, };
export const ADMIN_ROB_REWARD_BODY_DEF: AdminRobRewardBody = {amount:(0),reason:ROB_REWARD_REASON_DEF,user:GENE_DEF,};
export type AdminSetEmployeeBody = { perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),user:Gene, };
export const ADMIN_SET_EMPLOYEE_BODY_DEF: AdminSetEmployeeBody = {perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),user:GENE_DEF,};
export type AdminSetRobAvailableBody = { rob:(number), };
export const ADMIN_SET_ROB_AVAILABLE_BODY_DEF: AdminSetRobAvailableBody = {rob:(0),};
export type AdminSetRobIrrPriceBody = { irr:(number), };
export const ADMIN_SET_ROB_IRR_PRICE_BODY_DEF: AdminSetRobIrrPriceBody = {irr:(0),};
export type SuggestFlagsInfo = { holds_birthday_parties:(boolean),is_24_7:(boolean),is_brand:(boolean),is_famous:(boolean),is_perma_close:(boolean), };
export const SUGGEST_FLAGS_INFO_DEF: SuggestFlagsInfo = {holds_birthday_parties:(false),is_24_7:(false),is_brand:(false),is_famous:(false),is_perma_close:(false),};
export type SuggestIncorrectInfo = { incorrect_audience:(boolean),incorrect_best_dishes:(boolean),incorrect_decor:(boolean),incorrect_domain:(boolean),incorrect_group:(boolean),incorrect_menu:(boolean),incorrect_opening_hours:(boolean),incorrect_phone:(boolean),incorrect_photos:(boolean), };
export const SUGGEST_INCORRECT_INFO_DEF: SuggestIncorrectInfo = {incorrect_audience:(false),incorrect_best_dishes:(false),incorrect_decor:(false),incorrect_domain:(false),incorrect_group:(false),incorrect_menu:(false),incorrect_opening_hours:(false),incorrect_phone:(false),incorrect_photos:(false),};
export type SuggestKind = "unknown"|"add"|"edit"|"removal";
export const SUGGEST_KIND = ["unknown","add","edit","removal",] as const;
export function is_suggest_kind(value: string): value is SuggestKind {
    return SUGGEST_KIND.includes(value as SuggestKind)
}
;
export const SUGGEST_KIND_DEF: SuggestKind = 'unknown';
export type SuggestDishOrigin = { entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,item_count:(number),pond_count:(number),suggest:Gene,tail:Gene, };
export const SUGGEST_DISH_ORIGIN_DEF: SuggestDishOrigin = {entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,item_count:(0),pond_count:(0),suggest:GENE_DEF,tail:GENE_DEF,};
export type SuggestState = "unknown"|"draft"|"pending"|"approved"|"rejected";
export const SUGGEST_STATE = ["unknown","draft","pending","approved","rejected",] as const;
export function is_suggest_state(value: string): value is SuggestState {
    return SUGGEST_STATE.includes(value as SuggestState)
}
;
export const SUGGEST_STATE_DEF: SuggestState = 'unknown';
export type AdminSuggestInfo = { admin_pending:(number),audience:EateryAudience,best_dish:((Gene[])),buckle:Gene,created_at:(number),decor:EateryDecor,detail:Gene,domain:EateryDomain,eatery:Gene,ef:EntityFlags,flags:SuggestFlagsInfo,gene:Gene,group:EateryGroup,growth:(number),incorrect:SuggestIncorrectInfo,kind:SuggestKind,location:LocationInfo,menu?:((SuggestDishOrigin | null)),menu_photos:((Gene[])),name:(string),next:Gene,opening_hours?:(((string) | null)),past:Gene,pending_at:(number),photos:((Gene[])),rating:(number),resolve_at:(number),state:SuggestState,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,user:Gene,user_suggest:Gene, };
export const ADMIN_SUGGEST_INFO_DEF: AdminSuggestInfo = {admin_pending:(0),audience:EATERY_AUDIENCE_DEF,best_dish:([]),buckle:GENE_DEF,created_at:(0),decor:EATERY_DECOR_DEF,detail:GENE_DEF,domain:EATERY_DOMAIN_DEF,eatery:GENE_DEF,ef:ENTITY_FLAGS_DEF,flags:SUGGEST_FLAGS_INFO_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,growth:(0),incorrect:SUGGEST_INCORRECT_INFO_DEF,kind:SUGGEST_KIND_DEF,location:LOCATION_INFO_DEF,menu_photos:([]),name:(''),next:GENE_DEF,past:GENE_DEF,pending_at:(0),photos:([]),rating:(0),resolve_at:(0),state:SUGGEST_STATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,user:GENE_DEF,user_suggest:GENE_DEF,};
export type AdminTopicAddBody = { owner:Gene, };
export const ADMIN_TOPIC_ADD_BODY_DEF: AdminTopicAddBody = {owner:GENE_DEF,};
export type Count = { alive:(number),max_page:(number),size:(number),total:(number), };
export const COUNT_DEF: Count = {alive:(0),max_page:(0),size:(0),total:(0),};
export type AdminTopicCount = { messages:Count,topics:Count, };
export const ADMIN_TOPIC_COUNT_DEF: AdminTopicCount = {messages:COUNT_DEF,topics:COUNT_DEF,};
export type AdminTopicUpdateBody = { title?:(((string) | null)), };
export const ADMIN_TOPIC_UPDATE_BODY_DEF: AdminTopicUpdateBody = {};
export type ShahEnum_u16_TransactionState = "pending"|"success"|"failure";
export const SHAH_ENUM_U16__TRANSACTION_STATE = ["pending","success","failure",] as const;
export function is_shah_enum_u16__transaction_state(value: string): value is ShahEnum_u16_TransactionState {
    return SHAH_ENUM_U16__TRANSACTION_STATE.includes(value as ShahEnum_u16_TransactionState)
}
;
export const SHAH_ENUM_U16__TRANSACTION_STATE_DEF: ShahEnum_u16_TransactionState = 'pending';
export type UserTransactionZibal = { card:ShahString,irr:(number),ref_id:(number),state:ShahEnum_u16_TransactionState,track_id:(number),updated_at:(number), };
export const USER_TRANSACTION_ZIBAL_DEF: UserTransactionZibal = {card:SHAH_STRING_DEF,irr:(0),ref_id:(0),state:SHAH_ENUM_U16__TRANSACTION_STATE_DEF,track_id:(0),updated_at:(0),};
export type UserTransactionZarinpal = { authority:ShahString,card:ShahString,card_hash:ShahString,irr:(number),ref_id:(number),state:ShahEnum_u16_TransactionState,updated_at:(number), };
export const USER_TRANSACTION_ZARINPAL_DEF: UserTransactionZarinpal = {authority:SHAH_STRING_DEF,card:SHAH_STRING_DEF,card_hash:SHAH_STRING_DEF,irr:(0),ref_id:(0),state:SHAH_ENUM_U16__TRANSACTION_STATE_DEF,updated_at:(0),};
export type ShahEnum_u16_TransactionCurrecny = "unknown"|"iran_rial";
export const SHAH_ENUM_U16__TRANSACTION_CURRECNY = ["unknown","iran_rial",] as const;
export function is_shah_enum_u16__transaction_currecny(value: string): value is ShahEnum_u16_TransactionCurrecny {
    return SHAH_ENUM_U16__TRANSACTION_CURRECNY.includes(value as ShahEnum_u16_TransactionCurrecny)
}
;
export const SHAH_ENUM_U16__TRANSACTION_CURRECNY_DEF: ShahEnum_u16_TransactionCurrecny = 'unknown';
export type UserTransactionRobPurchase = { _pad:(((number)[])),amount:(number),currency:ShahEnum_u16_TransactionCurrecny,rob:(number), };
export const USER_TRANSACTION_ROB_PURCHASE_DEF: UserTransactionRobPurchase = {_pad:([]),amount:(0),currency:SHAH_ENUM_U16__TRANSACTION_CURRECNY_DEF,rob:(0),};
export type UserTransactionEateryRobTransfer = { eatery:Gene,rob:(number), };
export const USER_TRANSACTION_EATERY_ROB_TRANSFER_DEF: UserTransactionEateryRobTransfer = {eatery:GENE_DEF,rob:(0),};
export type UserTransactionRobGift = { from:Gene,rob:(number), };
export const USER_TRANSACTION_ROB_GIFT_DEF: UserTransactionRobGift = {from:GENE_DEF,rob:(0),};
export type ShahEnum_u16_RobRewardReason = "unknown"|"suggest_add"|"suggest_edit"|"suggest_removal"|"friend_invite"|"joined_invite";
export const SHAH_ENUM_U16__ROB_REWARD_REASON = ["unknown","suggest_add","suggest_edit","suggest_removal","friend_invite","joined_invite",] as const;
export function is_shah_enum_u16__rob_reward_reason(value: string): value is ShahEnum_u16_RobRewardReason {
    return SHAH_ENUM_U16__ROB_REWARD_REASON.includes(value as ShahEnum_u16_RobRewardReason)
}
;
export const SHAH_ENUM_U16__ROB_REWARD_REASON_DEF: ShahEnum_u16_RobRewardReason = 'unknown';
export type UserTransactionRobReward = { _pad:(((number)[])),reason:ShahEnum_u16_RobRewardReason,rob:(number), };
export const USER_TRANSACTION_ROB_REWARD_DEF: UserTransactionRobReward = {_pad:([]),reason:SHAH_ENUM_U16__ROB_REWARD_REASON_DEF,rob:(0),};
export type ShahEnum_u16_UserItemPurchaseKind = "unknown"|"discount";
export const SHAH_ENUM_U16__USER_ITEM_PURCHASE_KIND = ["unknown","discount",] as const;
export function is_shah_enum_u16__user_item_purchase_kind(value: string): value is ShahEnum_u16_UserItemPurchaseKind {
    return SHAH_ENUM_U16__USER_ITEM_PURCHASE_KIND.includes(value as ShahEnum_u16_UserItemPurchaseKind)
}
;
export const SHAH_ENUM_U16__USER_ITEM_PURCHASE_KIND_DEF: ShahEnum_u16_UserItemPurchaseKind = 'unknown';
export type UserTransactionItemPurchase = { _pad:(((number)[])),item_kind:ShahEnum_u16_UserItemPurchaseKind,rob:(number), };
export const USER_TRANSACTION_ITEM_PURCHASE_DEF: UserTransactionItemPurchase = {_pad:([]),item_kind:SHAH_ENUM_U16__USER_ITEM_PURCHASE_KIND_DEF,rob:(0),};
export type UserTransactionKind = ({ kind:("unknown"), })|(UserTransactionZibal&({ kind:("zibal"), }))|(UserTransactionZarinpal&({ kind:("zarinpal"), }))|(UserTransactionRobPurchase&({ kind:("rob_purchase"), }))|(UserTransactionEateryRobTransfer&({ kind:("eatery_rob_transfer"), }))|(UserTransactionRobGift&({ kind:("rob_gift"), }))|(UserTransactionRobReward&({ kind:("rob_reward"), }))|(UserTransactionItemPurchase&({ kind:("item_purchase"), }));
export const USER_TRANSACTION_KIND_DEF: UserTransactionKind = ({kind:('unknown'),});
export type UserTransactionInfo = UserTransactionKind&({ created_at:(number),gene:Gene,user:Gene, });
export const USER_TRANSACTION_INFO_DEF: UserTransactionInfo = {...USER_TRANSACTION_KIND_DEF,...({created_at:(0),gene:GENE_DEF,user:GENE_DEF,}),};
export type AdminTransactionListInfo = { list:((UserTransactionInfo[])),next:Gene,past:Gene, };
export const ADMIN_TRANSACTION_LIST_INFO_DEF: AdminTransactionListInfo = {list:([]),next:GENE_DEF,past:GENE_DEF,};
export type AdminUpdateRecruitLinkBody = { expires_at?:(((number) | null)),limit?:(((number) | null)),perms?:((([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]) | null)), };
export const ADMIN_UPDATE_RECRUIT_LINK_BODY_DEF: AdminUpdateRecruitLinkBody = {};
export type AdminUserBulkBody = { list:((Gene[])), };
export const ADMIN_USER_BULK_BODY_DEF: AdminUserBulkBody = {list:([]),};
export type UserGender = "unknown"|"male"|"female";
export const USER_GENDER = ["unknown","male","female",] as const;
export function is_user_gender(value: string): value is UserGender {
    return USER_GENDER.includes(value as UserGender)
}
;
export const USER_GENDER_DEF: UserGender = 'unknown';
export type FilterEnum_UserGender = ({ opt:("eq"),value:UserGender, })|({ opt:("ne"),value:UserGender, })|({ opt:("in"),value:((UserGender[])), })|({ opt:("not_in"),value:((UserGender[])), });
export const FILTER_ENUM__USER_GENDER_DEF: FilterEnum_UserGender = ({opt:('eq'),value:USER_GENDER_DEF,});
export type FilterNumber_i64 = ({ opt:("gt"),value:(number), })|({ opt:("lt"),value:(number), })|({ opt:("eq"),value:(number), })|({ opt:("ne"),value:(number), })|({ opt:("in"),value:(((number)[])), })|({ opt:("not_in"),value:(((number)[])), });
export const FILTER_NUMBER_I64_DEF: FilterNumber_i64 = ({opt:('gt'),value:(0),});
export type AdminUserFilter = ({ kind:("gender"),value:FilterEnum_UserGender, })|({ kind:("has_photo"),value:(boolean), })|({ kind:("created_at"),value:FilterNumber_u64, })|({ kind:("online_at"),value:FilterNumber_u64, })|({ kind:("cc"),value:FilterNumber_u16, })|({ kind:("is_banned"),value:(boolean), })|({ kind:("is_jailed"),value:(boolean), })|({ kind:("birth_date"),value:FilterNumber_i64, })|({ kind:("wallet_irr"),value:FilterNumber_u64, })|({ kind:("wallet_rob"),value:FilterNumber_u64, })|({ kind:("geo_radius"),value:GeoRadius, })|({ kind:("or"), })|({ kind:("and"), })|({ kind:("group"),value:((AdminUserFilter[])), });
export const ADMIN_USER_FILTER_DEF: AdminUserFilter = ({kind:('gender'),value:FILTER_ENUM__USER_GENDER_DEF,});
export type UserFlagsInfo = { has_password:(boolean),is_banned:(boolean),is_invited:(boolean),is_jailed:(boolean), };
export const USER_FLAGS_INFO_DEF: UserFlagsInfo = {has_password:(false),is_banned:(false),is_invited:(false),is_jailed:(false),};
export type SessionInfo = { browser:(number),browser_version:(number),client:(number),client_version:(number),device:(number),os:(number),os_version:(number), };
export const SESSION_INFO_DEF: SessionInfo = {browser:(0),browser_version:(0),client:(0),client_version:(0),device:(0),os:(0),os_version:(0),};
export type Session = { info:SessionInfo,ip:(string),timestamp:(number),token:ShahString, };
export const SESSION_DEF: Session = {info:SESSION_INFO_DEF,ip:(''),timestamp:(0),token:SHAH_STRING_DEF,};
export type UserWallet = { irr:(number),rob:(number), };
export const USER_WALLET_DEF: UserWallet = {irr:(0),rob:(0),};
export type AdminUserInfo = { agent:Gene,birth_date:(number),compact_gene:CompactGene,created_at:(number),entity_flags:EntityFlags,flags:UserFlagsInfo,gender:UserGender,gene:Gene,history_eatery_nav:Gene,history_eatery_view:Gene,home_location:LocationInfo,name:(string),notifications:(boolean),online_at:(number),photo:Gene,preferences:Gene,review:Gene,saved_dishes:Gene,saved_eateries:Gene,sessions:((Session[])),telephone:SeedPhone,transactions:Gene,username:(string),wallet:UserWallet, };
export const ADMIN_USER_INFO_DEF: AdminUserInfo = {agent:GENE_DEF,birth_date:(0),compact_gene:COMPACT_GENE_DEF,created_at:(0),entity_flags:ENTITY_FLAGS_DEF,flags:USER_FLAGS_INFO_DEF,gender:USER_GENDER_DEF,gene:GENE_DEF,history_eatery_nav:GENE_DEF,history_eatery_view:GENE_DEF,home_location:LOCATION_INFO_DEF,name:(''),notifications:(false),online_at:(0),photo:GENE_DEF,preferences:GENE_DEF,review:GENE_DEF,saved_dishes:GENE_DEF,saved_eateries:GENE_DEF,sessions:([]),telephone:SEED_PHONE_DEF,transactions:GENE_DEF,username:(''),wallet:USER_WALLET_DEF,};
export type UserSort = ({ kind:("created_at"), })|({ kind:("online_at"), })|({ kind:("birth_date"), })|({ kind:("wallet_irr"), })|({ kind:("wallet_rob"), })|({ kind:("geo_point"),lat:(number),lng:(number), });
export const USER_SORT_DEF: UserSort = ({kind:('created_at'),});
export type UserSortItem = { by:UserSort,order?:((SortOrder | null)), };
export const USER_SORT_ITEM_DEF: UserSortItem = {by:USER_SORT_DEF,};
export type AdminUserSearchBody = { filters:((AdminUserFilter[])),query:(string),sort:((UserSortItem[])), };
export const ADMIN_USER_SEARCH_BODY_DEF: AdminUserSearchBody = {filters:([]),query:(''),sort:([]),};
export type AdminUserSetAdminPermsBody = { perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]), };
export const ADMIN_USER_SET_ADMIN_PERMS_BODY_DEF: AdminUserSetAdminPermsBody = {perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),};
export type UserCrimeCause = "unknown"|"swearing"|"nsfw"|"trolling"|"advertising"|"illegal"|"other"|"spam";
export const USER_CRIME_CAUSE = ["unknown","swearing","nsfw","trolling","advertising","illegal","other","spam",] as const;
export function is_user_crime_cause(value: string): value is UserCrimeCause {
    return USER_CRIME_CAUSE.includes(value as UserCrimeCause)
}
;
export const USER_CRIME_CAUSE_DEF: UserCrimeCause = 'unknown';
export type AdminUserSetCrimeBody = { cause:UserCrimeCause,severity:(number), };
export const ADMIN_USER_SET_CRIME_BODY_DEF: AdminUserSetCrimeBody = {cause:USER_CRIME_CAUSE_DEF,severity:(0),};
export type AdminUserUpdateBody = { clear_password:(boolean),delete_photo:(boolean),is_banned:(boolean),name?:(((string) | null)),username?:(((string) | null)), };
export const ADMIN_USER_UPDATE_BODY_DEF: AdminUserUpdateBody = {clear_password:(false),delete_photo:(false),is_banned:(false),};
export type AgentStats = { akhbar_add:(number),dish_added:(number),dish_photo_set:(number),dish_updated:(number),eatery_deleted:(number),eatery_photo_set:(number),eatery_photo_wheat:(number),eatery_updated:(number),feedback_deleted:(number),issue_deleted:(number),suggest_deleted:(number), };
export const AGENT_STATS_DEF: AgentStats = {akhbar_add:(0),dish_added:(0),dish_photo_set:(0),dish_updated:(0),eatery_deleted:(0),eatery_photo_set:(0),eatery_photo_wheat:(0),eatery_updated:(0),feedback_deleted:(0),issue_deleted:(0),suggest_deleted:(0),};
export type UserTopic = { last_read_message_sync:(number),topic:Gene, };
export const USER_TOPIC_DEF: UserTopic = {last_read_message_sync:(0),topic:GENE_DEF,};
export type ShahEnum_u16_UserCrimeCause = "unknown"|"swearing"|"nsfw"|"trolling"|"advertising"|"illegal"|"other"|"spam";
export const SHAH_ENUM_U16__USER_CRIME_CAUSE = ["unknown","swearing","nsfw","trolling","advertising","illegal","other","spam",] as const;
export function is_shah_enum_u16__user_crime_cause(value: string): value is ShahEnum_u16_UserCrimeCause {
    return SHAH_ENUM_U16__USER_CRIME_CAUSE.includes(value as ShahEnum_u16_UserCrimeCause)
}
;
export const SHAH_ENUM_U16__USER_CRIME_CAUSE_DEF: ShahEnum_u16_UserCrimeCause = 'unknown';
export type UserCrime = { cause:ShahEnum_u16_UserCrimeCause,severity:(number),timestamp:(number), };
export const USER_CRIME_DEF: UserCrime = {cause:SHAH_ENUM_U16__USER_CRIME_CAUSE_DEF,severity:(0),timestamp:(0),};
export type UserFeedback = { created_at:(number),feedback:Gene, };
export const USER_FEEDBACK_DEF: UserFeedback = {created_at:(0),feedback:GENE_DEF,};
export type ShahEnum_u8_UserIssueReqEatOwnStatus = "none"|"pending"|"resolved"|"rejected";
export const SHAH_ENUM_U8__USER_ISSUE_REQ_EAT_OWN_STATUS = ["none","pending","resolved","rejected",] as const;
export function is_shah_enum_u8__user_issue_req_eat_own_status(value: string): value is ShahEnum_u8_UserIssueReqEatOwnStatus {
    return SHAH_ENUM_U8__USER_ISSUE_REQ_EAT_OWN_STATUS.includes(value as ShahEnum_u8_UserIssueReqEatOwnStatus)
}
;
export const SHAH_ENUM_U8__USER_ISSUE_REQ_EAT_OWN_STATUS_DEF: ShahEnum_u8_UserIssueReqEatOwnStatus = 'none';
export type UserIssueRequestEateryOwership = { eatery:Gene,issue:Gene,response_at:(number),status:ShahEnum_u8_UserIssueReqEatOwnStatus, };
export const USER_ISSUE_REQUEST_EATERY_OWERSHIP_DEF: UserIssueRequestEateryOwership = {eatery:GENE_DEF,issue:GENE_DEF,response_at:(0),status:SHAH_ENUM_U8__USER_ISSUE_REQ_EAT_OWN_STATUS_DEF,};
export type ShahEnum_u8_UserIssueRequestTicketStatus = "none"|"pending"|"resolved"|"rejected";
export const SHAH_ENUM_U8__USER_ISSUE_REQUEST_TICKET_STATUS = ["none","pending","resolved","rejected",] as const;
export function is_shah_enum_u8__user_issue_request_ticket_status(value: string): value is ShahEnum_u8_UserIssueRequestTicketStatus {
    return SHAH_ENUM_U8__USER_ISSUE_REQUEST_TICKET_STATUS.includes(value as ShahEnum_u8_UserIssueRequestTicketStatus)
}
;
export const SHAH_ENUM_U8__USER_ISSUE_REQUEST_TICKET_STATUS_DEF: ShahEnum_u8_UserIssueRequestTicketStatus = 'none';
export type UserIssueRequestTicket = { issue:Gene,response_at:(number),status:ShahEnum_u8_UserIssueRequestTicketStatus, };
export const USER_ISSUE_REQUEST_TICKET_DEF: UserIssueRequestTicket = {issue:GENE_DEF,response_at:(0),status:SHAH_ENUM_U8__USER_ISSUE_REQUEST_TICKET_STATUS_DEF,};
export type Agent = { admin_perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),admin_stats:AgentStats,associated_eateries:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),associated_topics:([ UserTopic,UserTopic,UserTopic,UserTopic,UserTopic,UserTopic, ]),crimes:([ UserCrime,UserCrime,UserCrime,UserCrime,UserCrime, ]),entity_flags:EntityFlags,feedbacks:([ UserFeedback,UserFeedback, ]),gene:Gene,growth:(number),invited_count:(number),invited_users:Gene,latest_suggestion:(number),request_eatery_ownership:UserIssueRequestEateryOwership,request_ticket:UserIssueRequestTicket,sparks:Gene,suggest:Gene,user:Gene, };
export const AGENT_DEF: Agent = {admin_perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),admin_stats:AGENT_STATS_DEF,associated_eateries:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),associated_topics:([USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,]),crimes:([USER_CRIME_DEF,USER_CRIME_DEF,USER_CRIME_DEF,USER_CRIME_DEF,USER_CRIME_DEF,]),entity_flags:ENTITY_FLAGS_DEF,feedbacks:([USER_FEEDBACK_DEF,USER_FEEDBACK_DEF,]),gene:GENE_DEF,growth:(0),invited_count:(0),invited_users:GENE_DEF,latest_suggestion:(0),request_eatery_ownership:USER_ISSUE_REQUEST_EATERY_OWERSHIP_DEF,request_ticket:USER_ISSUE_REQUEST_TICKET_DEF,sparks:GENE_DEF,suggest:GENE_DEF,user:GENE_DEF,};
export type UserNetworkInfo = { belt_count:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,tail:Gene,user:Gene, };
export const USER_NETWORK_INFO_DEF: UserNetworkInfo = {belt_count:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,tail:GENE_DEF,user:GENE_DEF,};
export type SuggestUserOrigin = { entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,item_count:(number),pond_count:(number),tail:Gene,user:Gene, };
export const SUGGEST_USER_ORIGIN_DEF: SuggestUserOrigin = {entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,item_count:(0),pond_count:(0),tail:GENE_DEF,user:GENE_DEF,};
export type AgentInfo = { admin_perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),admin_stats:AgentStats,associated_eateries:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),associated_topics:([ UserTopic,UserTopic,UserTopic,UserTopic,UserTopic,UserTopic, ]),crimes:([ UserCrime,UserCrime,UserCrime,UserCrime,UserCrime, ]),entity_flags:EntityFlags,feedbacks:([ UserFeedback,UserFeedback, ]),gene:Gene,invited_count:(number),invited_users?:((UserNetworkInfo | null)),latest_suggestion:(number),request_eatery_ownership:UserIssueRequestEateryOwership,request_ticket:UserIssueRequestTicket,sparks:Gene,suggest?:((SuggestUserOrigin | null)), };
export const AGENT_INFO_DEF: AgentInfo = {admin_perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),admin_stats:AGENT_STATS_DEF,associated_eateries:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),associated_topics:([USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,USER_TOPIC_DEF,]),crimes:([USER_CRIME_DEF,USER_CRIME_DEF,USER_CRIME_DEF,USER_CRIME_DEF,USER_CRIME_DEF,]),entity_flags:ENTITY_FLAGS_DEF,feedbacks:([USER_FEEDBACK_DEF,USER_FEEDBACK_DEF,]),gene:GENE_DEF,invited_count:(0),latest_suggestion:(0),request_eatery_ownership:USER_ISSUE_REQUEST_EATERY_OWERSHIP_DEF,request_ticket:USER_ISSUE_REQUEST_TICKET_DEF,sparks:GENE_DEF,};
export type AnalyticsEateriesStats = { active_staff_1_week:(number),alive:(number),brand:(number),cafe:(number),dessert:(number),fast_food:(number),has_active_discount:(number),has_alias:(number),has_content_in_1_month:(number),has_content_in_1_year:(number),has_content_in_3_months:(number),has_employee:(number),has_impressions:(number),has_menu:(number),has_naved:(number),has_parsimap_address:(number),has_phone:(number),has_share:(number),has_tables:(number),has_views:(number),hidden:(number),is_perma_close:(number),low_quality:(number),no_address:(number),photo_1p:(number),photo_4p:(number),restaurant:(number),tender:(number),unique:(number),verified:(number),verified_expired:(number), };
export const ANALYTICS_EATERIES_STATS_DEF: AnalyticsEateriesStats = {active_staff_1_week:(0),alive:(0),brand:(0),cafe:(0),dessert:(0),fast_food:(0),has_active_discount:(0),has_alias:(0),has_content_in_1_month:(0),has_content_in_1_year:(0),has_content_in_3_months:(0),has_employee:(0),has_impressions:(0),has_menu:(0),has_naved:(0),has_parsimap_address:(0),has_phone:(0),has_share:(0),has_tables:(0),has_views:(0),hidden:(0),is_perma_close:(0),low_quality:(0),no_address:(0),photo_1p:(0),photo_4p:(0),restaurant:(0),tender:(0),unique:(0),verified:(0),verified_expired:(0),};
export type AnalyticsRoot = { eatery_nav:ShahBuckle,eatery_share:ShahBuckle,eatery_subed:ShahBuckle,eatery_view:ShahBuckle,rob_purchase:ShahBuckle,user_login:ShahBuckle,user_online:ShahBuckle,user_register:ShahBuckle, };
export const ANALYTICS_ROOT_DEF: AnalyticsRoot = {eatery_nav:SHAH_BUCKLE_DEF,eatery_share:SHAH_BUCKLE_DEF,eatery_subed:SHAH_BUCKLE_DEF,eatery_view:SHAH_BUCKLE_DEF,rob_purchase:SHAH_BUCKLE_DEF,user_login:SHAH_BUCKLE_DEF,user_online:SHAH_BUCKLE_DEF,user_register:SHAH_BUCKLE_DEF,};
export type EateryStat = { count:(number),key:(string), };
export const EATERY_STAT_DEF: EateryStat = {count:(0),key:(''),};
export type EateryName = { eatery:Gene,name:(string), };
export const EATERY_NAME_DEF: EateryName = {eatery:GENE_DEF,name:(''),};
export type AnalyticsStateInfo = { eatery_names:((EateryStat[])),eatery_words:((EateryStat[])),names:((EateryName[])), };
export const ANALYTICS_STATE_INFO_DEF: AnalyticsStateInfo = {eatery_names:([]),eatery_words:([]),names:([]),};
export type ApiRobIrrPrice = { irr:(number),timestamp:(number), };
export const API_ROB_IRR_PRICE_DEF: ApiRobIrrPrice = {irr:(0),timestamp:(0),};
export type AppErr = { code:SeedError,debug?:(((string) | null)),status:(number), };
export const APP_ERR_DEF: AppErr = {code:SEED_ERROR_DEF,status:(0),};
export type BuyRopResponse = ({ kind:("redirect"),url:(string), })|({ kind:("purchased"),wallet:UserWallet, });
export const BUY_ROP_RESPONSE_DEF: BuyRopResponse = ({kind:('redirect'),url:(''),});
export type CabbageAnswerValue = { kind:(string),locale:(string),mb_money_locale:(string), };
export const CABBAGE_ANSWER_VALUE_DEF: CabbageAnswerValue = {kind:(''),locale:(''),mb_money_locale:(''),};
export type CabbageAnswer = ({ answer:(number),answer_kind:("rating"), })|({ answer:(string),answer_kind:("string"), })|({ answer:CabbageAnswerValue,answer_kind:("answer"), })|({ answer:((CabbageAnswerValue[])),answer_kind:("answer_list"), });
export const CABBAGE_ANSWER_DEF: CabbageAnswer = ({answer:(0),answer_kind:('rating'),});
export type EEWheatMediaSource = { h:(number),url:(string),w:(number), };
export const E_E_WHEAT_MEDIA_SOURCE_DEF: EEWheatMediaSource = {h:(0),url:(''),w:(0),};
export type EEWheatMediaLabel = "none"|"food"|"menu"|"people"|"clean";
export const E_E_WHEAT_MEDIA_LABEL = ["none","food","menu","people","clean",] as const;
export function is_e_e_wheat_media_label(value: string): value is EEWheatMediaLabel {
    return E_E_WHEAT_MEDIA_LABEL.includes(value as EEWheatMediaLabel)
}
;
export const E_E_WHEAT_MEDIA_LABEL_DEF: EEWheatMediaLabel = 'none';
export type EEWheatMedia = { id:(string),image:EEWheatMediaSource,label:EEWheatMediaLabel,score:(number),timestamp:(number),video:((((EEWheatMediaSource[])) | null)), };
export const E_E_WHEAT_MEDIA_DEF: EEWheatMedia = {id:(''),image:E_E_WHEAT_MEDIA_SOURCE_DEF,label:E_E_WHEAT_MEDIA_LABEL_DEF,score:(0),timestamp:(0),video:(null),};
export type CabbageQuestion = CabbageAnswer&({ kind:(string),question_in_locale:(string),question_locale:(string),tag_locale:(string), });
export const CABBAGE_QUESTION_DEF: CabbageQuestion = {...CABBAGE_ANSWER_DEF,...({kind:(''),question_in_locale:(''),question_locale:(''),tag_locale:(''),}),};
export type CabbageContent = { created_at:(number),media:((EEWheatMedia[])),questions:((CabbageQuestion[])),text:(string),updated_at:(number), };
export const CABBAGE_CONTENT_DEF: CabbageContent = {created_at:(0),media:([]),questions:([]),text:(''),updated_at:(0),};
export type CabbageData = { cabbage:Cabbage,content?:((CabbageContent | null)),id:(string),user_photo_url:(string), };
export const CABBAGE_DATA_DEF: CabbageData = {cabbage:CABBAGE_DEF,id:(''),user_photo_url:(''),};
export type CabbageList = { list:((Cabbage[])),next:Gene,past:Gene, };
export const CABBAGE_LIST_DEF: CabbageList = {list:([]),next:GENE_DEF,past:GENE_DEF,};
export type CloneMenuBody = { from:Gene,to:Gene, };
export const CLONE_MENU_BODY_DEF: CloneMenuBody = {from:GENE_DEF,to:GENE_DEF,};
export type ComChanRequestBodyV1 = ({ kind:("geo_app_list"), })|({ kind:("notification_status"), })|({ kind:("theme_get"), })|({ dark_mode:(boolean),kind:("theme_set"), })|({ kind:("contact_list"), })|({ kind:("open_notification_settings"), })|({ kind:("push_notification"),title:(string), })|({ kind:("open_geo_app"),latitude:(number),longitude:(number),package_name?:(((string) | null)), });
export const COM_CHAN_REQUEST_BODY_V1_DEF: ComChanRequestBodyV1 = ({kind:('geo_app_list'),});
export type ComChanVersion = "v1";
export const COM_CHAN_VERSION = ["v1",] as const;
export function is_com_chan_version(value: string): value is ComChanVersion {
    return COM_CHAN_VERSION.includes(value as ComChanVersion)
}
;
export const COM_CHAN_VERSION_DEF: ComChanVersion = 'v1';
export type ComChanRequestV1 = { body:ComChanRequestBodyV1,rqid:(string),version:ComChanVersion, };
export const COM_CHAN_REQUEST_V1_DEF: ComChanRequestV1 = {body:COM_CHAN_REQUEST_BODY_V1_DEF,rqid:(''),version:COM_CHAN_VERSION_DEF,};
export type GeoApp = { icon:(string),label:(string),package_name:(string), };
export const GEO_APP_DEF: GeoApp = {icon:(''),label:(''),package_name:(''),};
export type ComChanResponseBodyV1 = ({ kind:("ok"), })|({ kind:("set_version"), })|({ kind:("timeout"), })|({ contact_count:(number),kind:("contact_list"), })|({ detail:(string),kind:("error"), })|({ dark_mode:(boolean),kind:("theme"), })|({ apps:((GeoApp[])),kind:("geo_app_list"), })|({ is_enabled:(boolean),kind:("notification_status"), });
export const COM_CHAN_RESPONSE_BODY_V1_DEF: ComChanResponseBodyV1 = ({kind:('ok'),});
export type ComChanResponseV1 = { body:ComChanResponseBodyV1,rqid:(string),version:ComChanVersion, };
export const COM_CHAN_RESPONSE_V1_DEF: ComChanResponseV1 = {body:COM_CHAN_RESPONSE_BODY_V1_DEF,rqid:(''),version:COM_CHAN_VERSION_DEF,};
export type TaskSpiceEateryInfo = { progress:(number),total:(number), };
export const TASK_SPICE_EATERY_INFO_DEF: TaskSpiceEateryInfo = {progress:(0),total:(0),};
export type SpiceTaskData = (TaskSpiceEateryInfo&({ kind:("eatery"), }))|({ kind:("__user"), });
export const SPICE_TASK_DATA_DEF: SpiceTaskData = ({...TASK_SPICE_EATERY_INFO_DEF,...({kind:('eatery'),}),});
export type ConcurrentTask = { abort:(boolean),created_at:(number),data:SpiceTaskData,done_at:(number),error?:((SeedError | null)),id:TaskId, };
export const CONCURRENT_TASK_DEF: ConcurrentTask = {abort:(false),created_at:(0),data:SPICE_TASK_DATA_DEF,done_at:(0),id:TASK_ID_DEF,};
export type EateryTaskCloneMenuInfo = { dish_cloned:(number),dish_count:(number),from_gene:Gene,record_cloned:(number),record_cloned_size:(number),to_gene:Gene, };
export const EATERY_TASK_CLONE_MENU_INFO_DEF: EateryTaskCloneMenuInfo = {dish_cloned:(0),dish_count:(0),from_gene:GENE_DEF,record_cloned:(0),record_cloned_size:(0),to_gene:GENE_DEF,};
export type EateryTaskUpdateInfo = { alive:(number),dish_search:(number),google_address:(number),google_overflow:(number),low_quality:(number),names:(number),no_extra:(number),parsimap_address:(number),parsimap_error:(number),parsimap_no_addr:(number),prices:(number),progress:(number),search:(number),sector_canton:(number),tiles:(number), };
export const EATERY_TASK_UPDATE_INFO_DEF: EateryTaskUpdateInfo = {alive:(0),dish_search:(0),google_address:(0),google_overflow:(0),low_quality:(0),names:(0),no_extra:(0),parsimap_address:(0),parsimap_error:(0),parsimap_no_addr:(0),prices:(0),progress:(0),search:(0),sector_canton:(0),tiles:(0),};
export type EateryTaskWheatUpdateInfo = { alive:(number),extra_not_found:(number),has_tags:(number),info_errored:(number),info_updated:(number),invalid_extra:(number),media_empty:(number),media_errored:(number),media_updated:(number),multi_extra:(number),no_extra:(number),no_wheat:(number),oh_updated:(number),perma_closed:(number),popular_times_updated:(number),progress:(number),reviews_empty:(number),reviews_errored:(number),reviews_updated:(number),search:(number), };
export const EATERY_TASK_WHEAT_UPDATE_INFO_DEF: EateryTaskWheatUpdateInfo = {alive:(0),extra_not_found:(0),has_tags:(0),info_errored:(0),info_updated:(0),invalid_extra:(0),media_empty:(0),media_errored:(0),media_updated:(0),multi_extra:(0),no_extra:(0),no_wheat:(0),oh_updated:(0),perma_closed:(0),popular_times_updated:(0),progress:(0),reviews_empty:(0),reviews_errored:(0),reviews_updated:(0),search:(0),};
export type EateryTaskCleanIssueInfo = { cleaned:(number),progress:(number),total:(number), };
export const EATERY_TASK_CLEAN_ISSUE_INFO_DEF: EateryTaskCleanIssueInfo = {cleaned:(0),progress:(0),total:(0),};
export type IEatWheat = { bad_names:(number),cleaned:(number),eateries:(number),has_link:(number),has_vid:(number),progress:(number),total:(number),total_media_count:(number), };
export const I_EAT_WHEAT_DEF: IEatWheat = {bad_names:(0),cleaned:(0),eateries:(0),has_link:(0),has_vid:(0),progress:(0),total:(0),total_media_count:(0),};
export type EateryTaskSitemapInfo = { alive:(number),progress:(number),url:(number), };
export const EATERY_TASK_SITEMAP_INFO_DEF: EateryTaskSitemapInfo = {alive:(0),progress:(0),url:(0),};
export type EateryTaskSsrInfo = { alive:(number),com_dur:(number),err:(number),progress:(number),rendered:(number),req_dur:(number),size:(number),size_html:(number), };
export const EATERY_TASK_SSR_INFO_DEF: EateryTaskSsrInfo = {alive:(0),com_dur:(0),err:(0),progress:(0),rendered:(0),req_dur:(0),size:(0),size_html:(0),};
export type EateryTaskEateryAnalyticsInfo = { alive:(number),cz:(number),extra_data:(number),extra_json:(number),extra_not_found:(number),extra_update_failed:(number),extra_updated:(number),invalid_extra:(number),progress:(number),z14:(number),z15:(number),z16:(number),zo:(number), };
export const EATERY_TASK_EATERY_ANALYTICS_INFO_DEF: EateryTaskEateryAnalyticsInfo = {alive:(0),cz:(0),extra_data:(0),extra_json:(0),extra_not_found:(0),extra_update_failed:(0),extra_updated:(0),invalid_extra:(0),progress:(0),z14:(0),z15:(0),z16:(0),zo:(0),};
export type EateryTaskCabbageCleanInfo = { alive:(number),bs:(number),deleted:(number),emojies:(number),empty:(number),english:(number),other:(number),persian:(number),progress:(number), };
export const EATERY_TASK_CABBAGE_CLEAN_INFO_DEF: EateryTaskCabbageCleanInfo = {alive:(0),bs:(0),deleted:(0),emojies:(0),empty:(0),english:(0),other:(0),persian:(0),progress:(0),};
export type EateryTaskData = (EateryTaskCloneMenuInfo&({ kind:("clone"), }))|(EateryTaskUpdateInfo&({ kind:("update"), }))|(EateryTaskWheatUpdateInfo&({ kind:("wheat"), }))|(EateryTaskCleanIssueInfo&({ kind:("clean_issue"), }))|(IEatWheat&({ kind:("i_eat_wheat"), }))|(EateryTaskSitemapInfo&({ kind:("sitemap"), }))|(EateryTaskSsrInfo&({ kind:("ssr"), }))|(EateryTaskEateryAnalyticsInfo&({ kind:("analytics"), }))|(EateryTaskCabbageCleanInfo&({ kind:("cabbage"), }));
export const EATERY_TASK_DATA_DEF: EateryTaskData = ({...EATERY_TASK_CLONE_MENU_INFO_DEF,...({kind:('clone'),}),});
export type ConcurrentTask_EateryTaskData = { abort:(boolean),created_at:(number),data:EateryTaskData,done_at:(number),error?:((SeedError | null)),id:TaskId, };
export const CONCURRENT_TASK__EATERY_TASK_DATA_DEF: ConcurrentTask_EateryTaskData = {abort:(false),created_at:(0),data:EATERY_TASK_DATA_DEF,done_at:(0),id:TASK_ID_DEF,};
export type ConcurrentTask_SpiceTaskData = { abort:(boolean),created_at:(number),data:SpiceTaskData,done_at:(number),error?:((SeedError | null)),id:TaskId, };
export const CONCURRENT_TASK__SPICE_TASK_DATA_DEF: ConcurrentTask_SpiceTaskData = {abort:(false),created_at:(0),data:SPICE_TASK_DATA_DEF,done_at:(0),id:TASK_ID_DEF,};
export type UserTaskUpdateInfo = { alive:(number),progress:(number),search:(number),sessions_reseted:(number),tiles:(number), };
export const USER_TASK_UPDATE_INFO_DEF: UserTaskUpdateInfo = {alive:(0),progress:(0),search:(0),sessions_reseted:(0),tiles:(0),};
export type UserTaskAnalyticsInfo = { alive:(number),android:(number),ios:(number),linux:(number),mac:(number),other:(number),progress:(number),unknown:(number),windows:(number), };
export const USER_TASK_ANALYTICS_INFO_DEF: UserTaskAnalyticsInfo = {alive:(0),android:(0),ios:(0),linux:(0),mac:(0),other:(0),progress:(0),unknown:(0),windows:(0),};
export type UserTaskData = (UserTaskUpdateInfo&({ kind:("update"), }))|(UserTaskAnalyticsInfo&({ kind:("analytics"), }));
export const USER_TASK_DATA_DEF: UserTaskData = ({...USER_TASK_UPDATE_INFO_DEF,...({kind:('update'),}),});
export type ConcurrentTask_UserTaskData = { abort:(boolean),created_at:(number),data:UserTaskData,done_at:(number),error?:((SeedError | null)),id:TaskId, };
export const CONCURRENT_TASK__USER_TASK_DATA_DEF: ConcurrentTask_UserTaskData = {abort:(false),created_at:(0),data:USER_TASK_DATA_DEF,done_at:(0),id:TASK_ID_DEF,};
export type DishDailyInput = { in_friday?:(((boolean) | null)),in_monday?:(((boolean) | null)),in_saturday?:(((boolean) | null)),in_sunday?:(((boolean) | null)),in_thursday?:(((boolean) | null)),in_tuesday?:(((boolean) | null)),in_wednesday?:(((boolean) | null)),is_daily?:(((boolean) | null)), };
export const DISH_DAILY_INPUT_DEF: DishDailyInput = {};
export type DishFilter = ({ kind:("kind"),value:FilterEnum_DishKind, })|({ kind:("eatery"),value:Gene, })|({ kind:("price"),value:FilterNumber_f64, })|({ kind:("photo"),value:(boolean), })|({ kind:("stars"),value:FilterNumber_f32, })|({ kind:("geo_radius"),value:GeoRadius, })|({ kind:("or"), })|({ kind:("and"), })|({ kind:("group"),value:((DishFilter[])), });
export const DISH_FILTER_DEF: DishFilter = ({kind:('kind'),value:FILTER_ENUM__DISH_KIND_DEF,});
export type DishFlagsInput = { is_hidden?:(((boolean) | null)), };
export const DISH_FLAGS_INPUT_DEF: DishFlagsInput = {};
export type DishList = { list:((DishInfo[])),next:Gene,past:Gene, };
export const DISH_LIST_DEF: DishList = {list:([]),next:GENE_DEF,past:GENE_DEF,};
export type GeoSearch = { lat:(number),lng:(number), };
export const GEO_SEARCH_DEF: GeoSearch = {lat:(0),lng:(0),};
export type DishSearch = { _geo:GeoSearch,combo:DishKind,eatery:Gene,eatery_name:(string),eatery_photo:Gene,gene:Gene,is_hidden:(boolean),kind:DishKind,name:(string),note:(string),photo:Gene,price:(number),random_id:(number),review_count:(number),stars:(number), };
export const DISH_SEARCH_DEF: DishSearch = {_geo:GEO_SEARCH_DEF,combo:DISH_KIND_DEF,eatery:GENE_DEF,eatery_name:(''),eatery_photo:GENE_DEF,gene:GENE_DEF,is_hidden:(false),kind:DISH_KIND_DEF,name:(''),note:(''),photo:GENE_DEF,price:(0),random_id:(0),review_count:(0),stars:(0),};
export type DishSearchBody = { filters:((DishFilter[])),name:(string),page:(number),sort:((DishSortItem[])), };
export const DISH_SEARCH_BODY_DEF: DishSearchBody = {filters:([]),name:(''),page:(0),sort:([]),};
export type DishSetPhotoOptions = { put_watermark:(boolean), };
export const DISH_SET_PHOTO_OPTIONS_DEF: DishSetPhotoOptions = {put_watermark:(false),};
export type DishSetPhoto = { options:DishSetPhotoOptions,photo:(File), };
export const DISH_SET_PHOTO_DEF: DishSetPhoto = {options:DISH_SET_PHOTO_OPTIONS_DEF,photo:(new File([], '')),};
export type DishTagsInput = { _is_offering?:((Flag2 | null)),_is_spot_rate_price?:((Flag2 | null)),is_available?:((Flag2 | null)),is_breakfast?:((Flag2 | null)),is_dinner?:((Flag2 | null)),is_free?:((Flag2 | null)),is_lunch?:((Flag2 | null)), };
export const DISH_TAGS_INPUT_DEF: DishTagsInput = {};
export type EEOpenStreet = { latitude:(number),longitude:(number),name:(string), };
export const E_E_OPEN_STREET_DEF: EEOpenStreet = {latitude:(0),longitude:(0),name:(''),};
export type EERicePoi = { latitude:(number),longitude:(number),minzoom:(number),name:(string),reviews:(number),score:(number),token:(string), };
export const E_E_RICE_POI_DEF: EERicePoi = {latitude:(0),longitude:(0),minzoom:(0),name:(''),reviews:(0),score:(0),token:(''),};
export type MediaLabel = { confidence:(number),label:EEWheatMediaLabel, };
export const MEDIA_LABEL_DEF: MediaLabel = {confidence:(0),label:E_E_WHEAT_MEDIA_LABEL_DEF,};
export type EEWheatPriceRange = { count:(number),range:(string), };
export const E_E_WHEAT_PRICE_RANGE_DEF: EEWheatPriceRange = {count:(0),range:(''),};
export type EEWheat = { address:(string),categories:(((string)[])),country_code:(string),gcid_tags:(((string)[])),id:(((number)[])),id_hex:(string),info_updated:(number),latitude:(number),longitude:(number),media:((EEWheatMedia[])),media_labeled:(_Map<MediaLabel>),meida_updated:(number),menu_url:(string),other_phones:(((string)[])),prices:((((EEWheatPriceRange[])) | null)),releated:(((string)[])),review_count:(number),reviews_updated:(number),second_title:(string),star:(((number)[])),stars:(number),summery_long:(string),summery_short:(string),tags:(((string)[])),timezone:(string),title:(string),website:(string), };
export const E_E_WHEAT_DEF: EEWheat = {address:(''),categories:([]),country_code:(''),gcid_tags:([]),id:([]),id_hex:(''),info_updated:(0),latitude:(0),longitude:(0),media:([]),media_labeled:({}),meida_updated:(0),menu_url:(''),other_phones:([]),prices:(null),releated:([]),review_count:(0),reviews_updated:(0),second_title:(''),star:([]),stars:(0),summery_long:(''),summery_short:(''),tags:([]),timezone:(''),title:(''),website:(''),};
export type EateryAnalytics = { buckle:Gene,data?:(((string) | null)),eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),next:Gene,past:Gene,timestamp:(number), };
export const EATERY_ANALYTICS_DEF: EateryAnalytics = {buckle:GENE_DEF,eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),next:GENE_DEF,past:GENE_DEF,timestamp:(0),};
export type EateryAnalyticsBuckle = { belt_count:(number),eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,tail:Gene, };
export const EATERY_ANALYTICS_BUCKLE_DEF: EateryAnalyticsBuckle = {belt_count:(0),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,tail:GENE_DEF,};
export type EateryAnalyticsRoot = { nav:EateryAnalyticsBuckle,share:EateryAnalyticsBuckle,view:EateryAnalyticsBuckle, };
export const EATERY_ANALYTICS_ROOT_DEF: EateryAnalyticsRoot = {nav:EATERY_ANALYTICS_BUCKLE_DEF,share:EATERY_ANALYTICS_BUCKLE_DEF,view:EATERY_ANALYTICS_BUCKLE_DEF,};
export type EateryAudienceStats = { business:(number),couples:(number),family:(number),friends:(number),none:(number), };
export const EATERY_AUDIENCE_STATS_DEF: EateryAudienceStats = {business:(0),couples:(0),family:(0),friends:(0),none:(0),};
export type EateryDecorStats = { bookish:(number),cultural:(number),fantasy:(number),game:(number),luxury:(number),minimal:(number),modern:(number),musical:(number),nature:(number),none:(number),street:(number),traditional:(number), };
export const EATERY_DECOR_STATS_DEF: EateryDecorStats = {bookish:(0),cultural:(0),fantasy:(0),game:(0),luxury:(0),minimal:(0),modern:(0),musical:(0),nature:(0),none:(0),street:(0),traditional:(0),};
export type ShahEnum_u8_EateryUserDiscountState = "holding"|"active"|"applied";
export const SHAH_ENUM_U8__EATERY_USER_DISCOUNT_STATE = ["holding","active","applied",] as const;
export function is_shah_enum_u8__eatery_user_discount_state(value: string): value is ShahEnum_u8_EateryUserDiscountState {
    return SHAH_ENUM_U8__EATERY_USER_DISCOUNT_STATE.includes(value as ShahEnum_u8_EateryUserDiscountState)
}
;
export const SHAH_ENUM_U8__EATERY_USER_DISCOUNT_STATE_DEF: ShahEnum_u8_EateryUserDiscountState = 'holding';
export type EateryUserDiscount = { activated_at:(number),applied_at:(number),created_at:(number),eatery:Gene,entity_flags:EntityFlags,expires_at:(number),gene:Gene,growth:(number),max_amount:(number),min_order:(number),percentage:(number),pond:Gene,rob_price:(number),shadow:Gene,starts_at:(number),state:ShahEnum_u8_EateryUserDiscountState,user:Gene, };
export const EATERY_USER_DISCOUNT_DEF: EateryUserDiscount = {activated_at:(0),applied_at:(0),created_at:(0),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,expires_at:(0),gene:GENE_DEF,growth:(0),max_amount:(0),min_order:(0),percentage:(0),pond:GENE_DEF,rob_price:(0),shadow:GENE_DEF,starts_at:(0),state:SHAH_ENUM_U8__EATERY_USER_DISCOUNT_STATE_DEF,user:GENE_DEF,};
export type EateryDiscountListInfo = { list:((EateryUserDiscount[])),next:Gene,past:Gene,users:((UserCard[])), };
export const EATERY_DISCOUNT_LIST_INFO_DEF: EateryDiscountListInfo = {list:([]),next:GENE_DEF,past:GENE_DEF,users:([]),};
export type EateryDomainStats = { ash:(number),bakery:(number),cafe:(number),dessert:(number),dizi:(number),falafel:(number),fast_food:(number),fried:(number),gelato:(number),hot_dog:(number),ice_cream:(number),juicery:(number),kababi:(number),kalle_pache:(number),liver:(number),none:(number),restaurant:(number),sandwich:(number),seafood:(number),teahouse:(number), };
export const EATERY_DOMAIN_STATS_DEF: EateryDomainStats = {ash:(0),bakery:(0),cafe:(0),dessert:(0),dizi:(0),falafel:(0),fast_food:(0),fried:(0),gelato:(0),hot_dog:(0),ice_cream:(0),juicery:(0),kababi:(0),kalle_pache:(0),liver:(0),none:(0),restaurant:(0),sandwich:(0),seafood:(0),teahouse:(0),};
export type EateryExtra = { links:(((string)[])),openstreet:((EEOpenStreet | null)),rice:((EERicePoi | null)),wheat:((EEWheat | null)), };
export const EATERY_EXTRA_DEF: EateryExtra = {links:([]),openstreet:(null),rice:(null),wheat:(null),};
export type EateryFarmWheatInfo = { id:(string),menu_url:(string),website:(string), };
export const EATERY_FARM_WHEAT_INFO_DEF: EateryFarmWheatInfo = {id:(''),menu_url:(''),website:(''),};
export type EateryFarmInfo = { alias:(string),domain:EateryDomain,gene:Gene,group:EateryGroup,location:LocationInfo,name:(string),telephone:SeedPhone,wheat?:((EateryFarmWheatInfo | null)), };
export const EATERY_FARM_INFO_DEF: EateryFarmInfo = {alias:(''),domain:EATERY_DOMAIN_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,location:LOCATION_INFO_DEF,name:(''),telephone:SEED_PHONE_DEF,};
export type EateryFilter = ({ kind:("tags"),value:EateryTagsInput, })|({ kind:("flags"),value:EateryFlagsInput, })|({ kind:("recently_naved"),value:(boolean), })|({ kind:("recently_viewd"),value:(boolean), })|({ kind:("has_address"),value:(boolean), })|({ kind:("has_photo"),value:(boolean), })|({ kind:("has_trailer"),value:(boolean), })|({ kind:("has_active_staff"),value:(boolean), })|({ kind:("gender_specific"),value:FilterEnum_EateryGenderSpecific, })|({ kind:("eatery_group"),value:FilterEnum_EateryGroup, })|({ kind:("domain"),value:FilterEnum_EateryDomain, })|({ kind:("decor"),value:FilterEnum_EateryDecor, })|({ kind:("audience"),value:FilterEnum_EateryAudience, })|({ kind:("event"),value:FilterEnum_EateryEvent, })|({ kind:("stars"),value:FilterNumber_f32, })|({ kind:("review_count"),value:FilterNumber_u64, })|({ kind:("verified_until"),value:FilterNumber_u64, })|({ kind:("last_activity"),value:FilterNumber_u64, })|({ kind:("score"),value:FilterNumber_f32, })|({ kind:("quality_score"),value:FilterNumber_f32, })|({ kind:("price_range_min"),value:FilterNumber_f64, })|({ kind:("price_range_max"),value:FilterNumber_f64, })|({ kind:("price_range_avg"),value:FilterNumber_f64, })|({ kind:("dish_count"),value:FilterNumber_u16, })|({ kind:("geo_radius"),value:GeoRadius, })|({ kind:("discount_percentage"),value:FilterNumber_u8, })|({ kind:("discount_expires_at"),value:FilterNumber_u64, })|({ kind:("sector_nation"),value:FilterEnum_String, })|({ kind:("sector_region"),value:FilterEnum_String, })|({ kind:("sector_canton"),value:FilterEnum_String, })|({ kind:("or"), })|({ kind:("and"), })|({ kind:("group"),value:((EateryFilter[])), });
export const EATERY_FILTER_DEF: EateryFilter = ({kind:('tags'),value:EATERY_TAGS_INPUT_DEF,});
export type EateryFlags = { has_content_in_1_month:(boolean),has_content_in_1_year:(boolean),has_content_in_3_months:(boolean),has_employee:(boolean),holds_birthday_parties:(boolean),is_24_7:(boolean),is_address_custom:(boolean),is_address_google:(boolean),is_address_parsimap:(boolean),is_brand:(boolean),is_close:(boolean),is_famous:(boolean),is_for_guest:(boolean),is_hidden:(boolean),is_low_quality:(boolean),is_perma_close:(boolean),is_tender:(boolean),is_tourist_attraction:(boolean),is_unique:(boolean),trailer_m3u8_rendered:(boolean),trailer_preview_rendered:(boolean), };
export const EATERY_FLAGS_DEF: EateryFlags = {has_content_in_1_month:(false),has_content_in_1_year:(false),has_content_in_3_months:(false),has_employee:(false),holds_birthday_parties:(false),is_24_7:(false),is_address_custom:(false),is_address_google:(false),is_address_parsimap:(false),is_brand:(false),is_close:(false),is_famous:(false),is_for_guest:(false),is_hidden:(false),is_low_quality:(false),is_perma_close:(false),is_tender:(false),is_tourist_attraction:(false),is_unique:(false),trailer_m3u8_rendered:(false),trailer_preview_rendered:(false),};
export type EateryGenderSpecificStats = { female:(number),male:(number),none:(number), };
export const EATERY_GENDER_SPECIFIC_STATS_DEF: EateryGenderSpecificStats = {female:(0),male:(0),none:(0),};
export type EateryGroupStats = { cafe:(number),dessert:(number),fast_food:(number),restaurant:(number),unknown:(number), };
export const EATERY_GROUP_STATS_DEF: EateryGroupStats = {cafe:(0),dessert:(0),fast_food:(0),restaurant:(0),unknown:(0),};
export type WarehouseInfo = { discount:EateryDiscount,experience:(number),gene:Gene,subscription:EaterySubscription, };
export const WAREHOUSE_INFO_DEF: WarehouseInfo = {discount:EATERY_DISCOUNT_DEF,experience:(0),gene:GENE_DEF,subscription:EATERY_SUBSCRIPTION_DEF,};
export type EateryInfo = { address:(string),alias:(string),audience:EateryAudience,best_dish:([ Gene,Gene,Gene,Gene,Gene, ]),cabbage?:((CabbageOrigin | null)),cabbage_stars:StarRate,calc_zoom:(number),compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,entity_flags:EntityFlags,event:EateryEvent,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,impressions:Gene,last_activity:(number),location:LocationInfo,menu?:((DishOrigin | null)),name:(string),opening_hours?:(((string) | null)),photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),popular_times?:(((string) | null)),price_range:PriceRange,priority:(number),quality_score:(number),review?:((ReviewOrigin | null)),review_count:(number),score:(number),stars:(number),stars_rate:StarRate,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,updated_at:(number),verified_until:(number),warehouse?:((WarehouseInfo | null)),zoom:(number), };
export const EATERY_INFO_DEF: EateryInfo = {address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,best_dish:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),cabbage_stars:STAR_RATE_DEF,calc_zoom:(0),compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,entity_flags:ENTITY_FLAGS_DEF,event:EATERY_EVENT_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,impressions:GENE_DEF,last_activity:(0),location:LOCATION_INFO_DEF,name:(''),photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,priority:(0),quality_score:(0),review_count:(0),score:(0),stars:(0),stars_rate:STAR_RATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,updated_at:(0),verified_until:(0),zoom:(0),};
export type EateryItem = { address:(string),alias:(string),audience:EateryAudience,best_dish:([ Gene,Gene,Gene,Gene,Gene, ]),cabbage_stars:StarRate,calc_zoom:(number),compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,entity_flags:EntityFlags,event:EateryEvent,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,impressions:Gene,last_activity:(number),location:LocationInfo,name:(string),opening_hours?:(((string) | null)),photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),popular_times?:(((string) | null)),price_range:PriceRange,priority:(number),quality_score:(number),review_count:(number),score:(number),stars:(number),stars_rate:StarRate,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,updated_at:(number),verified_until:(number),zoom:(number), };
export const EATERY_ITEM_DEF: EateryItem = {address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,best_dish:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),cabbage_stars:STAR_RATE_DEF,calc_zoom:(0),compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,entity_flags:ENTITY_FLAGS_DEF,event:EATERY_EVENT_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,impressions:GENE_DEF,last_activity:(0),location:LOCATION_INFO_DEF,name:(''),photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,priority:(0),quality_score:(0),review_count:(0),score:(0),stars:(0),stars_rate:STAR_RATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,updated_at:(0),verified_until:(0),zoom:(0),};
export type EateryReviewInfo = { detail:Gene,eatery:Gene,entity_flags:EntityFlags,gene:Gene,issue:Gene,pond:Gene,star_food:(number),star_service:(number),star_vibe:(number),state:ReviewState,summary:(string),timestamp:(number),user?:((UserCard | null)),user_review:Gene, };
export const EATERY_REVIEW_INFO_DEF: EateryReviewInfo = {detail:GENE_DEF,eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,issue:GENE_DEF,pond:GENE_DEF,star_food:(0),star_service:(0),star_vibe:(0),state:REVIEW_STATE_DEF,summary:(''),timestamp:(0),user_review:GENE_DEF,};
export type EateryReviewInfoList = { list:((EateryReviewInfo[])),next:Gene,past:Gene, };
export const EATERY_REVIEW_INFO_LIST_DEF: EateryReviewInfoList = {list:([]),next:GENE_DEF,past:GENE_DEF,};
export type PopularTimesDay = { h0?:(number),h1?:(number),h10?:(number),h11?:(number),h12?:(number),h13?:(number),h14?:(number),h15?:(number),h16?:(number),h17?:(number),h18?:(number),h19?:(number),h2?:(number),h20?:(number),h21?:(number),h22?:(number),h23?:(number),h3?:(number),h4?:(number),h5?:(number),h6?:(number),h7?:(number),h8?:(number),h9?:(number), };
export const POPULAR_TIMES_DAY_DEF: PopularTimesDay = {};
export type PopularTimes = { d0?:PopularTimesDay,d1?:PopularTimesDay,d2?:PopularTimesDay,d3?:PopularTimesDay,d4?:PopularTimesDay,d5?:PopularTimesDay,d6?:PopularTimesDay, };
export const POPULAR_TIMES_DEF: PopularTimes = {};
export type EaterySearch = { _geo:GeoSearch,address:(string),alias:(string),audience:EateryAudience,decor:EateryDecor,discount_available:(number),discount_expires_at:(number),discount_percentage:(number),dish_count:(number),domain:EateryDomain,event:EateryEvent,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,last_activity:(number),name:(string),opening_hours:(((string) | null)),photo:Gene,popular_times?:PopularTimes,price_range:PriceRange,quality_score:(number),random_id:(number),review_count:(number),score:(number),sector:SectorInfo,star_sum:(number),stars:(number),tables:(number),tags:EateryTagsInfo,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,verified_until:(number), };
export const EATERY_SEARCH_DEF: EaterySearch = {_geo:GEO_SEARCH_DEF,address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,decor:EATERY_DECOR_DEF,discount_available:(0),discount_expires_at:(0),discount_percentage:(0),dish_count:(0),domain:EATERY_DOMAIN_DEF,event:EATERY_EVENT_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,last_activity:(0),name:(''),opening_hours:(null),photo:GENE_DEF,price_range:PRICE_RANGE_DEF,quality_score:(0),random_id:(0),review_count:(0),score:(0),sector:SECTOR_INFO_DEF,star_sum:(0),stars:(0),tables:(0),tags:EATERY_TAGS_INFO_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,verified_until:(0),};
export type EaterySearchBody = { filters:((EateryFilter[])),name:(string),page:(number),sort:((EaterySortItem[])), };
export const EATERY_SEARCH_BODY_DEF: EaterySearchBody = {filters:([]),name:(''),page:(0),sort:([]),};
export type EaterySetPhotoOptions = { put_watermark?:(boolean), };
export const EATERY_SET_PHOTO_OPTIONS_DEF: EaterySetPhotoOptions = {};
export type EaterySetPhoto = { options:EaterySetPhotoOptions,photo:(File), };
export const EATERY_SET_PHOTO_DEF: EaterySetPhoto = {options:EATERY_SET_PHOTO_OPTIONS_DEF,photo:(new File([], '')),};
export type Flag2Stats = { no:(number),yes:(number), };
export const FLAG2_STATS_DEF: Flag2Stats = {no:(0),yes:(0),};
export type EateryTagsStats = { allows_long_stays:Flag2Stats,can_smoke_indoor:Flag2Stats,has_breakfast:Flag2Stats,has_delivery:Flag2Stats,has_dine_in:Flag2Stats,has_dinner:Flag2Stats,has_dj:Flag2Stats,has_drive_through:Flag2Stats,has_good_view:Flag2Stats,has_halal_food:Flag2Stats,has_indoor_seating:Flag2Stats,has_live_music:Flag2Stats,has_lunch:Flag2Stats,has_outdoor_seating:Flag2Stats,has_parking:Flag2Stats,has_private_dining:Flag2Stats,has_qelyan:Flag2Stats,has_reservations:Flag2Stats,has_self_service:Flag2Stats,has_solo_dining:Flag2Stats,has_takeaway:Flag2Stats,has_toilet:Flag2Stats,has_tv:Flag2Stats,has_vegan_food:Flag2Stats,has_vegetarian_food:Flag2Stats,has_wifi:Flag2Stats,is_photogenic:Flag2Stats,is_suitable_for_children:Flag2Stats,is_suitable_for_large_groups:Flag2Stats,is_suitable_for_pets:Flag2Stats,is_suitable_for_reading:Flag2Stats,is_suitable_for_social_working:Flag2Stats,is_tourist_friendly:Flag2Stats,is_wheelchair_accessible:Flag2Stats, };
export const EATERY_TAGS_STATS_DEF: EateryTagsStats = {allows_long_stays:FLAG2_STATS_DEF,can_smoke_indoor:FLAG2_STATS_DEF,has_breakfast:FLAG2_STATS_DEF,has_delivery:FLAG2_STATS_DEF,has_dine_in:FLAG2_STATS_DEF,has_dinner:FLAG2_STATS_DEF,has_dj:FLAG2_STATS_DEF,has_drive_through:FLAG2_STATS_DEF,has_good_view:FLAG2_STATS_DEF,has_halal_food:FLAG2_STATS_DEF,has_indoor_seating:FLAG2_STATS_DEF,has_live_music:FLAG2_STATS_DEF,has_lunch:FLAG2_STATS_DEF,has_outdoor_seating:FLAG2_STATS_DEF,has_parking:FLAG2_STATS_DEF,has_private_dining:FLAG2_STATS_DEF,has_qelyan:FLAG2_STATS_DEF,has_reservations:FLAG2_STATS_DEF,has_self_service:FLAG2_STATS_DEF,has_solo_dining:FLAG2_STATS_DEF,has_takeaway:FLAG2_STATS_DEF,has_toilet:FLAG2_STATS_DEF,has_tv:FLAG2_STATS_DEF,has_vegan_food:FLAG2_STATS_DEF,has_vegetarian_food:FLAG2_STATS_DEF,has_wifi:FLAG2_STATS_DEF,is_photogenic:FLAG2_STATS_DEF,is_suitable_for_children:FLAG2_STATS_DEF,is_suitable_for_large_groups:FLAG2_STATS_DEF,is_suitable_for_pets:FLAG2_STATS_DEF,is_suitable_for_reading:FLAG2_STATS_DEF,is_suitable_for_social_working:FLAG2_STATS_DEF,is_tourist_friendly:FLAG2_STATS_DEF,is_wheelchair_accessible:FLAG2_STATS_DEF,};
export type EateryStats = { audience:EateryAudienceStats,count:(number),decor:EateryDecorStats,domain:EateryDomainStats,gender_specific:EateryGenderSpecificStats,group:EateryGroupStats,oldest:Gene,tags:EateryTagsStats, };
export const EATERY_STATS_DEF: EateryStats = {audience:EATERY_AUDIENCE_STATS_DEF,count:(0),decor:EATERY_DECOR_STATS_DEF,domain:EATERY_DOMAIN_STATS_DEF,gender_specific:EATERY_GENDER_SPECIFIC_STATS_DEF,group:EATERY_GROUP_STATS_DEF,oldest:GENE_DEF,tags:EATERY_TAGS_STATS_DEF,};
export type EaterySubscriptionKind = "free"|"vip";
export const EATERY_SUBSCRIPTION_KIND = ["free","vip",] as const;
export function is_eatery_subscription_kind(value: string): value is EaterySubscriptionKind {
    return EATERY_SUBSCRIPTION_KIND.includes(value as EaterySubscriptionKind)
}
;
export const EATERY_SUBSCRIPTION_KIND_DEF: EaterySubscriptionKind = 'free';
export type EaterySubscriptionPlan = { dishes:(number),employees:(number),keep_analytics:(boolean),kind:EaterySubscriptionKind,price:(number),recruit_links:(number),view_tips:(boolean), };
export const EATERY_SUBSCRIPTION_PLAN_DEF: EaterySubscriptionPlan = {dishes:(0),employees:(0),keep_analytics:(false),kind:EATERY_SUBSCRIPTION_KIND_DEF,price:(0),recruit_links:(0),view_tips:(false),};
export type EateryTags = { allows_long_stays:Flag2,can_smoke_indoor:Flag2,has_breakfast:Flag2,has_delivery:Flag2,has_dine_in:Flag2,has_dinner:Flag2,has_dj:Flag2,has_drive_through:Flag2,has_good_view:Flag2,has_halal_food:Flag2,has_indoor_seating:Flag2,has_live_music:Flag2,has_lunch:Flag2,has_outdoor_seating:Flag2,has_parking:Flag2,has_private_dining:Flag2,has_qelyan:Flag2,has_reservations:Flag2,has_self_service:Flag2,has_solo_dining:Flag2,has_takeaway:Flag2,has_toilet:Flag2,has_tv:Flag2,has_vegan_food:Flag2,has_vegetarian_food:Flag2,has_wifi:Flag2,is_photogenic:Flag2,is_suitable_for_children:Flag2,is_suitable_for_large_groups:Flag2,is_suitable_for_pets:Flag2,is_suitable_for_reading:Flag2,is_suitable_for_social_working:Flag2,is_tourist_friendly:Flag2,is_wheelchair_accessible:Flag2, };
export const EATERY_TAGS_DEF: EateryTags = {allows_long_stays:FLAG2_DEF,can_smoke_indoor:FLAG2_DEF,has_breakfast:FLAG2_DEF,has_delivery:FLAG2_DEF,has_dine_in:FLAG2_DEF,has_dinner:FLAG2_DEF,has_dj:FLAG2_DEF,has_drive_through:FLAG2_DEF,has_good_view:FLAG2_DEF,has_halal_food:FLAG2_DEF,has_indoor_seating:FLAG2_DEF,has_live_music:FLAG2_DEF,has_lunch:FLAG2_DEF,has_outdoor_seating:FLAG2_DEF,has_parking:FLAG2_DEF,has_private_dining:FLAG2_DEF,has_qelyan:FLAG2_DEF,has_reservations:FLAG2_DEF,has_self_service:FLAG2_DEF,has_solo_dining:FLAG2_DEF,has_takeaway:FLAG2_DEF,has_toilet:FLAG2_DEF,has_tv:FLAG2_DEF,has_vegan_food:FLAG2_DEF,has_vegetarian_food:FLAG2_DEF,has_wifi:FLAG2_DEF,is_photogenic:FLAG2_DEF,is_suitable_for_children:FLAG2_DEF,is_suitable_for_large_groups:FLAG2_DEF,is_suitable_for_pets:FLAG2_DEF,is_suitable_for_reading:FLAG2_DEF,is_suitable_for_social_working:FLAG2_DEF,is_tourist_friendly:FLAG2_DEF,is_wheelchair_accessible:FLAG2_DEF,};
export type EateryTaskUpdateBody = { add_manual_merge:(boolean),address:(boolean),clean_themes:(boolean),dish_search:(boolean),has_content:(boolean),low_quality:(boolean),names:(boolean),prices:(boolean),reset_event?:((EateryEvent | null)),search:(boolean),sector:(boolean),tiles:(boolean), };
export const EATERY_TASK_UPDATE_BODY_DEF: EateryTaskUpdateBody = {add_manual_merge:(false),address:(false),clean_themes:(false),dish_search:(false),has_content:(false),low_quality:(false),names:(false),prices:(false),search:(false),sector:(false),tiles:(false),};
export type EateryTaskWheatUpdateBody = { info:(boolean),media:(boolean),reviews:(boolean), };
export const EATERY_TASK_WHEAT_UPDATE_BODY_DEF: EateryTaskWheatUpdateBody = {info:(false),media:(false),reviews:(false),};
export type EateryTaskWheatUpdatePartialBody = { eateries_gene:(string),info:(boolean),media:(boolean),reviews:(boolean), };
export const EATERY_TASK_WHEAT_UPDATE_PARTIAL_BODY_DEF: EateryTaskWheatUpdatePartialBody = {eateries_gene:(''),info:(false),media:(false),reviews:(false),};
export type EateryTipFlags = { is_anonymous:(boolean), };
export const EATERY_TIP_FLAGS_DEF: EateryTipFlags = {is_anonymous:(false),};
export type EateryTip = { buckle:Gene,created_at:(number),detail:Gene,eatery:Gene,entity_flags:EntityFlags,flags:EateryTipFlags,gene:Gene,growth:(number),next:Gene,past:Gene,read_at:(number),summery:ShahString,user:Gene, };
export const EATERY_TIP_DEF: EateryTip = {buckle:GENE_DEF,created_at:(0),detail:GENE_DEF,eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,flags:EATERY_TIP_FLAGS_DEF,gene:GENE_DEF,growth:(0),next:GENE_DEF,past:GENE_DEF,read_at:(0),summery:SHAH_STRING_DEF,user:GENE_DEF,};
export type EateryTipFlagsInfo = { is_anonymous:(boolean), };
export const EATERY_TIP_FLAGS_INFO_DEF: EateryTipFlagsInfo = {is_anonymous:(false),};
export type EntityFlagsInfo = { is_alive:(boolean), };
export const ENTITY_FLAGS_INFO_DEF: EntityFlagsInfo = {is_alive:(false),};
export type EateryTipInfo = { buckle:Gene,created_at:(number),detail:(string),eatery:Gene,entity_flags:EntityFlagsInfo,flags:EateryTipFlagsInfo,gene:Gene,next:Gene,past:Gene,read_at:(number),user?:((UserCard | null)), };
export const EATERY_TIP_INFO_DEF: EateryTipInfo = {buckle:GENE_DEF,created_at:(0),detail:(''),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_INFO_DEF,flags:EATERY_TIP_FLAGS_INFO_DEF,gene:GENE_DEF,next:GENE_DEF,past:GENE_DEF,read_at:(0),};
export type EateryTransactionDiscountPurchase = { rob:(number),user:Gene, };
export const EATERY_TRANSACTION_DISCOUNT_PURCHASE_DEF: EateryTransactionDiscountPurchase = {rob:(0),user:GENE_DEF,};
export type EateryTransactionUserRobTransferred = { rob:(number),user:Gene, };
export const EATERY_TRANSACTION_USER_ROB_TRANSFERRED_DEF: EateryTransactionUserRobTransferred = {rob:(0),user:GENE_DEF,};
export type EateryTransactionSubscriptionPurchase = { rob:(number),user:Gene, };
export const EATERY_TRANSACTION_SUBSCRIPTION_PURCHASE_DEF: EateryTransactionSubscriptionPurchase = {rob:(0),user:GENE_DEF,};
export type EateryTransactionKind = ({ kind:("unknown"), })|(EateryTransactionUserRobTransferred&({ kind:("user_rob_transferred"), }))|(EateryTransactionDiscountPurchase&({ kind:("discount_purchase"), }))|(EateryTransactionSubscriptionPurchase&({ kind:("subscription_purchase"), }));
export const EATERY_TRANSACTION_KIND_DEF: EateryTransactionKind = ({kind:('unknown'),});
export type EateryTransactionInfo = EateryTransactionKind&({ created_at:(number),eatery:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),pond:Gene, });
export const EATERY_TRANSACTION_INFO_DEF: EateryTransactionInfo = {...EATERY_TRANSACTION_KIND_DEF,...({created_at:(0),eatery:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),pond:GENE_DEF,}),};
export type EateryTransactionListInfo = { list:((EateryTransactionInfo[])),next:Gene,past:Gene,users:((UserCard[])), };
export const EATERY_TRANSACTION_LIST_INFO_DEF: EateryTransactionListInfo = {list:([]),next:GENE_DEF,past:GENE_DEF,users:([]),};
export type Employee = { created_at:(number),perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),updated_at:(number),user:Gene, };
export const EMPLOYEE_DEF: Employee = {created_at:(0),perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),updated_at:(0),user:GENE_DEF,};
export type EmployeeInfo = { created_at:(number),perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),updated_at:(number),user:UserCard, };
export const EMPLOYEE_INFO_DEF: EmployeeInfo = {created_at:(0),perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),updated_at:(0),user:USER_CARD_DEF,};
export type EmployeeListInfo = { buckle:Gene,eatery:Gene,employees:((EmployeeInfo[])),gene:Gene,next:Gene,past:Gene, };
export const EMPLOYEE_LIST_INFO_DEF: EmployeeListInfo = {buckle:GENE_DEF,eatery:GENE_DEF,employees:([]),gene:GENE_DEF,next:GENE_DEF,past:GENE_DEF,};
export type ShahEnum_u8_FeedbackKind = "unknown"|"criticism"|"suggestion"|"bug"|"resolved"|"chatting";
export const SHAH_ENUM_U8__FEEDBACK_KIND = ["unknown","criticism","suggestion","bug","resolved","chatting",] as const;
export function is_shah_enum_u8__feedback_kind(value: string): value is ShahEnum_u8_FeedbackKind {
    return SHAH_ENUM_U8__FEEDBACK_KIND.includes(value as ShahEnum_u8_FeedbackKind)
}
;
export const SHAH_ENUM_U8__FEEDBACK_KIND_DEF: ShahEnum_u8_FeedbackKind = 'unknown';
export type ShahEnum_u8_FeedbackStatus = "unknown"|"pending"|"chatting"|"resolved";
export const SHAH_ENUM_U8__FEEDBACK_STATUS = ["unknown","pending","chatting","resolved",] as const;
export function is_shah_enum_u8__feedback_status(value: string): value is ShahEnum_u8_FeedbackStatus {
    return SHAH_ENUM_U8__FEEDBACK_STATUS.includes(value as ShahEnum_u8_FeedbackStatus)
}
;
export const SHAH_ENUM_U8__FEEDBACK_STATUS_DEF: ShahEnum_u8_FeedbackStatus = 'unknown';
export type Feedback = { detail:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),kind:ShahEnum_u8_FeedbackKind,next:Gene,past:Gene,record:Gene,root:Gene,status:ShahEnum_u8_FeedbackStatus,summary:ShahString,timestamp:(number),topic:Gene,user:Gene, };
export const FEEDBACK_DEF: Feedback = {detail:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),kind:SHAH_ENUM_U8__FEEDBACK_KIND_DEF,next:GENE_DEF,past:GENE_DEF,record:GENE_DEF,root:GENE_DEF,status:SHAH_ENUM_U8__FEEDBACK_STATUS_DEF,summary:SHAH_STRING_DEF,timestamp:(0),topic:GENE_DEF,user:GENE_DEF,};
export type FeedbackKind = "unknown"|"criticism"|"suggestion"|"bug"|"resolved"|"chatting";
export const FEEDBACK_KIND = ["unknown","criticism","suggestion","bug","resolved","chatting",] as const;
export function is_feedback_kind(value: string): value is FeedbackKind {
    return FEEDBACK_KIND.includes(value as FeedbackKind)
}
;
export const FEEDBACK_KIND_DEF: FeedbackKind = 'unknown';
export type FeedbackAddInfo = { detail:(string),kind:FeedbackKind, };
export const FEEDBACK_ADD_INFO_DEF: FeedbackAddInfo = {detail:(''),kind:FEEDBACK_KIND_DEF,};
export type FeedbackAddBody = { info:FeedbackAddInfo,record?:(((File) | null)), };
export const FEEDBACK_ADD_BODY_DEF: FeedbackAddBody = {info:FEEDBACK_ADD_INFO_DEF,};
export type FeedbackStatus = "unknown"|"pending"|"chatting"|"resolved";
export const FEEDBACK_STATUS = ["unknown","pending","chatting","resolved",] as const;
export function is_feedback_status(value: string): value is FeedbackStatus {
    return FEEDBACK_STATUS.includes(value as FeedbackStatus)
}
;
export const FEEDBACK_STATUS_DEF: FeedbackStatus = 'unknown';
export type FeedbackInfo = { detail:(string),gene:Gene,kind:FeedbackKind,next:Gene,past:Gene,record:Gene,root:Gene,status:FeedbackStatus,timestamp:(number),topic:Gene,user:Gene, };
export const FEEDBACK_INFO_DEF: FeedbackInfo = {detail:(''),gene:GENE_DEF,kind:FEEDBACK_KIND_DEF,next:GENE_DEF,past:GENE_DEF,record:GENE_DEF,root:GENE_DEF,status:FEEDBACK_STATUS_DEF,timestamp:(0),topic:GENE_DEF,user:GENE_DEF,};
export type FeedbackRoot = { bug:ShahBuckle,chatting:ShahBuckle,criticism:ShahBuckle,resolved:ShahBuckle,suggestion:ShahBuckle, };
export const FEEDBACK_ROOT_DEF: FeedbackRoot = {bug:SHAH_BUCKLE_DEF,chatting:SHAH_BUCKLE_DEF,criticism:SHAH_BUCKLE_DEF,resolved:SHAH_BUCKLE_DEF,suggestion:SHAH_BUCKLE_DEF,};
export type GeneInput = string;
export const GENE_INPUT_DEF: GeneInput = '';
export type ShahEnum_u8_GeneralAnalyticsKind = "unknown"|"user_online"|"user_login"|"user_register"|"eatery_view"|"eatery_nav"|"eatery_share"|"eatery_subed"|"rob_purchase";
export const SHAH_ENUM_U8__GENERAL_ANALYTICS_KIND = ["unknown","user_online","user_login","user_register","eatery_view","eatery_nav","eatery_share","eatery_subed","rob_purchase",] as const;
export function is_shah_enum_u8__general_analytics_kind(value: string): value is ShahEnum_u8_GeneralAnalyticsKind {
    return SHAH_ENUM_U8__GENERAL_ANALYTICS_KIND.includes(value as ShahEnum_u8_GeneralAnalyticsKind)
}
;
export const SHAH_ENUM_U8__GENERAL_ANALYTICS_KIND_DEF: ShahEnum_u8_GeneralAnalyticsKind = 'unknown';
export type GeneralAnalytics = { data?:(((string) | null)),entity_flags:EntityFlags,gene:Gene,growth:(number),kind:ShahEnum_u8_GeneralAnalyticsKind,next:Gene,past:Gene,root:Gene,timestamp:(number), };
export const GENERAL_ANALYTICS_DEF: GeneralAnalytics = {entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),kind:SHAH_ENUM_U8__GENERAL_ANALYTICS_KIND_DEF,next:GENE_DEF,past:GENE_DEF,root:GENE_DEF,timestamp:(0),};
export type GolemFlags = { is_banned:(boolean), };
export const GOLEM_FLAGS_DEF: GolemFlags = {is_banned:(false),};
export type Golem = { created_at:(number),entity_flags:EntityFlags,expires_at:(number),flags:GolemFlags,gene:Gene,growth:(number),name:ShahString,perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),token:(string), };
export const GOLEM_DEF: Golem = {created_at:(0),entity_flags:ENTITY_FLAGS_DEF,expires_at:(0),flags:GOLEM_FLAGS_DEF,gene:GENE_DEF,growth:(0),name:SHAH_STRING_DEF,perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),token:(''),};
export type GolemAddBody = { expires_after:(number),name:(string),perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]), };
export const GOLEM_ADD_BODY_DEF: GolemAddBody = {expires_after:(0),name:(''),perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),};
export type GolemToken = { golem:Golem,token:(string), };
export const GOLEM_TOKEN_DEF: GolemToken = {golem:GOLEM_DEF,token:(''),};
export type GolemUsersStats = { count:(number),online:((([ (number),(number), ])[])), };
export const GOLEM_USERS_STATS_DEF: GolemUsersStats = {count:(0),online:([]),};
export type GoojeWallet = { irr:(number), };
export const GOOJE_WALLET_DEF: GoojeWallet = {irr:(0),};
export type HistoryItem = { item:Gene,timestamp:(number), };
export const HISTORY_ITEM_DEF: HistoryItem = {item:GENE_DEF,timestamp:(0),};
export type IrrProvider = "auto"|"zibal"|"zarinpal";
export const IRR_PROVIDER = ["auto","zibal","zarinpal",] as const;
export function is_irr_provider(value: string): value is IrrProvider {
    return IRR_PROVIDER.includes(value as IrrProvider)
}
;
export const IRR_PROVIDER_DEF: IrrProvider = 'auto';
export type IssueCensoredReview = { review:Gene, };
export const ISSUE_CENSORED_REVIEW_DEF: IssueCensoredReview = {review:GENE_DEF,};
export type IssueDenseArea = { latitude:(number),longitude:(number), };
export const ISSUE_DENSE_AREA_DEF: IssueDenseArea = {latitude:(0),longitude:(0),};
export type IssueEateryCabbageReport = { cabbage:Gene,eatery:Gene,reporter:Gene, };
export const ISSUE_EATERY_CABBAGE_REPORT_DEF: IssueEateryCabbageReport = {cabbage:GENE_DEF,eatery:GENE_DEF,reporter:GENE_DEF,};
export type IssueEateryReport = { eatery:Gene,reporter:Gene, };
export const ISSUE_EATERY_REPORT_DEF: IssueEateryReport = {eatery:GENE_DEF,reporter:GENE_DEF,};
export type IssueEateryReviewReport = { eatery:Gene,reporter:Gene,review:Gene, };
export const ISSUE_EATERY_REVIEW_REPORT_DEF: IssueEateryReviewReport = {eatery:GENE_DEF,reporter:GENE_DEF,review:GENE_DEF,};
export type IssueNsfwPhoto = { user:Gene, };
export const ISSUE_NSFW_PHOTO_DEF: IssueNsfwPhoto = {user:GENE_DEF,};
export type IssueManualMerge = { eatery:Gene, };
export const ISSUE_MANUAL_MERGE_DEF: IssueManualMerge = {eatery:GENE_DEF,};
export type IssueRequestEateryOwnership = { eatery:Gene,media:((Gene[])),timestamp:(number),user:Gene, };
export const ISSUE_REQUEST_EATERY_OWNERSHIP_DEF: IssueRequestEateryOwnership = {eatery:GENE_DEF,media:([]),timestamp:(0),user:GENE_DEF,};
export type ShahEnum_u8_RequestTicketAbout = "unknown"|"finance"|"technical";
export const SHAH_ENUM_U8__REQUEST_TICKET_ABOUT = ["unknown","finance","technical",] as const;
export function is_shah_enum_u8__request_ticket_about(value: string): value is ShahEnum_u8_RequestTicketAbout {
    return SHAH_ENUM_U8__REQUEST_TICKET_ABOUT.includes(value as ShahEnum_u8_RequestTicketAbout)
}
;
export const SHAH_ENUM_U8__REQUEST_TICKET_ABOUT_DEF: ShahEnum_u8_RequestTicketAbout = 'unknown';
export type IssueRequestTicket = { about:ShahEnum_u8_RequestTicketAbout,description:ShahString,timestamp:(number),user:Gene, };
export const ISSUE_REQUEST_TICKET_DEF: IssueRequestTicket = {about:SHAH_ENUM_U8__REQUEST_TICKET_ABOUT_DEF,description:SHAH_STRING_DEF,timestamp:(0),user:GENE_DEF,};
export type IssueRequestEateryVerification = { eatery:Gene,timestamp:(number),user:Gene, };
export const ISSUE_REQUEST_EATERY_VERIFICATION_DEF: IssueRequestEateryVerification = {eatery:GENE_DEF,timestamp:(0),user:GENE_DEF,};
export type IssueUserReport = { reporter:Gene,target:Gene, };
export const ISSUE_USER_REPORT_DEF: IssueUserReport = {reporter:GENE_DEF,target:GENE_DEF,};
export type IssueKind = ({ kind:("unknown"), })|(IssueDenseArea&({ kind:("dense_area"), }))|(IssueCensoredReview&({ kind:("censored_review"), }))|(IssueNsfwPhoto&({ kind:("nsfw_photo"), }))|(IssueManualMerge&({ kind:("manual_merge"), }))|(IssueRequestEateryOwnership&({ kind:("request_eatery_ownership"), }))|(IssueRequestTicket&({ kind:("request_ticket"), }))|(IssueRequestEateryVerification&({ kind:("request_eatery_verification"), }))|(IssueEateryReport&({ kind:("eatery_report"), }))|(IssueEateryReviewReport&({ kind:("eatery_review_report"), }))|(IssueEateryCabbageReport&({ kind:("eatery_cabbage_report"), }))|(IssueUserReport&({ kind:("user_report"), }));
export const ISSUE_KIND_DEF: IssueKind = ({kind:('unknown'),});
export type IssueInfo = IssueKind&({ ef:EntityFlags,gene:Gene,growth:(number),next:Gene,past:Gene,pending:(number),root:Gene, });
export const ISSUE_INFO_DEF: IssueInfo = {...ISSUE_KIND_DEF,...({ef:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),next:GENE_DEF,past:GENE_DEF,pending:(0),root:GENE_DEF,}),};
export type IssueReqEatOwnBody = { media:(((File)[])), };
export const ISSUE_REQ_EAT_OWN_BODY_DEF: IssueReqEatOwnBody = {media:([]),};
export type RequestTicketAbout = "unknown"|"finance"|"technical";
export const REQUEST_TICKET_ABOUT = ["unknown","finance","technical",] as const;
export function is_request_ticket_about(value: string): value is RequestTicketAbout {
    return REQUEST_TICKET_ABOUT.includes(value as RequestTicketAbout)
}
;
export const REQUEST_TICKET_ABOUT_DEF: RequestTicketAbout = 'unknown';
export type IssueRequestTicketBody = { about:RequestTicketAbout,description:(string), };
export const ISSUE_REQUEST_TICKET_BODY_DEF: IssueRequestTicketBody = {about:REQUEST_TICKET_ABOUT_DEF,description:(''),};
export type IssueRoot = { censored_review:ShahBuckle,dense_area:ShahBuckle,eatery_cabbage_report:ShahBuckle,eatery_report:ShahBuckle,eatery_review_report:ShahBuckle,manual_merge:ShahBuckle,nsfw_photo:ShahBuckle,request_eatery_ownership:ShahBuckle,request_eatery_verification:ShahBuckle,request_ticket:ShahBuckle,user_report:ShahBuckle, };
export const ISSUE_ROOT_DEF: IssueRoot = {censored_review:SHAH_BUCKLE_DEF,dense_area:SHAH_BUCKLE_DEF,eatery_cabbage_report:SHAH_BUCKLE_DEF,eatery_report:SHAH_BUCKLE_DEF,eatery_review_report:SHAH_BUCKLE_DEF,manual_merge:SHAH_BUCKLE_DEF,nsfw_photo:SHAH_BUCKLE_DEF,request_eatery_ownership:SHAH_BUCKLE_DEF,request_eatery_verification:SHAH_BUCKLE_DEF,request_ticket:SHAH_BUCKLE_DEF,user_report:SHAH_BUCKLE_DEF,};
export type KhabarEateryInfo = { audience:EateryAudience,compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,gene:Gene,group:EateryGroup,location:LocationInfo,name:(string),opening_hours?:(((string) | null)),photo:Gene,photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),price_range:PriceRange,review_count:(number),stars:(number),tables:(number),verified_until:(number), };
export const KHABAR_EATERY_INFO_DEF: KhabarEateryInfo = {audience:EATERY_AUDIENCE_DEF,compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,location:LOCATION_INFO_DEF,name:(''),photo:GENE_DEF,photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,review_count:(0),stars:(0),tables:(0),verified_until:(0),};
export type KhabarFlagsInput = { is_hidden?:(((boolean) | null)), };
export const KHABAR_FLAGS_INPUT_DEF: KhabarFlagsInput = {};
export type KhabarSuggestInfo = { eatery:Gene,gene:Gene,rating:(number),user:Gene, };
export const KHABAR_SUGGEST_INFO_DEF: KhabarSuggestInfo = {eatery:GENE_DEF,gene:GENE_DEF,rating:(0),user:GENE_DEF,};
export type KhabarKindInfo = ({ kind:("unknown"), })|({ eatery:KhabarEateryInfo,kind:("new_review"),review:EateryReviewItem,user:UserCard, })|({ eatery:KhabarEateryInfo,kind:("new_eatery"), })|({ eatery?:((KhabarEateryInfo | null)),kind:("suggest"),suggest:KhabarSuggestInfo,user:UserCard, });
export const KHABAR_KIND_INFO_DEF: KhabarKindInfo = ({kind:('unknown'),});
export type KhabarInfo = KhabarKindInfo&({ ef:EntityFlags,flags:KhabarFlagsInfo,gene:Gene,growth:(number),timestamp:(number), });
export const KHABAR_INFO_DEF: KhabarInfo = {...KHABAR_KIND_INFO_DEF,...({ef:ENTITY_FLAGS_DEF,flags:KHABAR_FLAGS_INFO_DEF,gene:GENE_DEF,growth:(0),timestamp:(0),}),};
export type LoginBody = { code:(string),info:SessionInfo,telephone:SeedPhone, };
export const LOGIN_BODY_DEF: LoginBody = {code:(''),info:SESSION_INFO_DEF,telephone:SEED_PHONE_DEF,};
export type UserEateryHistory = { all_time:EateryStats,belt_count:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,recently:EateryStats,tail:Gene,update_at:(number),user:Gene, };
export const USER_EATERY_HISTORY_DEF: UserEateryHistory = {all_time:EATERY_STATS_DEF,belt_count:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,recently:EATERY_STATS_DEF,tail:GENE_DEF,update_at:(0),user:GENE_DEF,};
export type UserInventoryInfo = { discounts_applied?:((ShahOrigin | null)),discounts_holding?:((ShahOrigin | null)), };
export const USER_INVENTORY_INFO_DEF: UserInventoryInfo = {};
export type UserPreferences = { eatery:EateryStats,entity_flags:EntityFlags,gene:Gene,growth:(number),user:Gene, };
export const USER_PREFERENCES_DEF: UserPreferences = {eatery:EATERY_STATS_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),user:GENE_DEF,};
export type UserReviewOrigin = { entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,pond_count:(number),review_count:(number),tail:Gene,user:Gene, };
export const USER_REVIEW_ORIGIN_DEF: UserReviewOrigin = {entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,pond_count:(0),review_count:(0),tail:GENE_DEF,user:GENE_DEF,};
export type UserInfo = { agent?:((AgentInfo | null)),birth_date:(number),compact_gene:CompactGene,created_at:(number),entity_flags:EntityFlags,flags:UserFlagsInfo,gender:UserGender,gene:Gene,history_eatery_nav?:((UserEateryHistory | null)),history_eatery_view?:((UserEateryHistory | null)),home_location:LocationInfo,inventory:UserInventoryInfo,name:(string),notifications:(boolean),online_at:(number),photo:Gene,preferences?:((UserPreferences | null)),review?:((UserReviewOrigin | null)),saved_dishes?:((ShahBuckle | null)),saved_eateries?:((ShahBuckle | null)),session_index:(number),sessions:((Session[])),telephone:SeedPhone,transactions?:((ShahOrigin | null)),username:(string),wallet:UserWallet, };
export const USER_INFO_DEF: UserInfo = {birth_date:(0),compact_gene:COMPACT_GENE_DEF,created_at:(0),entity_flags:ENTITY_FLAGS_DEF,flags:USER_FLAGS_INFO_DEF,gender:USER_GENDER_DEF,gene:GENE_DEF,home_location:LOCATION_INFO_DEF,inventory:USER_INVENTORY_INFO_DEF,name:(''),notifications:(false),online_at:(0),photo:GENE_DEF,session_index:(0),sessions:([]),telephone:SEED_PHONE_DEF,username:(''),wallet:USER_WALLET_DEF,};
export type LoginInfo = ({ created:(boolean),kind:("logged_in"),user:UserInfo, })|({ expires:(number),gene:Gene,kind:("password"),secret:(string), });
export const LOGIN_INFO_DEF: LoginInfo = ({created:(false),kind:('logged_in'),user:USER_INFO_DEF,});
export type NetworkItemInfo = { timestamp:(number),user:UserCard, };
export const NETWORK_ITEM_INFO_DEF: NetworkItemInfo = {timestamp:(0),user:USER_CARD_DEF,};
export type PriceSettings = { rob_available:(number),rob_irr:(number),rob_irr_history:((ApiRobIrrPrice[])),rob_max:(number),rob_min:(number), };
export const PRICE_SETTINGS_DEF: PriceSettings = {rob_available:(0),rob_irr:(0),rob_irr_history:([]),rob_max:(0),rob_min:(0),};
export type RippleEateryTransactionNew = { transaction:Gene, };
export const RIPPLE_EATERY_TRANSACTION_NEW_DEF: RippleEateryTransactionNew = {transaction:GENE_DEF,};
export type VerificationAction = "login"|"delete"|"set_password";
export const VERIFICATION_ACTION = ["login","delete","set_password",] as const;
export function is_verification_action(value: string): value is VerificationAction {
    return VERIFICATION_ACTION.includes(value as VerificationAction)
}
;
export const VERIFICATION_ACTION_DEF: VerificationAction = 'login';
export type RippleVerification = { action:VerificationAction,cc:(number),code:ShahString,phone:ShahString, };
export const RIPPLE_VERIFICATION_DEF: RippleVerification = {action:VERIFICATION_ACTION_DEF,cc:(0),code:SHAH_STRING_DEF,phone:SHAH_STRING_DEF,};
export type RippleUserTransactionNew = { transaction:Gene, };
export const RIPPLE_USER_TRANSACTION_NEW_DEF: RippleUserTransactionNew = {transaction:GENE_DEF,};
export type RippleReviewNew = { eatery:Gene,review:Gene, };
export const RIPPLE_REVIEW_NEW_DEF: RippleReviewNew = {eatery:GENE_DEF,review:GENE_DEF,};
export type RippleUserOnline = { last_online_at:(number),online_after:(number), };
export const RIPPLE_USER_ONLINE_DEF: RippleUserOnline = {last_online_at:(0),online_after:(0),};
export type RippleKind = ({ kind:("unknown"), })|(RippleVerification&({ kind:("verification"), }))|(RippleUserTransactionNew&({ kind:("user_transaction_new"), }))|(RippleReviewNew&({ kind:("review_new"), }))|({ kind:("user_update_info"), })|({ kind:("user_update_photo"), })|(RippleUserOnline&({ kind:("user_online"), }))|(RippleEateryTransactionNew&({ kind:("eatery_transaction_new"), }))|({ kind:("user_login"), });
export const RIPPLE_KIND_DEF: RippleKind = ({kind:('unknown'),});
export type RippleInfo = RippleKind&({ actor:Gene,created_at:(number),ef:EntityFlags,gene:Gene,next:Gene,past:Gene,root:Gene, });
export const RIPPLE_INFO_DEF: RippleInfo = {...RIPPLE_KIND_DEF,...({actor:GENE_DEF,created_at:(0),ef:ENTITY_FLAGS_DEF,gene:GENE_DEF,next:GENE_DEF,past:GENE_DEF,root:GENE_DEF,}),};
export type RippleRoot = { eatery_transaction_new:ShahBuckle,review_new:ShahBuckle,user_online:ShahBuckle,user_transaction_new:ShahBuckle,user_update_info:ShahBuckle,user_update_photo:ShahBuckle,verification:ShahBuckle, };
export const RIPPLE_ROOT_DEF: RippleRoot = {eatery_transaction_new:SHAH_BUCKLE_DEF,review_new:SHAH_BUCKLE_DEF,user_online:SHAH_BUCKLE_DEF,user_transaction_new:SHAH_BUCKLE_DEF,user_update_info:SHAH_BUCKLE_DEF,user_update_photo:SHAH_BUCKLE_DEF,verification:SHAH_BUCKLE_DEF,};
export type RobIrrPrice = { irr:(number),timestamp:(number),user:Gene, };
export const ROB_IRR_PRICE_DEF: RobIrrPrice = {irr:(0),timestamp:(0),user:GENE_DEF,};
export type RobPrices = { discount_max?:(number),discount_min?:(number), };
export const ROB_PRICES_DEF: RobPrices = {};
export type RobRewards = { frined_invite?:(number), };
export const ROB_REWARDS_DEF: RobRewards = {};
export type RobState = { available:(number),sold:(number), };
export const ROB_STATE_DEF: RobState = {available:(0),sold:(0),};
export type SeedSettingJson = { rob:RobState,rob_irr:((RobIrrPrice[])),rob_prices:RobPrices,rob_rewards:RobRewards,wallet:GoojeWallet, };
export const SEED_SETTING_JSON_DEF: SeedSettingJson = {rob:ROB_STATE_DEF,rob_irr:([]),rob_prices:ROB_PRICES_DEF,rob_rewards:ROB_REWARDS_DEF,wallet:GOOJE_WALLET_DEF,};
export type SetPasswordBody = { code:(string),new_pass?:(((string) | null)),old_pass?:(((string) | null)), };
export const SET_PASSWORD_BODY_DEF: SetPasswordBody = {code:(''),};
export type ShahEnum_u16_EateryDomain = "none"|"cafe"|"bakery"|"teahouse"|"restaurant"|"seafood"|"dizi"|"ash"|"kababi"|"kalle_pache"|"liver"|"fast_food"|"hot_dog"|"sandwich"|"falafel"|"fried"|"dessert"|"ice_cream"|"juicery"|"gelato";
export const SHAH_ENUM_U16__EATERY_DOMAIN = ["none","cafe","bakery","teahouse","restaurant","seafood","dizi","ash","kababi","kalle_pache","liver","fast_food","hot_dog","sandwich","falafel","fried","dessert","ice_cream","juicery","gelato",] as const;
export function is_shah_enum_u16__eatery_domain(value: string): value is ShahEnum_u16_EateryDomain {
    return SHAH_ENUM_U16__EATERY_DOMAIN.includes(value as ShahEnum_u16_EateryDomain)
}
;
export const SHAH_ENUM_U16__EATERY_DOMAIN_DEF: ShahEnum_u16_EateryDomain = 'none';
export type ShahEnum_u16_EateryEvent = "none"|"halloween"|"christmas"|"yalda"|"norooz"|"valentine"|"scarlet_wednesday"|"fifa_world_cup";
export const SHAH_ENUM_U16__EATERY_EVENT = ["none","halloween","christmas","yalda","norooz","valentine","scarlet_wednesday","fifa_world_cup",] as const;
export function is_shah_enum_u16__eatery_event(value: string): value is ShahEnum_u16_EateryEvent {
    return SHAH_ENUM_U16__EATERY_EVENT.includes(value as ShahEnum_u16_EateryEvent)
}
;
export const SHAH_ENUM_U16__EATERY_EVENT_DEF: ShahEnum_u16_EateryEvent = 'none';
export type ShahEnum_u16_XenosOwnerKind = "unknown"|"eatery"|"cabbage";
export const SHAH_ENUM_U16__XENOS_OWNER_KIND = ["unknown","eatery","cabbage",] as const;
export function is_shah_enum_u16__xenos_owner_kind(value: string): value is ShahEnum_u16_XenosOwnerKind {
    return SHAH_ENUM_U16__XENOS_OWNER_KIND.includes(value as ShahEnum_u16_XenosOwnerKind)
}
;
export const SHAH_ENUM_U16__XENOS_OWNER_KIND_DEF: ShahEnum_u16_XenosOwnerKind = 'unknown';
export type ShahEnum_u8_EateryAudience = "none"|"family"|"friends"|"couples"|"business";
export const SHAH_ENUM_U8__EATERY_AUDIENCE = ["none","family","friends","couples","business",] as const;
export function is_shah_enum_u8__eatery_audience(value: string): value is ShahEnum_u8_EateryAudience {
    return SHAH_ENUM_U8__EATERY_AUDIENCE.includes(value as ShahEnum_u8_EateryAudience)
}
;
export const SHAH_ENUM_U8__EATERY_AUDIENCE_DEF: ShahEnum_u8_EateryAudience = 'none';
export type ShahEnum_u8_EateryDecor = "none"|"bookish"|"cultural"|"traditional"|"fantasy"|"musical"|"nature"|"game"|"minimal"|"modern"|"luxury"|"street";
export const SHAH_ENUM_U8__EATERY_DECOR = ["none","bookish","cultural","traditional","fantasy","musical","nature","game","minimal","modern","luxury","street",] as const;
export function is_shah_enum_u8__eatery_decor(value: string): value is ShahEnum_u8_EateryDecor {
    return SHAH_ENUM_U8__EATERY_DECOR.includes(value as ShahEnum_u8_EateryDecor)
}
;
export const SHAH_ENUM_U8__EATERY_DECOR_DEF: ShahEnum_u8_EateryDecor = 'none';
export type ShahEnum_u8_EateryGenderSpecific = "none"|"male"|"female";
export const SHAH_ENUM_U8__EATERY_GENDER_SPECIFIC = ["none","male","female",] as const;
export function is_shah_enum_u8__eatery_gender_specific(value: string): value is ShahEnum_u8_EateryGenderSpecific {
    return SHAH_ENUM_U8__EATERY_GENDER_SPECIFIC.includes(value as ShahEnum_u8_EateryGenderSpecific)
}
;
export const SHAH_ENUM_U8__EATERY_GENDER_SPECIFIC_DEF: ShahEnum_u8_EateryGenderSpecific = 'none';
export type ShahEnum_u8_EateryGroup = "unknown"|"cafe"|"restaurant"|"fast_food"|"dessert";
export const SHAH_ENUM_U8__EATERY_GROUP = ["unknown","cafe","restaurant","fast_food","dessert",] as const;
export function is_shah_enum_u8__eatery_group(value: string): value is ShahEnum_u8_EateryGroup {
    return SHAH_ENUM_U8__EATERY_GROUP.includes(value as ShahEnum_u8_EateryGroup)
}
;
export const SHAH_ENUM_U8__EATERY_GROUP_DEF: ShahEnum_u8_EateryGroup = 'unknown';
export type ShahEnum_u8_EateryVerificationRequestStatus = "none"|"pending"|"resolved"|"rejected";
export const SHAH_ENUM_U8__EATERY_VERIFICATION_REQUEST_STATUS = ["none","pending","resolved","rejected",] as const;
export function is_shah_enum_u8__eatery_verification_request_status(value: string): value is ShahEnum_u8_EateryVerificationRequestStatus {
    return SHAH_ENUM_U8__EATERY_VERIFICATION_REQUEST_STATUS.includes(value as ShahEnum_u8_EateryVerificationRequestStatus)
}
;
export const SHAH_ENUM_U8__EATERY_VERIFICATION_REQUEST_STATUS_DEF: ShahEnum_u8_EateryVerificationRequestStatus = 'none';
export type ShahEnum_u8_SuggestKind = "unknown"|"add"|"edit"|"removal";
export const SHAH_ENUM_U8__SUGGEST_KIND = ["unknown","add","edit","removal",] as const;
export function is_shah_enum_u8__suggest_kind(value: string): value is ShahEnum_u8_SuggestKind {
    return SHAH_ENUM_U8__SUGGEST_KIND.includes(value as ShahEnum_u8_SuggestKind)
}
;
export const SHAH_ENUM_U8__SUGGEST_KIND_DEF: ShahEnum_u8_SuggestKind = 'unknown';
export type ShahEnum_u8_SuggestState = "unknown"|"draft"|"pending"|"approved"|"rejected";
export const SHAH_ENUM_U8__SUGGEST_STATE = ["unknown","draft","pending","approved","rejected",] as const;
export function is_shah_enum_u8__suggest_state(value: string): value is ShahEnum_u8_SuggestState {
    return SHAH_ENUM_U8__SUGGEST_STATE.includes(value as ShahEnum_u8_SuggestState)
}
;
export const SHAH_ENUM_U8__SUGGEST_STATE_DEF: ShahEnum_u8_SuggestState = 'unknown';
export type ShahEnum_u8_UserHistoryKind = "unknown"|"eatery_view"|"eatery_nav";
export const SHAH_ENUM_U8__USER_HISTORY_KIND = ["unknown","eatery_view","eatery_nav",] as const;
export function is_shah_enum_u8__user_history_kind(value: string): value is ShahEnum_u8_UserHistoryKind {
    return SHAH_ENUM_U8__USER_HISTORY_KIND.includes(value as ShahEnum_u8_UserHistoryKind)
}
;
export const SHAH_ENUM_U8__USER_HISTORY_KIND_DEF: ShahEnum_u8_UserHistoryKind = 'unknown';
export type ShahEnum_u8_UserSavedKind = "unknown"|"eatery"|"dish";
export const SHAH_ENUM_U8__USER_SAVED_KIND = ["unknown","eatery","dish",] as const;
export function is_shah_enum_u8__user_saved_kind(value: string): value is ShahEnum_u8_UserSavedKind {
    return SHAH_ENUM_U8__USER_SAVED_KIND.includes(value as ShahEnum_u8_UserSavedKind)
}
;
export const SHAH_ENUM_U8__USER_SAVED_KIND_DEF: ShahEnum_u8_UserSavedKind = 'unknown';
export type SparkEateryDel = { audience:ShahEnum_u8_EateryAudience,decor:ShahEnum_u8_EateryDecor,domain:ShahEnum_u16_EateryDomain,group:ShahEnum_u8_EateryGroup,location:LocationInfo,name:ShahString,telephone:SeedPhone, };
export const SPARK_EATERY_DEL_DEF: SparkEateryDel = {audience:SHAH_ENUM_U8__EATERY_AUDIENCE_DEF,decor:SHAH_ENUM_U8__EATERY_DECOR_DEF,domain:SHAH_ENUM_U16__EATERY_DOMAIN_DEF,group:SHAH_ENUM_U8__EATERY_GROUP_DEF,location:LOCATION_INFO_DEF,name:SHAH_STRING_DEF,telephone:SEED_PHONE_DEF,};
export type SparkEateryDiscountSet = { new:EateryDiscount,old:EateryDiscount, };
export const SPARK_EATERY_DISCOUNT_SET_DEF: SparkEateryDiscountSet = {new:EATERY_DISCOUNT_DEF,old:EATERY_DISCOUNT_DEF,};
export type SparkEateryEmployeeSet = { new:Employee,old:Employee, };
export const SPARK_EATERY_EMPLOYEE_SET_DEF: SparkEateryEmployeeSet = {new:EMPLOYEE_DEF,old:EMPLOYEE_DEF,};
export type SparkEateryPhotoDel = { pdx:(number), };
export const SPARK_EATERY_PHOTO_DEL_DEF: SparkEateryPhotoDel = {pdx:(0),};
export type SparkEateryPhotoReorder = { new:((Gene[])),old:((Gene[])), };
export const SPARK_EATERY_PHOTO_REORDER_DEF: SparkEateryPhotoReorder = {new:([]),old:([]),};
export type SparkEateryPhotoSet = { pdx:(number), };
export const SPARK_EATERY_PHOTO_SET_DEF: SparkEateryPhotoSet = {pdx:(0),};
export type SparkEateryPhotoWheatSet = { count:(number), };
export const SPARK_EATERY_PHOTO_WHEAT_SET_DEF: SparkEateryPhotoWheatSet = {count:(0),};
export type SparkEateryRecruitLinkSet = { new:RecruitLink,old:RecruitLink, };
export const SPARK_EATERY_RECRUIT_LINK_SET_DEF: SparkEateryRecruitLinkSet = {new:RECRUIT_LINK_DEF,old:RECRUIT_LINK_DEF,};
export type SparkEateryRobTransfer = { rob:(number), };
export const SPARK_EATERY_ROB_TRANSFER_DEF: SparkEateryRobTransfer = {rob:(0),};
export type SparkEaterySubscribed = { kind:ShahEnum_u8_EaterySubscriptionKind,months:(number),rob_cost:(number), };
export const SPARK_EATERY_SUBSCRIBED_DEF: SparkEaterySubscribed = {kind:SHAH_ENUM_U8__EATERY_SUBSCRIPTION_KIND_DEF,months:(0),rob_cost:(0),};
export type SparkEateryUpdateInfoLite = { audience:ShahEnum_u8_EateryAudience,decor:ShahEnum_u8_EateryDecor,domain:ShahEnum_u16_EateryDomain,event:ShahEnum_u16_EateryEvent,flags:EateryFlags,gender_specific:ShahEnum_u8_EateryGenderSpecific,group:ShahEnum_u8_EateryGroup,tables:(number),tags:EateryTags,verified_until:(number), };
export const SPARK_EATERY_UPDATE_INFO_LITE_DEF: SparkEateryUpdateInfoLite = {audience:SHAH_ENUM_U8__EATERY_AUDIENCE_DEF,decor:SHAH_ENUM_U8__EATERY_DECOR_DEF,domain:SHAH_ENUM_U16__EATERY_DOMAIN_DEF,event:SHAH_ENUM_U16__EATERY_EVENT_DEF,flags:EATERY_FLAGS_DEF,gender_specific:SHAH_ENUM_U8__EATERY_GENDER_SPECIFIC_DEF,group:SHAH_ENUM_U8__EATERY_GROUP_DEF,tables:(0),tags:EATERY_TAGS_DEF,verified_until:(0),};
export type SparkEateryUpdateInfo = { new:SparkEateryUpdateInfoLite,old:SparkEateryUpdateInfoLite,wide:Gene, };
export const SPARK_EATERY_UPDATE_INFO_DEF: SparkEateryUpdateInfo = {new:SPARK_EATERY_UPDATE_INFO_LITE_DEF,old:SPARK_EATERY_UPDATE_INFO_LITE_DEF,wide:GENE_DEF,};
export type SparkEateryUpdateInfoWide = { address:(string),alias:(string),best_dish:((Gene[])),name:(string),opening_hours:((((OpenDuration[]))[])),popular_times:(((((number)[]))[])),telephone:SeedPhone, };
export const SPARK_EATERY_UPDATE_INFO_WIDE_DEF: SparkEateryUpdateInfoWide = {address:(''),alias:(''),best_dish:([]),name:(''),opening_hours:([]),popular_times:([]),telephone:SEED_PHONE_DEF,};
export type SparkEateryUpdateInfoWideDiff = { new:SparkEateryUpdateInfoWide,old:SparkEateryUpdateInfoWide, };
export const SPARK_EATERY_UPDATE_INFO_WIDE_DIFF_DEF: SparkEateryUpdateInfoWideDiff = {new:SPARK_EATERY_UPDATE_INFO_WIDE_DEF,old:SPARK_EATERY_UPDATE_INFO_WIDE_DEF,};
export type SparkEateryUpdateLocation = { new_location:LocationInfo,new_zoom:(number),old_location:LocationInfo,old_zoom:(number), };
export const SPARK_EATERY_UPDATE_LOCATION_DEF: SparkEateryUpdateLocation = {new_location:LOCATION_INFO_DEF,new_zoom:(0),old_location:LOCATION_INFO_DEF,old_zoom:(0),};
export type SparkUserEmployed = { eatery:Gene,perms:(((number)[])), };
export const SPARK_USER_EMPLOYED_DEF: SparkUserEmployed = {eatery:GENE_DEF,perms:([]),};
export type SparkUserUpdate = { clear_password:(boolean),delete_photo:(boolean),is_banned:(boolean),new_name:ShahString,new_username:ShahString,old_name:ShahString,old_username:ShahString, };
export const SPARK_USER_UPDATE_DEF: SparkUserUpdate = {clear_password:(false),delete_photo:(false),is_banned:(false),new_name:SHAH_STRING_DEF,new_username:SHAH_STRING_DEF,old_name:SHAH_STRING_DEF,old_username:SHAH_STRING_DEF,};
export type SparkUserAdminSet = { new_perms:(((number)[])),old_perms:(((number)[])), };
export const SPARK_USER_ADMIN_SET_DEF: SparkUserAdminSet = {new_perms:([]),old_perms:([]),};
export type SparkUserCrimeSet = { new_crimes:((UserCrime[])),old_crimes:((UserCrime[])), };
export const SPARK_USER_CRIME_SET_DEF: SparkUserCrimeSet = {new_crimes:([]),old_crimes:([]),};
export type SparkUserRobGift = { from:Gene,rob:(number),transaction:Gene, };
export const SPARK_USER_ROB_GIFT_DEF: SparkUserRobGift = {from:GENE_DEF,rob:(0),transaction:GENE_DEF,};
export type SparkUserRobReward = { _pad:(((number)[])),reason:ShahEnum_u16_RobRewardReason,rob:(number),transaction:Gene, };
export const SPARK_USER_ROB_REWARD_DEF: SparkUserRobReward = {_pad:([]),reason:SHAH_ENUM_U16__ROB_REWARD_REASON_DEF,rob:(0),transaction:GENE_DEF,};
export type SparkKind = ({ kind:("unknown"), })|({ kind:("eatery_add"), })|({ data:SparkEateryDel,kind:("eatery_del"), })|({ data:SparkEateryUpdateInfo,kind:("eatery_update_info"), })|({ data:SparkEateryUpdateLocation,kind:("eatery_update_location"), })|({ data:SparkEateryPhotoSet,kind:("eatery_photo_set"), })|({ data:SparkEateryPhotoDel,kind:("eatery_photo_del"), })|({ data:SparkEateryPhotoReorder,kind:("eatery_photo_reorder"), })|({ data:SparkEateryPhotoWheatSet,kind:("eatery_photo_wheat_set"), })|({ kind:("eatery_trailer_set"), })|({ kind:("eatery_trailer_del"), })|({ data:SparkEateryDiscountSet,kind:("eatery_discount_set"), })|({ data:SparkEaterySubscribed,kind:("eatery_subscribed"), })|({ data:SparkEateryRobTransfer,kind:("eatery_rob_transfer"), })|({ kind:("eatery_request_verification"), })|({ data:Employee,kind:("eatery_employee_add"), })|({ data:SparkEateryEmployeeSet,kind:("eatery_employee_set"), })|({ data:Employee,kind:("eatery_employee_del"), })|({ data:RecruitLink,kind:("eatery_recruit_link_add"), })|({ data:SparkEateryRecruitLinkSet,kind:("eatery_recruit_link_set"), })|({ data:RecruitLink,kind:("eatery_recruit_link_del"), })|({ data:SparkUserEmployed,kind:("user_employed"), })|({ data:SparkUserUpdate,kind:("user_update"), })|({ data:SparkUserAdminSet,kind:("user_admin_set"), })|({ data:SparkUserCrimeSet,kind:("user_crime_set"), })|({ data:SparkUserRobGift,kind:("user_rob_gift"), })|({ data:SparkUserRobReward,kind:("user_rob_reward"), })|({ kind:("suggest_resovled"), })|({ kind:("suggest_deleted"), });
export const SPARK_KIND_DEF: SparkKind = ({kind:('unknown'),});
export type SparkTargetKind = "unknown"|"eatery"|"user"|"suggest";
export const SPARK_TARGET_KIND = ["unknown","eatery","user","suggest",] as const;
export function is_spark_target_kind(value: string): value is SparkTargetKind {
    return SPARK_TARGET_KIND.includes(value as SparkTargetKind)
}
;
export const SPARK_TARGET_KIND_DEF: SparkTargetKind = 'unknown';
export type SparkInfo = SparkKind&({ created_at:(number),ef:EntityFlags,gene:Gene,target:Gene,target_kind:SparkTargetKind,target_next:Gene,target_past:Gene,target_root:Gene,user:Gene,user_next:Gene,user_past:Gene,user_root:Gene, });
export const SPARK_INFO_DEF: SparkInfo = {...SPARK_KIND_DEF,...({created_at:(0),ef:ENTITY_FLAGS_DEF,gene:GENE_DEF,target:GENE_DEF,target_kind:SPARK_TARGET_KIND_DEF,target_next:GENE_DEF,target_past:GENE_DEF,target_root:GENE_DEF,user:GENE_DEF,user_next:GENE_DEF,user_past:GENE_DEF,user_root:GENE_DEF,}),};
export type SparkRoot = { created_at:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,owner:Gene,sparks:(number),tail:Gene, };
export const SPARK_ROOT_DEF: SparkRoot = {created_at:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,owner:GENE_DEF,sparks:(0),tail:GENE_DEF,};
export type SpiceCodeFile = { body:(string),name:(string), };
export const SPICE_CODE_FILE_DEF: SpiceCodeFile = {body:(''),name:(''),};
export type SpiceEateryAnalytics = { a:(number),b:(number),c:(number),count:(number), };
export const SPICE_EATERY_ANALYTICS_DEF: SpiceEateryAnalytics = {a:(0),b:(0),c:(0),count:(0),};
export type SpiceEateryRunOptions = { with_extra:(boolean), };
export const SPICE_EATERY_RUN_OPTIONS_DEF: SpiceEateryRunOptions = {with_extra:(false),};
export type SpiceEateryRunBody = { code:SpiceCodeFile,options:SpiceEateryRunOptions, };
export const SPICE_EATERY_RUN_BODY_DEF: SpiceEateryRunBody = {code:SPICE_CODE_FILE_DEF,options:SPICE_EATERY_RUN_OPTIONS_DEF,};
export type SpiceEateryStateResult = { count:(number),list:((AdminEateryItem[])), };
export const SPICE_EATERY_STATE_RESULT_DEF: SpiceEateryStateResult = {count:(0),list:([]),};
export type SpiceKind = "eatery";
export const SPICE_KIND = ["eatery",] as const;
export function is_spice_kind(value: string): value is SpiceKind {
    return SPICE_KIND.includes(value as SpiceKind)
}
;
export const SPICE_KIND_DEF: SpiceKind = 'eatery';
export type StaffBuySubscription = { months:(number), };
export const STAFF_BUY_SUBSCRIPTION_DEF: StaffBuySubscription = {months:(0),};
export type StaffWarehouseInfo = { discount:EateryDiscount,discounts_active?:((ShahOrigin | null)),discounts_applied?:((ShahOrigin | null)),discounts_holding?:((ShahOrigin | null)),employees?:((ShahBuckle | null)),experience:(number),gene:Gene,recruit_links?:((ShahOrigin | null)),subscription:EaterySubscription,tips?:((EateryTipBuckle | null)),transactions?:((ShahOrigin | null)),verification_request:EateryVerificationRequest,verification_request_status:EateryVerificationRequestStatus,wallet:EateryWallet, };
export const STAFF_WAREHOUSE_INFO_DEF: StaffWarehouseInfo = {discount:EATERY_DISCOUNT_DEF,experience:(0),gene:GENE_DEF,subscription:EATERY_SUBSCRIPTION_DEF,verification_request:EATERY_VERIFICATION_REQUEST_DEF,verification_request_status:EATERY_VERIFICATION_REQUEST_STATUS_DEF,wallet:EATERY_WALLET_DEF,};
export type StaffEateryInfo = { address:(string),alias:(string),audience:EateryAudience,best_dish:([ Gene,Gene,Gene,Gene,Gene, ]),cabbage?:((CabbageOrigin | null)),cabbage_stars:StarRate,calc_zoom:(number),compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,entity_flags:EntityFlags,event:EateryEvent,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,impressions:Gene,last_activity:(number),location:LocationInfo,menu?:((DishOrigin | null)),name:(string),opening_hours?:(((string) | null)),photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),popular_times?:(((string) | null)),price_range:PriceRange,priority:(number),quality_score:(number),review?:((ReviewOrigin | null)),review_count:(number),score:(number),stars:(number),stars_rate:StarRate,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,updated_at:(number),verified_until:(number),warehouse?:((StaffWarehouseInfo | null)),zoom:(number), };
export const STAFF_EATERY_INFO_DEF: StaffEateryInfo = {address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,best_dish:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),cabbage_stars:STAR_RATE_DEF,calc_zoom:(0),compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,entity_flags:ENTITY_FLAGS_DEF,event:EATERY_EVENT_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,impressions:GENE_DEF,last_activity:(0),location:LOCATION_INFO_DEF,name:(''),photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,priority:(0),quality_score:(0),review_count:(0),score:(0),stars:(0),stars_rate:STAR_RATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,updated_at:(0),verified_until:(0),zoom:(0),};
export type StaffEateryItem = { address:(string),alias:(string),audience:EateryAudience,best_dish:([ Gene,Gene,Gene,Gene,Gene, ]),cabbage_stars:StarRate,calc_zoom:(number),compact_gene:CompactGene,decor:EateryDecor,dish_count:(number),domain:EateryDomain,entity_flags:EntityFlags,event:EateryEvent,flags:EateryFlagsInfo,gender_specific:EateryGenderSpecific,gene:Gene,group:EateryGroup,impressions:Gene,last_activity:(number),location:LocationInfo,name:(string),opening_hours?:(((string) | null)),photos:([ Gene,Gene,Gene,Gene,Gene,Gene,Gene, ]),popular_times?:(((string) | null)),price_range:PriceRange,priority:(number),quality_score:(number),review_count:(number),score:(number),stars:(number),stars_rate:StarRate,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,top_impressions:([ EateryImpression,EateryImpression,EateryImpression,EateryImpression, ]),trailer:Gene,updated_at:(number),verified_until:(number),zoom:(number), };
export const STAFF_EATERY_ITEM_DEF: StaffEateryItem = {address:(''),alias:(''),audience:EATERY_AUDIENCE_DEF,best_dish:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),cabbage_stars:STAR_RATE_DEF,calc_zoom:(0),compact_gene:COMPACT_GENE_DEF,decor:EATERY_DECOR_DEF,dish_count:(0),domain:EATERY_DOMAIN_DEF,entity_flags:ENTITY_FLAGS_DEF,event:EATERY_EVENT_DEF,flags:EATERY_FLAGS_INFO_DEF,gender_specific:EATERY_GENDER_SPECIFIC_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,impressions:GENE_DEF,last_activity:(0),location:LOCATION_INFO_DEF,name:(''),photos:([GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,GENE_DEF,]),price_range:PRICE_RANGE_DEF,priority:(0),quality_score:(0),review_count:(0),score:(0),stars:(0),stars_rate:STAR_RATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,top_impressions:([EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,EATERY_IMPRESSION_DEF,]),trailer:GENE_DEF,updated_at:(0),verified_until:(0),zoom:(0),};
export type StaffEateryReorderPhotosBody = { photos:([ ((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)), ]), };
export const STAFF_EATERY_REORDER_PHOTOS_BODY_DEF: StaffEateryReorderPhotosBody = {photos:([(null),(null),(null),(null),(null),(null),(null),]),};
export type StaffEaterySetPhoto = { photo:(File), };
export const STAFF_EATERY_SET_PHOTO_DEF: StaffEaterySetPhoto = {photo:(new File([], '')),};
export type StaffEaterySetTrailer = { video:(File), };
export const STAFF_EATERY_SET_TRAILER_DEF: StaffEaterySetTrailer = {video:(new File([], '')),};
export type StaffEateryUpdateInfoBody = { address?:(((string) | null)),alias?:(((string) | null)),audience?:((EateryAudience | null)),best_dish?:((([ ((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)), ]) | null)),decor?:((EateryDecor | null)),domain?:((EateryDomain | null)),event?:((EateryEvent | null)),flags?:((EateryFlagsInput | null)),gender_specific?:((EateryGenderSpecific | null)),group?:((EateryGroup | null)),name?:(((string) | null)),opening_hours?:((([ ((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])), ]) | null)),popular_times?:((([ (((number)[])),(((number)[])),(((number)[])),(((number)[])),(((number)[])),(((number)[])),(((number)[])), ]) | null)),tables?:(((number) | null)),tags?:((EateryTagsInput | null)),telephone?:((SeedPhone | null)), };
export const STAFF_EATERY_UPDATE_INFO_BODY_DEF: StaffEateryUpdateInfoBody = {};
export type StaffRecruitLinkList = { list:((RecruitLink[])),pond:ShahPond, };
export const STAFF_RECRUIT_LINK_LIST_DEF: StaffRecruitLinkList = {list:([]),pond:SHAH_POND_DEF,};
export type StaffRequestTokenInfo = { eatery:Gene,expires_at:(number),perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]),token:(string), };
export const STAFF_REQUEST_TOKEN_INFO_DEF: StaffRequestTokenInfo = {eatery:GENE_DEF,expires_at:(0),perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),token:(''),};
export type StaffSessionInfo = { expires_at:(number),perms:(((number)[])),user:UserCard, };
export const STAFF_SESSION_INFO_DEF: StaffSessionInfo = {expires_at:(0),perms:([]),user:USER_CARD_DEF,};
export type StaffSetEmployeeBody = { perms:([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]), };
export const STAFF_SET_EMPLOYEE_BODY_DEF: StaffSetEmployeeBody = {perms:([(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),(0),]),};
export type StaffUpdateDishBody = { combo:DishKind,daily?:((DishDailyInput | null)),flags?:((DishFlagsInput | null)),kind:DishKind,name:(string),note:(string),price:(number),tags?:((DishTagsInput | null)), };
export const STAFF_UPDATE_DISH_BODY_DEF: StaffUpdateDishBody = {combo:DISH_KIND_DEF,kind:DISH_KIND_DEF,name:(''),note:(''),price:(0),};
export type StaffUpdateRecruitLinkBody = { expires_at?:(((number) | null)),limit?:(((number) | null)),perms?:((([ (number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number),(number), ]) | null)), };
export const STAFF_UPDATE_RECRUIT_LINK_BODY_DEF: StaffUpdateRecruitLinkBody = {};
export type StaffWarehouseItem = { discount:EateryDiscount,experience:(number),gene:Gene,subscription:EaterySubscription,verification_request:EateryVerificationRequest,verification_request_status:EateryVerificationRequestStatus,wallet:EateryWallet, };
export const STAFF_WAREHOUSE_ITEM_DEF: StaffWarehouseItem = {discount:EATERY_DISCOUNT_DEF,experience:(0),gene:GENE_DEF,subscription:EATERY_SUBSCRIPTION_DEF,verification_request:EATERY_VERIFICATION_REQUEST_DEF,verification_request_status:EATERY_VERIFICATION_REQUEST_STATUS_DEF,wallet:EATERY_WALLET_DEF,};
export type SuggestAddBody = { eatery?:((Gene | null)),kind:SuggestKind, };
export const SUGGEST_ADD_BODY_DEF: SuggestAddBody = {kind:SUGGEST_KIND_DEF,};
export type SuggestDishSetPhoto = { photo:(File), };
export const SUGGEST_DISH_SET_PHOTO_DEF: SuggestDishSetPhoto = {photo:(new File([], '')),};
export type SuggestDishUpdateBody = { combo:DishKind,daily?:((DishDailyInput | null)),flags?:((DishFlagsInput | null)),kind:DishKind,name:(string),note:(string),price:(number),tags?:((DishTagsInput | null)), };
export const SUGGEST_DISH_UPDATE_BODY_DEF: SuggestDishUpdateBody = {combo:DISH_KIND_DEF,kind:DISH_KIND_DEF,name:(''),note:(''),price:(0),};
export type SuggestIncorrectInput = { incorrect_audience?:(((boolean) | null)),incorrect_best_dishes?:(((boolean) | null)),incorrect_decor?:(((boolean) | null)),incorrect_domain?:(((boolean) | null)),incorrect_group?:(((boolean) | null)),incorrect_menu?:(((boolean) | null)),incorrect_opening_hours?:(((boolean) | null)),incorrect_phone?:(((boolean) | null)),incorrect_photos?:(((boolean) | null)), };
export const SUGGEST_INCORRECT_INPUT_DEF: SuggestIncorrectInput = {};
export type SuggestInfo = { audience:EateryAudience,best_dish:((Gene[])),created_at:(number),decor:EateryDecor,detail:Gene,domain:EateryDomain,eatery:Gene,ef:EntityFlags,flags:SuggestFlagsInfo,gene:Gene,group:EateryGroup,incorrect:SuggestIncorrectInfo,kind:SuggestKind,location:LocationInfo,menu?:((SuggestDishOrigin | null)),menu_photos:((Gene[])),name:(string),opening_hours?:(((string) | null)),pending_at:(number),photos:((Gene[])),rating:(number),resolve_at:(number),state:SuggestState,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,user:Gene,user_suggest:Gene, };
export const SUGGEST_INFO_DEF: SuggestInfo = {audience:EATERY_AUDIENCE_DEF,best_dish:([]),created_at:(0),decor:EATERY_DECOR_DEF,detail:GENE_DEF,domain:EATERY_DOMAIN_DEF,eatery:GENE_DEF,ef:ENTITY_FLAGS_DEF,flags:SUGGEST_FLAGS_INFO_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,incorrect:SUGGEST_INCORRECT_INFO_DEF,kind:SUGGEST_KIND_DEF,location:LOCATION_INFO_DEF,menu_photos:([]),name:(''),pending_at:(0),photos:([]),rating:(0),resolve_at:(0),state:SUGGEST_STATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,user:GENE_DEF,user_suggest:GENE_DEF,};
export type SuggestItem = { audience:EateryAudience,best_dish:((Gene[])),created_at:(number),decor:EateryDecor,detail:Gene,domain:EateryDomain,eatery:Gene,ef:EntityFlags,flags:SuggestFlagsInfo,gene:Gene,group:EateryGroup,incorrect:SuggestIncorrectInfo,kind:SuggestKind,location:LocationInfo,menu:Gene,menu_photos:((Gene[])),name:(string),opening_hours?:(((string) | null)),pending_at:(number),photos:((Gene[])),rating:(number),resolve_at:(number),state:SuggestState,tables:(number),tags:EateryTagsInfo,telephone:SeedPhone,user:Gene,user_suggest:Gene, };
export const SUGGEST_ITEM_DEF: SuggestItem = {audience:EATERY_AUDIENCE_DEF,best_dish:([]),created_at:(0),decor:EATERY_DECOR_DEF,detail:GENE_DEF,domain:EATERY_DOMAIN_DEF,eatery:GENE_DEF,ef:ENTITY_FLAGS_DEF,flags:SUGGEST_FLAGS_INFO_DEF,gene:GENE_DEF,group:EATERY_GROUP_DEF,incorrect:SUGGEST_INCORRECT_INFO_DEF,kind:SUGGEST_KIND_DEF,location:LOCATION_INFO_DEF,menu:GENE_DEF,menu_photos:([]),name:(''),pending_at:(0),photos:([]),rating:(0),resolve_at:(0),state:SUGGEST_STATE_DEF,tables:(0),tags:EATERY_TAGS_INFO_DEF,telephone:SEED_PHONE_DEF,user:GENE_DEF,user_suggest:GENE_DEF,};
export type SuggestPhotoOptions = { for_menu?:(boolean), };
export const SUGGEST_PHOTO_OPTIONS_DEF: SuggestPhotoOptions = {};
export type SuggestResolveBody = { eatery:Gene,rating:(number), };
export const SUGGEST_RESOLVE_BODY_DEF: SuggestResolveBody = {eatery:GENE_DEF,rating:(0),};
export type SuggestRoot = { draft:ShahBuckle,pending:ShahBuckle,resolved:ShahBuckle, };
export const SUGGEST_ROOT_DEF: SuggestRoot = {draft:SHAH_BUCKLE_DEF,pending:SHAH_BUCKLE_DEF,resolved:SHAH_BUCKLE_DEF,};
export type SuggestSetPhotoBody = { options:SuggestPhotoOptions,photo:(File), };
export const SUGGEST_SET_PHOTO_BODY_DEF: SuggestSetPhotoBody = {options:SUGGEST_PHOTO_OPTIONS_DEF,photo:(new File([], '')),};
export type Topic = { created_at:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,members:((Gene[])),message_count:(number),message_sync:(number),owner:Gene,pinned_messages:((Gene[])),pond_count:(number),storage:(number),tail:Gene,title:ShahString, };
export const TOPIC_DEF: Topic = {created_at:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,members:([]),message_count:(0),message_sync:(0),owner:GENE_DEF,pinned_messages:([]),pond_count:(0),storage:(0),tail:GENE_DEF,title:SHAH_STRING_DEF,};
export type TopicInfo = { gene:Gene,growth:(number),head:Gene,members:((UserCard[])),message_count:(number),message_sync:(number),owner?:((UserCard | null)),pinned_messages:((Gene[])),pond_count:(number),storage:(number),tail:Gene,title:(string), };
export const TOPIC_INFO_DEF: TopicInfo = {gene:GENE_DEF,growth:(0),head:GENE_DEF,members:([]),message_count:(0),message_sync:(0),pinned_messages:([]),pond_count:(0),storage:(0),tail:GENE_DEF,title:(''),};
export type TopicMediaInfo = ({ gene:Gene,height:(number),kind:("image"),size:(number),width:(number), })|({ duration:(number),gene:Gene,height:(number),kind:("video"),size:(number),width:(number), });
export const TOPIC_MEDIA_INFO_DEF: TopicMediaInfo = ({gene:GENE_DEF,height:(0),kind:('image'),size:(0),width:(0),});
export type TopicMessageAddDocumentInfo = { reply_to?:((Gene | null)), };
export const TOPIC_MESSAGE_ADD_DOCUMENT_INFO_DEF: TopicMessageAddDocumentInfo = {};
export type TopicMessageAddDocumentBody = { files:(((File)[])),info:TopicMessageAddDocumentInfo, };
export const TOPIC_MESSAGE_ADD_DOCUMENT_BODY_DEF: TopicMessageAddDocumentBody = {files:([]),info:TOPIC_MESSAGE_ADD_DOCUMENT_INFO_DEF,};
export type TopicMessageAddMediaInfo = { caption:(string),reply_to?:((Gene | null)), };
export const TOPIC_MESSAGE_ADD_MEDIA_INFO_DEF: TopicMessageAddMediaInfo = {caption:(''),};
export type TopicMessageAddMediaBody = { info:TopicMessageAddMediaInfo,media:(((File)[])), };
export const TOPIC_MESSAGE_ADD_MEDIA_BODY_DEF: TopicMessageAddMediaBody = {info:TOPIC_MESSAGE_ADD_MEDIA_INFO_DEF,media:([]),};
export type TopicMessageAddTextBody = { reply_to?:((Gene | null)),text:(string), };
export const TOPIC_MESSAGE_ADD_TEXT_BODY_DEF: TopicMessageAddTextBody = {text:(''),};
export type TopicMessageAddVoiceInfo = { reply_to?:((Gene | null)), };
export const TOPIC_MESSAGE_ADD_VOICE_INFO_DEF: TopicMessageAddVoiceInfo = {};
export type TopicMessageAddVoiceBody = { info:TopicMessageAddVoiceInfo,voice:(File), };
export const TOPIC_MESSAGE_ADD_VOICE_BODY_DEF: TopicMessageAddVoiceBody = {info:TOPIC_MESSAGE_ADD_VOICE_INFO_DEF,voice:(new File([], '')),};
export type TopicMessageEditResult = { edited_at:(number), };
export const TOPIC_MESSAGE_EDIT_RESULT_DEF: TopicMessageEditResult = {edited_at:(0),};
export type TopicMessageEditTextBody = { text:(string), };
export const TOPIC_MESSAGE_EDIT_TEXT_BODY_DEF: TopicMessageEditTextBody = {text:(''),};
export type TopicMessageKindInfo = ({ kind:("text"),text:(string), })|({ audio:Gene,duration:(number),kind:("voice"), })|({ caption:(string),kind:("media"),media:((TopicMediaInfo[])), })|({ files:((Record[])),kind:("document"), });
export const TOPIC_MESSAGE_KIND_INFO_DEF: TopicMessageKindInfo = ({kind:('text'),text:(''),});
export type TopicMessageInfo = TopicMessageKindInfo&({ created_at:(number),edited_at:(number),file_size:(number),gene:Gene,growth:(number),pond:Gene,read_at:(number),reply_to:Gene,sync:(number),user?:((UserCard | null)), });
export const TOPIC_MESSAGE_INFO_DEF: TopicMessageInfo = {...TOPIC_MESSAGE_KIND_INFO_DEF,...({created_at:(0),edited_at:(0),file_size:(0),gene:GENE_DEF,growth:(0),pond:GENE_DEF,read_at:(0),reply_to:GENE_DEF,sync:(0),}),};
export type TopicMessageList = { list:((TopicMessageInfo[])),pond:ShahPond, };
export const TOPIC_MESSAGE_LIST_DEF: TopicMessageList = {list:([]),pond:SHAH_POND_DEF,};
export type TopicUpdateBody = { title?:(((string) | null)), };
export const TOPIC_UPDATE_BODY_DEF: TopicUpdateBody = {};
export type UpdateDishBody = { combo:DishKind,daily?:((DishDailyInput | null)),flags?:((DishFlagsInput | null)),kind:DishKind,name:(string),note:(string),price:(number),tags?:((DishTagsInput | null)), };
export const UPDATE_DISH_BODY_DEF: UpdateDishBody = {combo:DISH_KIND_DEF,kind:DISH_KIND_DEF,name:(''),note:(''),price:(0),};
export type UpdateKhabar = { flags:KhabarFlagsInput, };
export const UPDATE_KHABAR_DEF: UpdateKhabar = {flags:KHABAR_FLAGS_INPUT_DEF,};
export type UpdatePhoto = { photo:(File), };
export const UPDATE_PHOTO_DEF: UpdatePhoto = {photo:(new File([], '')),};
export type UpdateReviewBody = { state:ReviewState, };
export const UPDATE_REVIEW_BODY_DEF: UpdateReviewBody = {state:REVIEW_STATE_DEF,};
export type UserHistoryList = { buckle:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),kind:ShahEnum_u8_UserHistoryKind,list:((HistoryItem[])),next:Gene,past:Gene,timestamp:(number),user:Gene, };
export const USER_HISTORY_LIST_DEF: UserHistoryList = {buckle:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),kind:SHAH_ENUM_U8__USER_HISTORY_KIND_DEF,list:([]),next:GENE_DEF,past:GENE_DEF,timestamp:(0),user:GENE_DEF,};
export type UserImpression = { eatery:Gene,impression:(number),timestamp:(number), };
export const USER_IMPRESSION_DEF: UserImpression = {eatery:GENE_DEF,impression:(0),timestamp:(0),};
export type UserIssueReqEatOwnStatus = "none"|"pending"|"resolved"|"rejected";
export const USER_ISSUE_REQ_EAT_OWN_STATUS = ["none","pending","resolved","rejected",] as const;
export function is_user_issue_req_eat_own_status(value: string): value is UserIssueReqEatOwnStatus {
    return USER_ISSUE_REQ_EAT_OWN_STATUS.includes(value as UserIssueReqEatOwnStatus)
}
;
export const USER_ISSUE_REQ_EAT_OWN_STATUS_DEF: UserIssueReqEatOwnStatus = 'none';
export type UserIssueRequestTicketStatus = "none"|"pending"|"resolved"|"rejected";
export const USER_ISSUE_REQUEST_TICKET_STATUS = ["none","pending","resolved","rejected",] as const;
export function is_user_issue_request_ticket_status(value: string): value is UserIssueRequestTicketStatus {
    return USER_ISSUE_REQUEST_TICKET_STATUS.includes(value as UserIssueRequestTicketStatus)
}
;
export const USER_ISSUE_REQUEST_TICKET_STATUS_DEF: UserIssueRequestTicketStatus = 'none';
export type UserItemDiscountApplied = { _pad:(((number)[])),applied_at:(number),eatery:Gene,percentage:(number),rob_price:(number),shadow:Gene, };
export const USER_ITEM_DISCOUNT_APPLIED_DEF: UserItemDiscountApplied = {_pad:([]),applied_at:(0),eatery:GENE_DEF,percentage:(0),rob_price:(0),shadow:GENE_DEF,};
export type UserItemDiscountHolding = { _pad:(((number)[])),code:ShahString,eatery:Gene,expires_at:(number),is_active:(boolean),max_amount:(number),min_order:(number),percentage:(number),rob_price:(number),shadow:Gene,starts_at:(number), };
export const USER_ITEM_DISCOUNT_HOLDING_DEF: UserItemDiscountHolding = {_pad:([]),code:SHAH_STRING_DEF,eatery:GENE_DEF,expires_at:(0),is_active:(false),max_amount:(0),min_order:(0),percentage:(0),rob_price:(0),shadow:GENE_DEF,starts_at:(0),};
export type UserItemKind = ({ kind:("unknown"), })|(UserItemDiscountHolding&({ kind:("discount_holding"), }))|(UserItemDiscountApplied&({ kind:("discount_applied"), }));
export const USER_ITEM_KIND_DEF: UserItemKind = ({kind:('unknown'),});
export type UserItemInfo = UserItemKind&({ created_at:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),pond:Gene,user:Gene, });
export const USER_ITEM_INFO_DEF: UserItemInfo = {...USER_ITEM_KIND_DEF,...({created_at:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),pond:GENE_DEF,user:GENE_DEF,}),};
export type UserItemListInfo = { eateries:((EateryCard[])),list:((UserItemInfo[])),next:Gene,past:Gene, };
export const USER_ITEM_LIST_INFO_DEF: UserItemListInfo = {eateries:([]),list:([]),next:GENE_DEF,past:GENE_DEF,};
export type UserNetworkList = { buckle:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),list:((NetworkItemInfo[])),next:Gene,past:Gene,user:Gene, };
export const USER_NETWORK_LIST_DEF: UserNetworkList = {buckle:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),list:([]),next:GENE_DEF,past:GENE_DEF,user:GENE_DEF,};
export type UserNotificationCrimeCommitted = { cause:ShahEnum_u16_UserCrimeCause,severity:(number), };
export const USER_NOTIFICATION_CRIME_COMMITTED_DEF: UserNotificationCrimeCommitted = {cause:SHAH_ENUM_U16__USER_CRIME_CAUSE_DEF,severity:(0),};
export type UserNotificationCrimePardoned = { cause:ShahEnum_u16_UserCrimeCause,severity:(number), };
export const USER_NOTIFICATION_CRIME_PARDONED_DEF: UserNotificationCrimePardoned = {cause:SHAH_ENUM_U16__USER_CRIME_CAUSE_DEF,severity:(0),};
export type UserNotificationEateryTipRead = { eatery:Gene,tip:Gene, };
export const USER_NOTIFICATION_EATERY_TIP_READ_DEF: UserNotificationEateryTipRead = {eatery:GENE_DEF,tip:GENE_DEF,};
export type UserNotificationFeedbackUpdate = { feedback:Gene,feedback_kind:ShahEnum_u8_FeedbackKind,status:ShahEnum_u8_FeedbackStatus, };
export const USER_NOTIFICATION_FEEDBACK_UPDATE_DEF: UserNotificationFeedbackUpdate = {feedback:GENE_DEF,feedback_kind:SHAH_ENUM_U8__FEEDBACK_KIND_DEF,status:SHAH_ENUM_U8__FEEDBACK_STATUS_DEF,};
export type UserNotificationFriendInvite = { user:Gene, };
export const USER_NOTIFICATION_FRIEND_INVITE_DEF: UserNotificationFriendInvite = {user:GENE_DEF,};
export type UserNotificationRobGift = { from:Gene,rob:(number), };
export const USER_NOTIFICATION_ROB_GIFT_DEF: UserNotificationRobGift = {from:GENE_DEF,rob:(0),};
export type UserNotificationTopicAdded = { topic:Gene, };
export const USER_NOTIFICATION_TOPIC_ADDED_DEF: UserNotificationTopicAdded = {topic:GENE_DEF,};
export type UserNotificationTopicKicked = { topic:Gene, };
export const USER_NOTIFICATION_TOPIC_KICKED_DEF: UserNotificationTopicKicked = {topic:GENE_DEF,};
export type UserNotificationRequestEateryOwnershipResponse = { eatery:Gene,status:ShahEnum_u8_UserIssueReqEatOwnStatus, };
export const USER_NOTIFICATION_REQUEST_EATERY_OWNERSHIP_RESPONSE_DEF: UserNotificationRequestEateryOwnershipResponse = {eatery:GENE_DEF,status:SHAH_ENUM_U8__USER_ISSUE_REQ_EAT_OWN_STATUS_DEF,};
export type UserNotificationRequestTicketResponse = { status:ShahEnum_u8_UserIssueRequestTicketStatus, };
export const USER_NOTIFICATION_REQUEST_TICKET_RESPONSE_DEF: UserNotificationRequestTicketResponse = {status:SHAH_ENUM_U8__USER_ISSUE_REQUEST_TICKET_STATUS_DEF,};
export type UserNotificationRequestEateryVerificationResponse = { eatery:Gene,status:ShahEnum_u8_EateryVerificationRequestStatus, };
export const USER_NOTIFICATION_REQUEST_EATERY_VERIFICATION_RESPONSE_DEF: UserNotificationRequestEateryVerificationResponse = {eatery:GENE_DEF,status:SHAH_ENUM_U8__EATERY_VERIFICATION_REQUEST_STATUS_DEF,};
export type UserNotificationTransactionFailed = { transaction:Gene, };
export const USER_NOTIFICATION_TRANSACTION_FAILED_DEF: UserNotificationTransactionFailed = {transaction:GENE_DEF,};
export type UserNotificationSuggestUpdate = { eatery:Gene,rating:(number),state:ShahEnum_u8_SuggestState,suggest:Gene,suggest_kind:ShahEnum_u8_SuggestKind, };
export const USER_NOTIFICATION_SUGGEST_UPDATE_DEF: UserNotificationSuggestUpdate = {eatery:GENE_DEF,rating:(0),state:SHAH_ENUM_U8__SUGGEST_STATE_DEF,suggest:GENE_DEF,suggest_kind:SHAH_ENUM_U8__SUGGEST_KIND_DEF,};
export type UserNotificationRobReward = { reason:ShahEnum_u16_RobRewardReason,rob:(number), };
export const USER_NOTIFICATION_ROB_REWARD_DEF: UserNotificationRobReward = {reason:SHAH_ENUM_U16__ROB_REWARD_REASON_DEF,rob:(0),};
export type UserNotificationKind = ({ kind:("unknown"), })|(UserNotificationRobGift&({ kind:("rob_gift"), }))|(UserNotificationTopicAdded&({ kind:("topic_added"), }))|(UserNotificationTopicKicked&({ kind:("topic_kicked"), }))|(UserNotificationRequestEateryOwnershipResponse&({ kind:("request_eatery_ownership_response"), }))|(UserNotificationRequestTicketResponse&({ kind:("request_ticket_response"), }))|(UserNotificationRequestEateryVerificationResponse&({ kind:("request_eatery_verification_response"), }))|(UserNotificationTransactionFailed&({ kind:("transaction_failed"), }))|(UserNotificationFeedbackUpdate&({ kind:("feedback_update"), }))|(UserNotificationSuggestUpdate&({ kind:("suggest_update"), }))|(UserNotificationRobReward&({ kind:("rob_reward"), }))|(UserNotificationEateryTipRead&({ kind:("eatery_tip_read"), }))|(UserNotificationFriendInvite&({ kind:("friend_invite"), }))|(UserNotificationCrimeCommitted&({ kind:("crime_committed"), }))|(UserNotificationCrimePardoned&({ kind:("crime_pardoned"), }));
export const USER_NOTIFICATION_KIND_DEF: UserNotificationKind = ({kind:('unknown'),});
export type UserNotificationInfo = UserNotificationKind&({ created_at:(number),read_at:(number), });
export const USER_NOTIFICATION_INFO_DEF: UserNotificationInfo = {...USER_NOTIFICATION_KIND_DEF,...({created_at:(0),read_at:(0),}),};
export type UserNotificationListInfo = { eateries:((EateryCard[])),eatery_tips:((EateryTip[])),feedbacks:((Feedback[])),list:((UserNotificationInfo[])),topics:((Topic[])),users:((UserCard[])), };
export const USER_NOTIFICATION_LIST_INFO_DEF: UserNotificationListInfo = {eateries:([]),eatery_tips:([]),feedbacks:([]),list:([]),topics:([]),users:([]),};
export type UserProfileInfo = { birth_date:(number),created_at:(number),gender:UserGender,gene:Gene,name:(string),online_at:(number),photo:Gene,review?:((UserReviewOrigin | null)),username:(string), };
export const USER_PROFILE_INFO_DEF: UserProfileInfo = {birth_date:(0),created_at:(0),gender:USER_GENDER_DEF,gene:GENE_DEF,name:(''),online_at:(0),photo:GENE_DEF,username:(''),};
export type UserReviewInfo = { detail:Gene,eatery?:((EateryCard | null)),eatery_review:Gene,entity_flags:EntityFlags,gene:Gene,issue:Gene,pond:Gene,star_food:(number),star_service:(number),star_vibe:(number),state:ReviewState,summary:(string),timestamp:(number),user:Gene, };
export const USER_REVIEW_INFO_DEF: UserReviewInfo = {detail:GENE_DEF,eatery_review:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,issue:GENE_DEF,pond:GENE_DEF,star_food:(0),star_service:(0),star_vibe:(0),state:REVIEW_STATE_DEF,summary:(''),timestamp:(0),user:GENE_DEF,};
export type UserReviewList = { list:((UserReviewInfo[])),next:Gene,past:Gene, };
export const USER_REVIEW_LIST_DEF: UserReviewList = {list:([]),next:GENE_DEF,past:GENE_DEF,};
export type UserSaved = { buckle:Gene,entity_flags:EntityFlags,gene:Gene,growth:(number),kind:ShahEnum_u8_UserSavedKind,next:Gene,past:Gene,saved:((Gene[])),user:Gene, };
export const USER_SAVED_DEF: UserSaved = {buckle:GENE_DEF,entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),kind:SHAH_ENUM_U8__USER_SAVED_KIND_DEF,next:GENE_DEF,past:GENE_DEF,saved:([]),user:GENE_DEF,};
export type UserSavedKind = "unknown"|"eatery"|"dish";
export const USER_SAVED_KIND = ["unknown","eatery","dish",] as const;
export function is_user_saved_kind(value: string): value is UserSavedKind {
    return USER_SAVED_KIND.includes(value as UserSavedKind)
}
;
export const USER_SAVED_KIND_DEF: UserSavedKind = 'unknown';
export type UserSearch = { _geo:GeoSearch,birth_date:(number),cc:(number),created_at:(number),gender:UserGender,gene:Gene,is_banned:(boolean),is_jailed:(boolean),name:(string),online_at:(number),phone:(string),photo:Gene,username:(string),wallet:UserWallet, };
export const USER_SEARCH_DEF: UserSearch = {_geo:GEO_SEARCH_DEF,birth_date:(0),cc:(0),created_at:(0),gender:USER_GENDER_DEF,gene:GENE_DEF,is_banned:(false),is_jailed:(false),name:(''),online_at:(0),phone:(''),photo:GENE_DEF,username:(''),wallet:USER_WALLET_DEF,};
export type UserSuggestInfo = { created_at:(number),eatery?:((EateryCard | null)),ef:EntityFlags,gene:Gene,kind:SuggestKind,pending_at:(number),pond:Gene,rating:(number),resolve_at:(number),state:SuggestState,suggest?:((SuggestItem | null)),suggest_gene:Gene,user:Gene, };
export const USER_SUGGEST_INFO_DEF: UserSuggestInfo = {created_at:(0),ef:ENTITY_FLAGS_DEF,gene:GENE_DEF,kind:SUGGEST_KIND_DEF,pending_at:(0),pond:GENE_DEF,rating:(0),resolve_at:(0),state:SUGGEST_STATE_DEF,suggest_gene:GENE_DEF,user:GENE_DEF,};
export type UserSuggestList = { list:((UserSuggestInfo[])),next:Gene,past:Gene, };
export const USER_SUGGEST_LIST_DEF: UserSuggestList = {list:([]),next:GENE_DEF,past:GENE_DEF,};
export type UserTaskUpdateBody = { clear_ap_no_pass:(boolean),reset_all_sessions:(boolean),search:(boolean),tiles:(boolean), };
export const USER_TASK_UPDATE_BODY_DEF: UserTaskUpdateBody = {clear_ap_no_pass:(false),reset_all_sessions:(false),search:(false),tiles:(false),};
export type UserTransactionListInfo = { eateries:((EateryCard[])),list:((UserTransactionInfo[])),next:Gene,past:Gene,users:((UserCard[])), };
export const USER_TRANSACTION_LIST_INFO_DEF: UserTransactionListInfo = {eateries:([]),list:([]),next:GENE_DEF,past:GENE_DEF,users:([]),};
export type UserUpdateBody = { birth_date?:(((number) | null)),gender?:((UserGender | null)),home_location?:((LocationInput | null)),name?:(((string) | null)),username?:(((string) | null)), };
export const USER_UPDATE_BODY_DEF: UserUpdateBody = {};
export type UserUpdateSuggestBody = { alias?:(((string) | null)),audience?:((EateryAudience | null)),best_dish?:((([ ((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)),((Gene | null)), ]) | null)),decor?:((EateryDecor | null)),domain?:((EateryDomain | null)),gender_specific?:((EateryGenderSpecific | null)),group?:((EateryGroup | null)),incorrect?:((SuggestIncorrectInput | null)),is_24_7?:(((boolean) | null)),location?:((LocationInput | null)),name?:(((string) | null)),opening_hours?:((([ ((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])),((OpenDuration[])), ]) | null)),tables?:(((number) | null)),tags?:((EateryTagsInput | null)),telephone?:((SeedPhone | null)), };
export const USER_UPDATE_SUGGEST_BODY_DEF: UserUpdateSuggestBody = {};
export type VerificationData = { action:VerificationAction,telephone:SeedPhone, };
export const VERIFICATION_DATA_DEF: VerificationData = {action:VERIFICATION_ACTION_DEF,telephone:SEED_PHONE_DEF,};
export type VerificationTimes = { last_code_expires:(number),next_resend?:(((number) | null)),verify_expires:(number), };
export const VERIFICATION_TIMES_DEF: VerificationTimes = {last_code_expires:(0),verify_expires:(0),};
export type VerifyPasswordBody = { gene:Gene,password:(string),secret:(string), };
export const VERIFY_PASSWORD_BODY_DEF: VerifyPasswordBody = {gene:GENE_DEF,password:(''),secret:(''),};
export type WalletBuyRobBody = { next?:(((string) | null)),provider:IrrProvider,rob:(number), };
export const WALLET_BUY_ROB_BODY_DEF: WalletBuyRobBody = {provider:IRR_PROVIDER_DEF,rob:(0),};
export type WalletChargeBody = { irr:(number),next?:(((string) | null)),provider:IrrProvider, };
export const WALLET_CHARGE_BODY_DEF: WalletChargeBody = {irr:(0),provider:IRR_PROVIDER_DEF,};
export type WalletIrrResponse = { redirect:(string), };
export const WALLET_IRR_RESPONSE_DEF: WalletIrrResponse = {redirect:(''),};
export type WheatInfo = { opening_hours?:((((((OpenDuration[]))[])) | null)),permanent_close:(boolean),pops?:(((((((number)[]))[])) | null)),tags?:((EateryTags | null)), };
export const WHEAT_INFO_DEF: WheatInfo = {permanent_close:(false),};
export type XenosBuckle = { chunks:(number),entity_flags:EntityFlags,gene:Gene,growth:(number),head:Gene,length:(number),owner:Gene,owner_kind:ShahEnum_u16_XenosOwnerKind,tail:Gene, };
export const XENOS_BUCKLE_DEF: XenosBuckle = {chunks:(0),entity_flags:ENTITY_FLAGS_DEF,gene:GENE_DEF,growth:(0),head:GENE_DEF,length:(0),owner:GENE_DEF,owner_kind:SHAH_ENUM_U16__XENOS_OWNER_KIND_DEF,tail:GENE_DEF,};
/**
Clear SSR Cache

*/
export async function api_admin_abzar_clear_ssr_cache_post (body: AbzarClearSsrCacheBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/clear-ssr-cache/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Get I Eat Wheat

*/
export async function api_admin_abzar_i_eat_wheat_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/i-eat-wheat/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Wheat Cookie Get

*/
export async function api_admin_abzar_wheat_cookie_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/wheat-cookie/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Wheat Cookie Set

*/
export async function api_admin_abzar_wheat_cookie_put (body: (string), override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = body;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/wheat-cookie/`,
        method: 'PUT',
        params: {  },
        headers: { 'Content-Type': 'text/plain', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Wheat Info

*/
export async function api_admin_abzar_wheat_info_post (body: AbzarWheatFetchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<WheatInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/wheat-info/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<WheatInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<WheatInfo>

}
/**
Wheat Media

*/
export async function api_admin_abzar_wheat_media_post (body: AbzarWheatFetchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EEWheatMedia[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/wheat-media/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EEWheatMedia[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EEWheatMedia[]))>

}
/**
Wheat Reviews

*/
export async function api_admin_abzar_wheat_reviews_post (body: AbzarWheatFetchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((CabbageData[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/abzar/wheat-reviews/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((CabbageData[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((CabbageData[]))>

}
/**
List

*/
export async function api_admin_akhbar_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((KhabarInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/akhbar/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((KhabarInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((KhabarInfo[]))>

}
/**
Add

*/
export async function api_admin_akhbar_post (body: AddKhabar, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminKhabarInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/akhbar/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminKhabarInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminKhabarInfo>

}
/**
Count

*/
export async function api_admin_akhbar_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/akhbar/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Update

*/
export async function api_admin_akhbar_patch (params: {gene:GeneInput,}, body: UpdateKhabar, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminKhabarInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/akhbar/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminKhabarInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminKhabarInfo>

}
/**
Analytics Root

*/
export async function api_admin_analytics_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AnalyticsRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/analytics/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AnalyticsRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AnalyticsRoot>

}
/**
State

*/
export async function api_admin_analytics_state_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AnalyticsStateInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/analytics/state/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AnalyticsStateInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AnalyticsStateInfo>

}
/**
Eatery Stats

*/
export async function api_admin_analytics_state_eateries_stats_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(_Map<AnalyticsEateriesStats>)>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/analytics/state/eateries-stats/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(_Map<AnalyticsEateriesStats>)> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(_Map<AnalyticsEateriesStats>)>

}
/**
Sync Cache

*/
export async function api_admin_analytics_sync_cache_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/analytics/sync-cache/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Analytics

*/
export async function api_admin_analytics_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<GeneralAnalytics>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/analytics/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<GeneralAnalytics> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<GeneralAnalytics>

}
/**
Admin Ui

*/
export async function api_admin_auth_admin_ui_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/auth/admin-ui/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
List

*/
export async function api_admin_cabbages_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Cabbage[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/cabbages/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Cabbage[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Cabbage[]))>

}
/**
Count

*/
export async function api_admin_cabbages_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/cabbages/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Pond List

*/
export async function api_admin_cabbages_pond_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminCabbageList>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/cabbages/pond/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminCabbageList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminCabbageList>

}
/**
Delete

*/
export async function api_admin_cabbages_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Cabbage>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/cabbages/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Cabbage> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Cabbage>

}
/**
List

*/
export async function api_admin_dishes_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((DishInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((DishInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((DishInfo[]))>

}
/**
Add

*/
export async function api_admin_dishes_post (body: AddDishBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Count

*/
export async function api_admin_dishes_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Pond List

*/
export async function api_admin_dishes_pond_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminDishList>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/pond/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminDishList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminDishList>

}
/**
Search

*/
export async function api_admin_dishes_search_post (body: AdminDishSearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((DishSearch[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((DishSearch[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((DishSearch[]))>

}
/**
Get

*/
export async function api_admin_dishes_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Delete

*/
export async function api_admin_dishes_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Update

*/
export async function api_admin_dishes_patch (params: {gene:GeneInput,}, body: UpdateDishBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Set Photo

*/
export async function api_admin_dishes_photos_put (params: {gene:GeneInput,pdx:(number),}, body: DishSetPhoto, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { gene,pdx } = params;
    let data = new FormData();
data.set(
    'options',
    new Blob(
        [JSON.stringify(body.options)],
        { type: 'application/json' }
    )
);

    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/${gene}/photos/${pdx}/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Photo

*/
export async function api_admin_dishes_photos_del (params: {gene:GeneInput,pdx:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,pdx } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/dishes/${gene}/photos/${pdx}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
List

*/
export async function api_admin_eateries_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((AdminEateryItem[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((AdminEateryItem[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((AdminEateryItem[]))>

}
/**
Add

*/
export async function api_admin_eateries_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Bulk

*/
export async function api_admin_eateries_bulk_post (body: AdminEateryBulkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(_Map<AdminEateryItem>)>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/bulk/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(_Map<AdminEateryItem>)> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(_Map<AdminEateryItem>)>

}
/**
Count

*/
export async function api_admin_eateries_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Search

*/
export async function api_admin_eateries_search_post (body: AdminEaterySearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EaterySearch[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EaterySearch[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EaterySearch[]))>

}
/**
List

*/
export async function api_admin_eateries_tasks_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((ConcurrentTask_EateryTaskData[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((ConcurrentTask_EateryTaskData[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((ConcurrentTask_EateryTaskData[]))>

}
/**
Analytics

*/
export async function api_admin_eateries_tasks_analytics_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/analytics/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Cabbage Clean

*/
export async function api_admin_eateries_tasks_cabbage_clean_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/cabbage-clean/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Clean Issue

*/
export async function api_admin_eateries_tasks_clean_issue_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/clean-issue/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
I Eat Wheat
Issue Eatery Wheat Count List ...
*/
export async function api_admin_eateries_tasks_i_eat_wheat_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/i-eat-wheat/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Menu Clone

*/
export async function api_admin_eateries_tasks_menu_clone_post (body: CloneMenuBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/menu-clone/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Sitemap

*/
export async function api_admin_eateries_tasks_sitemap_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/sitemap/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Ssr

*/
export async function api_admin_eateries_tasks_ssr_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/ssr/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Update

*/
export async function api_admin_eateries_tasks_update_post (body: EateryTaskUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/update/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Wheat Update Partial

*/
export async function api_admin_eateries_tasks_wheat_update_partial_post (body: EateryTaskWheatUpdatePartialBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/wheat-update-partial/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Wheat Update

*/
export async function api_admin_eateries_tasks_wheat_update_post (body: EateryTaskWheatUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/wheat-update/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Abort

*/
export async function api_admin_eateries_tasks_del (params: {id:TaskId,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask_EateryTaskData>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/tasks/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask_EateryTaskData> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask_EateryTaskData>

}
/**
Analytics Root

*/
export async function api_admin_eateries_analytics_root_get (params: {eatery:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryAnalyticsRoot>> {
    let { eatery } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/analytics/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryAnalyticsRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryAnalyticsRoot>

}
/**
Analytics

*/
export async function api_admin_eateries_analytics_get (params: {eatery:GeneInput,analytics:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryAnalytics>> {
    let { eatery,analytics } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/analytics/${analytics}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryAnalytics> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryAnalytics>

}
/**
Deactivate Discount

*/
export async function api_admin_eateries_deactivate_discount_post (params: {eatery:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { eatery } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/deactivate-discount/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Del Recruit Link

*/
export async function api_admin_eateries_recruit_links_del (params: {eatery:GeneInput,recruit_link:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { eatery,recruit_link } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/recruit-links/${recruit_link}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Set Recruit Link

*/
export async function api_admin_eateries_recruit_links_patch (params: {eatery:GeneInput,recruit_link:GeneInput,}, body: AdminUpdateRecruitLinkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<RecruitLink>> {
    let { eatery,recruit_link } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/recruit-links/${recruit_link}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<RecruitLink> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<RecruitLink>

}
/**
Tip List

*/
export async function api_admin_eateries_tips_list_list (params: {eatery:GeneInput,last_tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryTip[]))>> {
    let { eatery,last_tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/tips/${last_tip}/list/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryTip[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryTip[]))>

}
/**
Tip Get

*/
export async function api_admin_eateries_tips_get (params: {eatery:GeneInput,tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryTipInfo>> {
    let { eatery,tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/tips/${tip}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryTipInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryTipInfo>

}
/**
Tip Detail Get

*/
export async function api_admin_eateries_tips_detail_get (params: {eatery:GeneInput,tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { eatery,tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/tips/${tip}/detail/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Trailer Set

*/
export async function api_admin_eateries_trailer_put (params: {eatery:GeneInput,}, body: AdminEaterySetTrailer, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEaterySetTrailerResult>> {
    let { eatery } = params;
    let data = new FormData();
    data.set('video', body.video);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${eatery}/trailer/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEaterySetTrailerResult> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEaterySetTrailerResult>

}
/**
Get

*/
export async function api_admin_eateries_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryInfo>

}
/**
Delete

*/
export async function api_admin_eateries_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Add Employee

*/
export async function api_admin_eateries_employee_post (params: {gene:GeneInput,}, body: AdminSetEmployeeBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EmployeeInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/employee/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EmployeeInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EmployeeInfo>

}
/**
Set Employee

*/
export async function api_admin_eateries_employee_patch (params: {gene:GeneInput,}, body: AdminSetEmployeeBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EmployeeInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/employee/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EmployeeInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EmployeeInfo>

}
/**
List Employees

*/
export async function api_admin_eateries_employee_get (params: {gene:GeneInput,employee_list:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EmployeeListInfo>> {
    let { gene,employee_list } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/employee/${employee_list}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EmployeeListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EmployeeListInfo>

}
/**
Del Employee

*/
export async function api_admin_eateries_employee_del (params: {gene:GeneInput,user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene,user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/employee/${user}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Get Extra

*/
export async function api_admin_eateries_extra_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryExtra>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/extra/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryExtra> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryExtra>

}
/**
Set Extra

*/
export async function api_admin_eateries_extra_put (params: {gene:GeneInput,}, body: EateryExtra, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/extra/`,
        method: 'PUT',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Del Extra

*/
export async function api_admin_eateries_extra_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/extra/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update Info

*/
export async function api_admin_eateries_info_patch (params: {gene:GeneInput,}, body: AdminEateryUpdateInfoBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/info/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Update Location

*/
export async function api_admin_eateries_location_patch (params: {gene:GeneInput,}, body: AdminEateryUpdateLocationBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/location/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Reorder Photos

*/
export async function api_admin_eateries_photos_reorder_patch (params: {gene:GeneInput,}, body: AdminEateryReorderPhotosBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/photos-reorder/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Set Photo

*/
export async function api_admin_eateries_photos_put (params: {gene:GeneInput,pdx:(number),}, body: EaterySetPhoto, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { gene,pdx } = params;
    let data = new FormData();
data.set(
    'options',
    new Blob(
        [JSON.stringify(body.options)],
        { type: 'application/json' }
    )
);

    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/photos/${pdx}/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Photo

*/
export async function api_admin_eateries_photos_del (params: {gene:GeneInput,pdx:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene,pdx } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/photos/${pdx}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Add Recruit Link

*/
export async function api_admin_eateries_recruit_links_post (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<RecruitLink>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/recruit-links/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<RecruitLink> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<RecruitLink>

}
/**
List Recruit Links

*/
export async function api_admin_eateries_recruit_links_get (params: {gene:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminRecruitLinkList>> {
    let { gene,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/recruit-links/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminRecruitLinkList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminRecruitLinkList>

}
/**
Request Token

*/
export async function api_admin_eateries_request_token_post (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/request-token/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Trailer Delete

*/
export async function api_admin_eateries_trailer_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/trailer/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
Wheat Photos

*/
export async function api_admin_eateries_wheat_photos_post (params: {gene:GeneInput,}, body: AdminEateryWheatPhotosBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryItem>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eateries/${gene}/wheat-photos/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryItem>

}
/**
List

*/
export async function api_admin_eatery_tips_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryTip[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eatery-tips/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryTip[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryTip[]))>

}
/**
Count

*/
export async function api_admin_eatery_tips_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/eatery-tips/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Count

*/
export async function api_admin_feedbacks_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/feedbacks/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Root

*/
export async function api_admin_feedbacks_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<FeedbackRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/feedbacks/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<FeedbackRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<FeedbackRoot>

}
/**
Get

*/
export async function api_admin_feedbacks_get (params: {feedback:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<FeedbackInfo>> {
    let { feedback } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/feedbacks/${feedback}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<FeedbackInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<FeedbackInfo>

}
/**
Delete

*/
export async function api_admin_feedbacks_del (params: {feedback:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Feedback>> {
    let { feedback } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/feedbacks/${feedback}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Feedback> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Feedback>

}
/**
Chatting

*/
export async function api_admin_feedbacks_chatting_patch (params: {feedback:GeneInput,}, body: AdminFeedbackChattingBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Feedback>> {
    let { feedback } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/feedbacks/${feedback}/chatting/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Feedback> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Feedback>

}
/**
Resolve

*/
export async function api_admin_feedbacks_resolve_patch (params: {feedback:GeneInput,status:FeedbackStatus,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Feedback>> {
    let { feedback,status } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/feedbacks/${feedback}/resolve/${status}/`,
        method: 'PATCH',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Feedback> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Feedback>

}
/**
List

*/
export async function api_admin_golems_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Golem[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/golems/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Golem[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Golem[]))>

}
/**
Add

*/
export async function api_admin_golems_post (body: GolemAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<GolemToken>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/golems/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<GolemToken> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<GolemToken>

}
/**
Count

*/
export async function api_admin_golems_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/golems/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Get

*/
export async function api_admin_golems_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Golem>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/golems/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Golem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Golem>

}
/**
Delete

*/
export async function api_admin_golems_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Golem>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/golems/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Golem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Golem>

}
/**
Token Reset

*/
export async function api_admin_golems_token_reset_patch (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<GolemToken>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/golems/${gene}/token-reset`,
        method: 'PATCH',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<GolemToken> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<GolemToken>

}
/**
Add

*/
export async function api_admin_issues_post (body: IssueKind, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Add Manual Merge

*/
export async function api_admin_issues_add_manual_merge_post (body: (string), override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = body;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/add-manual-merge/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'text/plain', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Count

*/
export async function api_admin_issues_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Drop Manual Merge

*/
export async function api_admin_issues_drop_manual_merge_del (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/drop-manual-merge/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Root

*/
export async function api_admin_issues_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueRoot>

}
/**
Take

*/
export async function api_admin_issues_take_post (body: AdminIssueTakeBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/take/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Get

*/
export async function api_admin_issues_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Delete

*/
export async function api_admin_issues_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Update

*/
export async function api_admin_issues_patch (params: {gene:GeneInput,}, body: IssueKind, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Request Eatery Ownership Response

*/
export async function api_admin_issues_request_eatery_ownership_post (params: {issue:GeneInput,}, body: UserIssueReqEatOwnStatus, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    let { issue } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/${issue}/request-eatery-ownership/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Request Eatery Verification Response

*/
export async function api_admin_issues_request_eatery_verification_post (params: {issue:GeneInput,}, body: EateryVerificationRequestStatus, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    let { issue } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/${issue}/request-eatery-verification/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
Request Ticket Response

*/
export async function api_admin_issues_request_ticket_post (params: {issue:GeneInput,}, body: UserIssueRequestTicketStatus, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<IssueInfo>> {
    let { issue } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/issues/${issue}/request-ticket/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<IssueInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<IssueInfo>

}
/**
List

*/
export async function api_admin_records_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Record[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/records/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Record[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Record[]))>

}
/**
Count

*/
export async function api_admin_records_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/records/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Get

*/
export async function api_admin_records_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/records/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
List

*/
export async function api_admin_reviews_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryReviewItem[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryReviewItem[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryReviewItem[]))>

}
/**
Bulk

*/
export async function api_admin_reviews_bulk_post (body: ((Gene[])), override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(_Map<EateryReviewItem>)>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/bulk/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(_Map<EateryReviewItem>)> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(_Map<EateryReviewItem>)>

}
/**
Count

*/
export async function api_admin_reviews_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Detail Get

*/
export async function api_admin_reviews_detail_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/detail/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Pond List

*/
export async function api_admin_reviews_pond_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryReviewList>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/pond/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryReviewList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryReviewList>

}
/**
Get

*/
export async function api_admin_reviews_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryReviewFull>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryReviewFull> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryReviewFull>

}
/**
Update

*/
export async function api_admin_reviews_patch (params: {gene:GeneInput,}, body: UpdateReviewBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryReviewItem>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/reviews/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryReviewItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryReviewItem>

}
/**
List

*/
export async function api_admin_ripples_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((RippleInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/ripples/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((RippleInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((RippleInfo[]))>

}
/**
Count

*/
export async function api_admin_ripples_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/ripples/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Root

*/
export async function api_admin_ripples_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<RippleRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/ripples/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<RippleRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<RippleRoot>

}
/**
Walk Past

*/
export async function api_admin_ripples_walk_past_list (params: {last:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((RippleInfo[]))>> {
    let { last } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/ripples/walk-past/${last}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((RippleInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((RippleInfo[]))>

}
/**
Get

*/
export async function api_admin_ripples_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<RippleInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/ripples/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<RippleInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<RippleInfo>

}
/**
List

*/
export async function api_admin_sequential_tasks_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((SequentialTask[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sequential-tasks/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((SequentialTask[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((SequentialTask[]))>

}
/**
Get

*/
export async function api_admin_sequential_tasks_get (params: {id:TaskId,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SequentialTask>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sequential-tasks/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SequentialTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SequentialTask>

}
/**
Abort

*/
export async function api_admin_sequential_tasks_del (params: {id:TaskId,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SequentialTask>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sequential-tasks/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SequentialTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SequentialTask>

}
/**
Get

*/
export async function api_admin_settings_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SeedSettingJson>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/settings/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SeedSettingJson> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SeedSettingJson>

}
/**
Set Rob Available

*/
export async function api_admin_settings_rob_available_post (body: AdminSetRobAvailableBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SeedSettingJson>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/settings/rob-available/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SeedSettingJson> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SeedSettingJson>

}
/**
Set Rob Irr

*/
export async function api_admin_settings_rob_irr_post (body: AdminSetRobIrrPriceBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SeedSettingJson>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/settings/rob-irr/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SeedSettingJson> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SeedSettingJson>

}
/**
Rob Irr Rollback

*/
export async function api_admin_settings_rob_irr_del (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SeedSettingJson>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/settings/rob-irr/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SeedSettingJson> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SeedSettingJson>

}
/**
Set Rob Prices

*/
export async function api_admin_settings_rob_prices_post (body: RobPrices, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SeedSettingJson>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/settings/rob-prices/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SeedSettingJson> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SeedSettingJson>

}
/**
Set Rob Rewards

*/
export async function api_admin_settings_rob_rewards_post (body: RobRewards, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SeedSettingJson>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/settings/rob-rewards/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SeedSettingJson> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SeedSettingJson>

}
/**
List

*/
export async function api_admin_sparks_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((SparkInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sparks/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((SparkInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((SparkInfo[]))>

}
/**
Count

*/
export async function api_admin_sparks_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sparks/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Root

*/
export async function api_admin_sparks_root_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SparkRoot>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sparks/root/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SparkRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SparkRoot>

}
/**
Get

*/
export async function api_admin_sparks_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SparkInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/sparks/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SparkInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SparkInfo>

}
/**
Eatery Analytics

*/
export async function api_admin_spice_eatery_analytics_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SpiceEateryAnalytics>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/eatery/analytics/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SpiceEateryAnalytics> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SpiceEateryAnalytics>

}
/**
Export Eatery

*/
export async function api_admin_spice_export_eatery_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(((string)[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/export/eatery/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(((string)[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(((string)[]))>

}
/**
List

*/
export async function api_admin_spice_files_list (params: {kind:SpiceKind,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(((string)[]))>> {
    let { kind } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/files/${kind}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(((string)[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(((string)[]))>

}
/**
File Content

*/
export async function api_admin_spice_files_get (params: {kind:SpiceKind,filename:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { kind,filename } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/files/${kind}/${filename}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
State Eatery

*/
export async function api_admin_spice_state_eatery_get (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SpiceEateryStateResult>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/state/eatery/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SpiceEateryStateResult> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SpiceEateryStateResult>

}
/**
Task List

*/
export async function api_admin_spice_tasks_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((ConcurrentTask_SpiceTaskData[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/tasks/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((ConcurrentTask_SpiceTaskData[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((ConcurrentTask_SpiceTaskData[]))>

}
/**
Spice Eatery

*/
export async function api_admin_spice_tasks_eatery_post (body: SpiceEateryRunBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/tasks/eatery/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Spice Eatery Check

*/
export async function api_admin_spice_tasks_eatery_check_post (body: SpiceCodeFile, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/tasks/eatery/check/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Task Abort

*/
export async function api_admin_spice_tasks_del (params: {id:TaskId,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask_SpiceTaskData>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/spice/tasks/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask_SpiceTaskData> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask_SpiceTaskData>

}
/**
Count

*/
export async function api_admin_suggest_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Suggest Detail Get

*/
export async function api_admin_suggest_detail_get (params: {detail:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { detail } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/detail/${detail}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Dish Suggest Pond List

*/
export async function api_admin_suggest_dish_pond_get (params: {pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminDishList>> {
    let { pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/dish-pond/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminDishList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminDishList>

}
/**
Dish Get

*/
export async function api_admin_suggest_dish_get (params: {dish:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { dish } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/dish/${dish}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Root

*/
export async function api_admin_suggest_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestRoot>

}
/**
Take

*/
export async function api_admin_suggest_take_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminSuggestInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/take/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminSuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminSuggestInfo>

}
/**
Get

*/
export async function api_admin_suggest_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminSuggestInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminSuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminSuggestInfo>

}
/**
Resolve

*/
export async function api_admin_suggest_post (params: {gene:GeneInput,}, body: SuggestResolveBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminSuggestInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/${gene}/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminSuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminSuggestInfo>

}
/**
Delete

*/
export async function api_admin_suggest_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminSuggestInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/suggest/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminSuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminSuggestInfo>

}
/**
List

*/
export async function api_admin_topics_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Topic[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Topic[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Topic[]))>

}
/**
Add

*/
export async function api_admin_topics_post (body: AdminTopicAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicInfo>

}
/**
Count

*/
export async function api_admin_topics_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminTopicCount>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminTopicCount> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminTopicCount>

}
/**
Get

*/
export async function api_admin_topics_get (params: {topic:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicInfo>> {
    let { topic } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicInfo>

}
/**
Delete

*/
export async function api_admin_topics_del (params: {topic:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { topic } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_topics_patch (params: {topic:GeneInput,}, body: AdminTopicUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Member Add

*/
export async function api_admin_topics_members_post (params: {topic:GeneInput,user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic,user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/members/${user}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Member Del

*/
export async function api_admin_topics_members_del (params: {topic:GeneInput,user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic,user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/members/${user}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Message List

*/
export async function api_admin_topics_messages_get (params: {topic:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageList>> {
    let { topic,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/messages/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageList>

}
/**
Transfer Ownership

*/
export async function api_admin_topics_transfer_ownership_patch (params: {topic:GeneInput,new_owner:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic,new_owner } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/topics/${topic}/transfer-ownership/${new_owner}/`,
        method: 'PATCH',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
List

*/
export async function api_admin_users_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((AdminUserInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((AdminUserInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((AdminUserInfo[]))>

}
/**
Admin List

*/
export async function api_admin_users_admins_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((AdminUserInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/admins/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((AdminUserInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((AdminUserInfo[]))>

}
/**
Bulk

*/
export async function api_admin_users_bulk_post (body: AdminUserBulkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<(_Map<AdminUserInfo>)>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/bulk/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<(_Map<AdminUserInfo>)> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<(_Map<AdminUserInfo>)>

}
/**
Count

*/
export async function api_admin_users_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
History Eatery List

*/
export async function api_admin_users_history_eatery_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserEateryHistory[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/history-eatery/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserEateryHistory[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserEateryHistory[]))>

}
/**
History Eatery Get

*/
export async function api_admin_users_history_eatery_get (params: {history:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserHistoryList>> {
    let { history } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/history-eatery/${history}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserHistoryList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserHistoryList>

}
/**
History List

*/
export async function api_admin_users_history_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserHistoryList[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/history/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserHistoryList[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserHistoryList[]))>

}
/**
Search

*/
export async function api_admin_users_search_post (body: AdminUserSearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserSearch[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserSearch[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserSearch[]))>

}
/**
List

*/
export async function api_admin_users_tasks_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((ConcurrentTask_UserTaskData[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/tasks/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((ConcurrentTask_UserTaskData[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((ConcurrentTask_UserTaskData[]))>

}
/**
Analytics

*/
export async function api_admin_users_tasks_analytics_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/tasks/analytics/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Update

*/
export async function api_admin_users_tasks_update_post (body: UserTaskUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/tasks/update/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask>

}
/**
Abort

*/
export async function api_admin_users_tasks_del (params: {id:TaskId,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ConcurrentTask_UserTaskData>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/tasks/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ConcurrentTask_UserTaskData> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ConcurrentTask_UserTaskData>

}
/**
Transaction List

*/
export async function api_admin_users_transactions_pond_get (params: {pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminTransactionListInfo>> {
    let { pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/transactions-pond/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminTransactionListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminTransactionListInfo>

}
/**
Transaction List

*/
export async function api_admin_users_transactions_get (params: {transaction:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserTransactionInfo>> {
    let { transaction } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/transactions/${transaction}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserTransactionInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserTransactionInfo>

}
/**
Get By Username

*/
export async function api_admin_users_username_get (params: {username:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    let { username } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/username/`,
        method: 'GET',
        params: { username },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Get

*/
export async function api_admin_users_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Update

*/
export async function api_admin_users_patch (params: {gene:GeneInput,}, body: AdminUserUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminUserInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminUserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminUserInfo>

}
/**
Set Admin Perms

*/
export async function api_admin_users_admin_perms_patch (params: {gene:GeneInput,}, body: AdminUserSetAdminPermsBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AgentInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/${gene}/admin-perms/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AgentInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AgentInfo>

}
/**
Set Crime

*/
export async function api_admin_users_crimes_patch (params: {gene:GeneInput,cdx:(number),}, body: AdminUserSetCrimeBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AgentInfo>> {
    let { gene,cdx } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/users/${gene}/crimes/${cdx}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AgentInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AgentInfo>

}
/**
Gift Rob

*/
export async function api_admin_wallet_gift_rob_post (body: AdminGiftRobBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserTransactionInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/wallet/gift-rob/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserTransactionInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserTransactionInfo>

}
/**
Rob Reward

*/
export async function api_admin_wallet_rob_reward_post (body: AdminRobRewardBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserTransactionInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/wallet/rob-reward/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserTransactionInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserTransactionInfo>

}
/**
List

*/
export async function api_admin_xenos_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((XenosBuckle[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/xenos/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((XenosBuckle[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((XenosBuckle[]))>

}
/**
Count

*/
export async function api_admin_xenos_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/xenos/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Xenos Get

*/
export async function api_admin_xenos_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/admin/xenos/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
List

*/
export async function api_akhbar_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((KhabarInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/akhbar/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((KhabarInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((KhabarInfo[]))>

}
/**
Count

*/
export async function api_akhbar_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/akhbar/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Eatery Navigate

*/
export async function api_analytics_eatery_navigate_post (params: {eatery:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { eatery } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/analytics/eatery-navigate/${eatery}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Eatery Share

*/
export async function api_analytics_eatery_share_post (params: {eatery:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { eatery } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/analytics/eatery-share/${eatery}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Dish Search

*/
export async function api_eateries_dish_search_post (body: DishSearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((DishSearch[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/dish-search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((DishSearch[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((DishSearch[]))>

}
/**
Search

*/
export async function api_eateries_search_post (body: EaterySearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EaterySearch[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: r.headers.get('Content-Type') == 'application/x-binjin' ? ud.binjin_decode(await r.bytes()) : await r.json(),
        ok(): this is ud.Ok<((EaterySearch[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EaterySearch[]))>

}
/**
Get

*/
export async function api_eateries_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: r.headers.get('Content-Type') == 'application/x-binjin' ? ud.binjin_decode(await r.bytes()) : await r.json(),
        ok(): this is ud.Ok<EateryInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryInfo>

}
/**
Get Cabbage Detail

*/
export async function api_eateries_cabbages_detail_get (params: {gene:GeneInput,cabbage:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene,cabbage } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/cabbages/${cabbage}/detail/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Get Cabbages

*/
export async function api_eateries_cabbages_get (params: {gene:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<CabbageList>> {
    let { gene,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/cabbages/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<CabbageList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<CabbageList>

}
/**
Discount Buy

*/
export async function api_eateries_discount_buy_post (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<ShahOrigin>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/discount-buy/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<ShahOrigin> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<ShahOrigin>

}
/**
Dish Get

*/
export async function api_eateries_dish_get (params: {gene:GeneInput,dish:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,dish } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/dish/${dish}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Impressions Get

*/
export async function api_eateries_impressions_list (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryImpression[]))>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/impressions/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryImpression[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryImpression[]))>

}
/**
Impression Del

*/
export async function api_eateries_impressions_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryItem>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/impressions/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryItem>

}
/**
Impressions Add/Set

*/
export async function api_eateries_impressions_post (params: {gene:GeneInput,imp:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryItem>> {
    let { gene,imp } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/impressions/${imp}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryItem>

}
/**
Menu Get

*/
export async function api_eateries_menu_get (params: {gene:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishList>> {
    let { gene,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/menu/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishList>

}
/**
Add Review

*/
export async function api_eateries_reviews_post (params: {gene:GeneInput,}, body: AddReviewBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryReviewInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/reviews/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryReviewInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryReviewInfo>

}
/**
Get Reviews

*/
export async function api_eateries_reviews_get (params: {gene:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryReviewInfoList>> {
    let { gene,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/reviews/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryReviewInfoList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryReviewInfoList>

}
/**
Get Review Detail

*/
export async function api_eateries_reviews_detail_get (params: {gene:GeneInput,review:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene,review } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/reviews/${review}/detail/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Add Tip

*/
export async function api_eateries_tip_post (params: {gene:GeneInput,}, body: AddTipBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/eateries/${gene}/tip/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Add

*/
export async function api_feedback_post (body: FeedbackAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Agent>> {
    
    let data = new FormData();
data.set(
    'info',
    new Blob(
        [JSON.stringify(body.info)],
        { type: 'application/json' }
    )
);

    body.record && data.set('record', body.record);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/feedback/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Agent> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Agent>

}
/**
Get

*/
export async function api_feedback_get (params: {feedback:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<FeedbackInfo>> {
    let { feedback } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/feedback/${feedback}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<FeedbackInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<FeedbackInfo>

}
/**
Count

*/
export async function api_golem_eatery_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/golem/eatery/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
List

*/
export async function api_golem_eatery_farm_list_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryFarmInfo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/golem/eatery/farm-list/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryFarmInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryFarmInfo[]))>

}
/**
Stats

*/
export async function api_golem_users_stats_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<GolemUsersStats>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/golem/users/stats/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<GolemUsersStats> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<GolemUsersStats>

}
/**
Report Eatery Cabbage

*/
export async function api_issues_report_eatery_cabbage_post (params: {cabbage:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { cabbage } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/issues/report-eatery-cabbage/${cabbage}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Report Eatery Review

*/
export async function api_issues_report_eatery_review_post (params: {review:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { review } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/issues/report-eatery-review/${review}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Report Eatery

*/
export async function api_issues_report_eatery_post (params: {eatery:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { eatery } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/issues/report-eatery/${eatery}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Report User

*/
export async function api_issues_report_user_post (params: {user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/issues/report-user/${user}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Request Eatery Ownership

*/
export async function api_issues_request_eatery_ownership_post (params: {eatery:GeneInput,}, body: IssueReqEatOwnBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Agent>> {
    let { eatery } = params;
    let data = new FormData();
    body.media.forEach(f => data.append('media', f));

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/issues/request-eatery-ownership/${eatery}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Agent> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Agent>

}
/**
Request Ticket

*/
export async function api_issues_request_ticket_post (body: IssueRequestTicketBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Agent>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/issues/request-ticket/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Agent> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Agent>

}
/**
Get

*/
export async function api_staff_eatery_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryInfo>

}
/**
Analytics Root

*/
export async function api_staff_eatery_analytics_root_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryAnalyticsRoot>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/analytics/root/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryAnalyticsRoot> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryAnalyticsRoot>

}
/**
Analytics

*/
export async function api_staff_eatery_analytics_get (params: {analytics:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryAnalytics>> {
    let { analytics } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/analytics/${analytics}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryAnalytics> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryAnalytics>

}
/**
Buy Subscriptions

*/
export async function api_staff_eatery_buy_subscription_post (body: StaffBuySubscription, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/buy-subscription/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryInfo>

}
/**
Apply Discount

*/
export async function api_staff_eatery_discount_apply_post (params: {discount:GeneInput,code:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { discount,code } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/discount-apply/${discount}/${code}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Set Discount

*/
export async function api_staff_eatery_discount_put (body: EateryDiscount, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/discount/`,
        method: 'PUT',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Discounts List

*/
export async function api_staff_eatery_discounts_get (params: {pond_gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryDiscountListInfo>> {
    let { pond_gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/discounts/${pond_gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryDiscountListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryDiscountListInfo>

}
/**
Update Info

*/
export async function api_staff_eatery_info_patch (body: StaffEateryUpdateInfoBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/info/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryInfo>

}
/**
Update Location

*/
export async function api_staff_eatery_location_patch (body: LocationInput, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryItem>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/location/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryItem>

}
/**
Reorder Photos

*/
export async function api_staff_eatery_photos_reorder_patch (body: StaffEateryReorderPhotosBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryItem>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/photos-reorder/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryItem>

}
/**
Set Photo

*/
export async function api_staff_eatery_photos_put (params: {pdx:(number),}, body: StaffEaterySetPhoto, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { pdx } = params;
    let data = new FormData();
    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/photos/${pdx}/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Photo

*/
export async function api_staff_eatery_photos_del (params: {pdx:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryItem>> {
    let { pdx } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/photos/${pdx}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryItem>

}
/**
Request Verification

*/
export async function api_staff_eatery_request_verification_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffWarehouseItem>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/request-verification/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffWarehouseItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffWarehouseItem>

}
/**
Rob Transfer

*/
export async function api_staff_eatery_rob_transfer_post (params: {rob:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffWarehouseItem>> {
    let { rob } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/rob-transfer/${rob}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffWarehouseItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffWarehouseItem>

}
/**
Trailer Set

*/
export async function api_staff_eatery_trailer_put (body: StaffEaterySetTrailer, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    
    let data = new FormData();
    data.set('video', body.video);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/trailer/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Trailer

*/
export async function api_staff_eatery_trailer_del (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryItem>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/trailer/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryItem>

}
/**
Transaction List

*/
export async function api_staff_eatery_transactions_get (params: {pond_gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryTransactionListInfo>> {
    let { pond_gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/transactions/${pond_gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryTransactionListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryTransactionListInfo>

}
/**
Request Token

*/
export async function api_staff_eatery_request_token_post (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffRequestTokenInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/eatery/${gene}/request-token/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffRequestTokenInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffRequestTokenInfo>

}
/**
List

*/
export async function api_staff_employees_list_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EmployeeListInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/employees/list/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EmployeeListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EmployeeListInfo>

}
/**
Sessions

*/
export async function api_staff_employees_sessions_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((StaffSessionInfo[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/employees/sessions/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((StaffSessionInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((StaffSessionInfo[]))>

}
/**
Del Employee

*/
export async function api_staff_employees_del (params: {user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffEateryItem>> {
    let { user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/employees/${user}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffEateryItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffEateryItem>

}
/**
Set Employee

*/
export async function api_staff_employees_patch (params: {user:GeneInput,}, body: StaffSetEmployeeBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EmployeeInfo>> {
    let { user } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/employees/${user}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EmployeeInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EmployeeInfo>

}
/**
Add

*/
export async function api_staff_menu_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Pond List

*/
export async function api_staff_menu_pond_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishList>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/pond/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishList>

}
/**
Get

*/
export async function api_staff_menu_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Delete

*/
export async function api_staff_menu_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Update

*/
export async function api_staff_menu_patch (params: {gene:GeneInput,}, body: StaffUpdateDishBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Set Photo

*/
export async function api_staff_menu_photos_put (params: {gene:GeneInput,pdx:(number),}, body: DishSetPhoto, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { gene,pdx } = params;
    let data = new FormData();
data.set(
    'options',
    new Blob(
        [JSON.stringify(body.options)],
        { type: 'application/json' }
    )
);

    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/${gene}/photos/${pdx}/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Photo

*/
export async function api_staff_menu_photos_del (params: {gene:GeneInput,pdx:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,pdx } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/menu/${gene}/photos/${pdx}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Add

*/
export async function api_staff_recruit_links_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<RecruitLink>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/recruit-links/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<RecruitLink> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<RecruitLink>

}
/**
List Recruit Links

*/
export async function api_staff_recruit_links_pond_get (params: {pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffRecruitLinkList>> {
    let { pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/recruit-links/pond/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffRecruitLinkList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffRecruitLinkList>

}
/**
Del

*/
export async function api_staff_recruit_links_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/recruit-links/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Set

*/
export async function api_staff_recruit_links_patch (params: {gene:GeneInput,}, body: StaffUpdateRecruitLinkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<RecruitLink>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/recruit-links/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<RecruitLink> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<RecruitLink>

}
/**
Pond List

*/
export async function api_staff_reviews_pond_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryReviewInfoList>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/reviews/pond/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryReviewInfoList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryReviewInfoList>

}
/**
Get

*/
export async function api_staff_reviews_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminEateryReviewFull>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/reviews/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminEateryReviewFull> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminEateryReviewFull>

}
/**
Update

*/
export async function api_staff_reviews_patch (params: {gene:GeneInput,}, body: UpdateReviewBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryReviewItem>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/reviews/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryReviewItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryReviewItem>

}
/**
Detail Get

*/
export async function api_staff_reviews_detail_get (params: {gene:GeneInput,detail:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene,detail } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/reviews/${gene}/detail/${detail}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Tip List

*/
export async function api_staff_tips_list_list (params: {last_tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryTipInfo[]))>> {
    let { last_tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/tips/list/${last_tip}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryTipInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryTipInfo[]))>

}
/**
Tip Get

*/
export async function api_staff_tips_get (params: {tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryTipInfo>> {
    let { tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/tips/${tip}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryTipInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryTipInfo>

}
/**
Tip Detail Get

*/
export async function api_staff_tips_detail_get (params: {tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/tips/${tip}/detail/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Tip Read

*/
export async function api_staff_tips_read_post (params: {tip:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryTip>> {
    let { tip } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/staff/tips/${tip}/read/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryTip> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryTip>

}
/**
Add

*/
export async function api_suggest_post (body: SuggestAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestItem>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestItem>

}
/**
User Suggest Pond List

*/
export async function api_suggest_user_pond_list_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserSuggestList>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/user-pond-list/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserSuggestList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserSuggestList>

}
/**
Get Suggest

*/
export async function api_suggest_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestInfo>

}
/**
Delete

*/
export async function api_suggest_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestItem>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestItem> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestItem>

}
/**
Update

*/
export async function api_suggest_patch (params: {gene:GeneInput,}, body: UserUpdateSuggestBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestInfo>> {
    let { gene } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestInfo>

}
/**
Get Suggest Detail

*/
export async function api_suggest_detail_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<string>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/detail/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.text(),
        ok(): this is ud.Ok<string> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<string>

}
/**
Suggest Detail Set

*/
export async function api_suggest_detail_put (params: {gene:GeneInput,}, body: (string), override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestInfo>> {
    let { gene } = params;
    let data = body;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/detail/`,
        method: 'PUT',
        params: {  },
        headers: { 'Content-Type': 'text/plain', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestInfo>

}
/**
Dish Suggest Pond List

*/
export async function api_suggest_dish_pond_list_get (params: {gene:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishList>> {
    let { gene,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish-pond-list/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishList>

}
/**
Add Dish

*/
export async function api_suggest_dish_post (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Dish Get

*/
export async function api_suggest_dish_get (params: {gene:GeneInput,dish:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,dish } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish/${dish}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Dish Delete

*/
export async function api_suggest_dish_del (params: {gene:GeneInput,dish:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,dish } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish/${dish}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Dish Update

*/
export async function api_suggest_dish_patch (params: {gene:GeneInput,dish:GeneInput,}, body: SuggestDishUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,dish } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish/${dish}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Set Dish Photo

*/
export async function api_suggest_dish_photos_put (params: {gene:GeneInput,dish:GeneInput,pdx:(number),}, body: SuggestDishSetPhoto, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { gene,dish,pdx } = params;
    let data = new FormData();
    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish/${dish}/photos/${pdx}/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Dish Photo

*/
export async function api_suggest_dish_photos_del (params: {gene:GeneInput,dish:GeneInput,pdx:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<DishInfo>> {
    let { gene,dish,pdx } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/dish/${dish}/photos/${pdx}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<DishInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<DishInfo>

}
/**
Set Photo

*/
export async function api_suggest_photos_put (params: {gene:GeneInput,pdx:(number),}, body: SuggestSetPhotoBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    let { gene,pdx } = params;
    let data = new FormData();
data.set(
    'options',
    new Blob(
        [JSON.stringify(body.options)],
        { type: 'application/json' }
    )
);

    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/photos/${pdx}/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Del Photo

*/
export async function api_suggest_photos_del (params: {gene:GeneInput,pdx:(number),for_menu:(boolean),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestInfo>> {
    let { gene,pdx,for_menu } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/photos/${pdx}/`,
        method: 'DELETE',
        params: { for_menu },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestInfo>

}
/**
Submit

*/
export async function api_suggest_submit_post (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<SuggestInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/suggest/${gene}/submit/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<SuggestInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<SuggestInfo>

}
/**
Get

*/
export async function api_topics_get (params: {topic:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicInfo>> {
    let { topic } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicInfo>

}
/**
Delete

*/
export async function api_topics_del (params: {topic:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { topic } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_topics_patch (params: {topic:GeneInput,}, body: TopicUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Member Add

*/
export async function api_topics_members_post (params: {topic:GeneInput,user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic,user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/members/${user}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Member Del

*/
export async function api_topics_members_del (params: {topic:GeneInput,user:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic,user } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/members/${user}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Message Add Document

*/
export async function api_topics_messages_document_post (params: {topic:GeneInput,}, body: TopicMessageAddDocumentBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageInfo>> {
    let { topic } = params;
    let data = new FormData();
    body.files.forEach(f => data.append('files', f));
data.set(
    'info',
    new Blob(
        [JSON.stringify(body.info)],
        { type: 'application/json' }
    )
);


    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/document/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageInfo>

}
/**
Message Add Media

*/
export async function api_topics_messages_media_post (params: {topic:GeneInput,}, body: TopicMessageAddMediaBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageInfo>> {
    let { topic } = params;
    let data = new FormData();
data.set(
    'info',
    new Blob(
        [JSON.stringify(body.info)],
        { type: 'application/json' }
    )
);

    body.media.forEach(f => data.append('media', f));

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/media/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageInfo>

}
/**
Message Add Text

*/
export async function api_topics_messages_text_post (params: {topic:GeneInput,}, body: TopicMessageAddTextBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageInfo>> {
    let { topic } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/text/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageInfo>

}
/**
Message Add Voice

*/
export async function api_topics_messages_voice_post (params: {topic:GeneInput,}, body: TopicMessageAddVoiceBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageInfo>> {
    let { topic } = params;
    let data = new FormData();
data.set(
    'info',
    new Blob(
        [JSON.stringify(body.info)],
        { type: 'application/json' }
    )
);

    data.set('voice', body.voice);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/voice/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageInfo>

}
/**
Message Delete

*/
export async function api_topics_messages_del (params: {topic:GeneInput,message:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { topic,message } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/${message}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Message Edit Text

*/
export async function api_topics_messages_edit_patch (params: {topic:GeneInput,message:GeneInput,}, body: TopicMessageEditTextBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageEditResult>> {
    let { topic,message } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/${message}/edit/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageEditResult> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageEditResult>

}
/**
Message Read

*/
export async function api_topics_messages_read_post (params: {topic:GeneInput,message:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { topic,message } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/${message}/read/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Message List

*/
export async function api_topics_messages_get (params: {topic:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<TopicMessageList>> {
    let { topic,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/messages/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<TopicMessageList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<TopicMessageList>

}
/**
Transfer Ownership

*/
export async function api_topics_transfer_ownership_patch (params: {topic:GeneInput,new_owner:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Topic>> {
    let { topic,new_owner } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/topics/${topic}/transfer-ownership/${new_owner}/`,
        method: 'PATCH',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Topic> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Topic>

}
/**
Get

*/
export async function api_user_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Update

*/
export async function api_user_patch (body: UserUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Associated Eateries

*/
export async function api_user_associated_eateries_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryCard[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/associated-eateries/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryCard[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryCard[]))>

}
/**
Associated Topics

*/
export async function api_user_associated_topics_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Topic[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/associated-topics/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Topic[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Topic[]))>

}
/**
History Eatery List

*/
export async function api_user_history_eatery_get (params: {belt:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserHistoryList>> {
    let { belt } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/history-eatery/${belt}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserHistoryList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserHistoryList>

}
/**
Impressions

*/
export async function api_user_impressions_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserImpression[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/impressions/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserImpression[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserImpression[]))>

}
/**
Inventory List

*/
export async function api_user_inventory_get (params: {pond_gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserItemListInfo>> {
    let { pond_gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/inventory/${pond_gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserItemListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserItemListInfo>

}
/**
Invited By Inviter

*/
export async function api_user_invited_post (params: {inviter:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { inviter } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/invited/${inviter}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Login

*/
export async function api_user_login_post (body: LoginBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<LoginInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/login/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<LoginInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<LoginInfo>

}
/**
Logout

*/
export async function api_user_logout_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/logout/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Network List

*/
export async function api_user_network_get (params: {network:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserNetworkList>> {
    let { network } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/network/${network}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserNetworkList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserNetworkList>

}
/**
Notifications List

*/
export async function api_user_notifications_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserNotificationInfo[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/notifications/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserNotificationInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserNotificationInfo[]))>

}
/**
Notifications Info List

*/
export async function api_user_notifications_info_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserNotificationListInfo>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/notifications/info/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserNotificationListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserNotificationListInfo>

}
/**
Notifications Read All

*/
export async function api_user_notifications_read_all_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/notifications/read/all/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Notifications Read

*/
export async function api_user_notifications_read_post (params: {notif_idx:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { notif_idx } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/notifications/read/${notif_idx}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Set Password

*/
export async function api_user_password_put (body: SetPasswordBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/password/`,
        method: 'PUT',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update Photo

*/
export async function api_user_photo_put (body: UpdatePhoto, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Record>> {
    
    let data = new FormData();
    data.set('photo', body.photo);

    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/photo/`,
        method: 'PUT',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Record> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Record>

}
/**
Delete Photo

*/
export async function api_user_photo_del (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/photo/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Preference Set

*/
export async function api_user_preference_set_post (body: EateryStats, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserPreferences>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/preference-set/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserPreferences> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserPreferences>

}
/**
Delete Review Detail

*/
export async function api_user_reviews_detail_del (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<EateryReviewInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/reviews/${gene}/detail/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<EateryReviewInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<EateryReviewInfo>

}
/**
Reviews

*/
export async function api_user_reviews_get (params: {pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserReviewList>> {
    let { pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/reviews/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserReviewList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserReviewList>

}
/**
Saved Dishes

*/
export async function api_user_saved_dishes_list (params: {belt:GeneInput,page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((DishInfo[]))>> {
    let { belt,page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/saved/dishes/${belt}/${page}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((DishInfo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((DishInfo[]))>

}
/**
Saved Eateries

*/
export async function api_user_saved_eateries_list (params: {belt:GeneInput,page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((EateryCard[]))>> {
    let { belt,page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/saved/eateries/${belt}/${page}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((EateryCard[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((EateryCard[]))>

}
/**
Saved Get

*/
export async function api_user_saved_raw_get (params: {belt:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserSaved>> {
    let { belt } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/saved/raw/${belt}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserSaved> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserSaved>

}
/**
Saved Del

*/
export async function api_user_saved_del (params: {belt:GeneInput,target:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { belt,target } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/saved/${belt}/${target}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Saved Add

*/
export async function api_user_saved_post (params: {kind:UserSavedKind,target:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Gene>> {
    let { kind,target } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/saved/${kind}/${target}/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Gene> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Gene>

}
/**
Delete Session

*/
export async function api_user_sessions_del (params: {sid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { sid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/sessions/${sid}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Transaction List

*/
export async function api_user_transactions_get (params: {pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserTransactionListInfo>> {
    let { pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/transactions/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserTransactionListInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserTransactionListInfo>

}
/**
Verify Password

*/
export async function api_user_verify_password_post (body: VerifyPasswordBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserInfo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/user/verify-password/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserInfo>

}
/**
Get By Username

*/
export async function api_users_username_get (params: {username:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserProfileInfo>> {
    let { username } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/users/username/`,
        method: 'GET',
        params: { username },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserProfileInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserProfileInfo>

}
/**
Get User

*/
export async function api_users_get (params: {gene:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserProfileInfo>> {
    let { gene } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/users/${gene}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserProfileInfo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserProfileInfo>

}
/**
User Reviews

*/
export async function api_users_reviews_get (params: {user:GeneInput,pond:GeneInput,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<UserReviewList>> {
    let { user,pond } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/users${user}/reviews/${pond}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<UserReviewList> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<UserReviewList>

}
/**
Verification

*/
export async function api_verification_post (body: VerificationData, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<VerificationTimes>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/verification/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<VerificationTimes> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<VerificationTimes>

}
/**
Buy Rob

*/
export async function api_wallet_buy_rob_post (body: WalletBuyRobBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<BuyRopResponse>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/wallet/buy-rob/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<BuyRopResponse> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<BuyRopResponse>

}
/**
Charge

*/
export async function api_wallet_charge_post (body: WalletChargeBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<WalletIrrResponse>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/wallet/charge/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<WalletIrrResponse> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<WalletIrrResponse>

}
/**
Prices

*/
export async function api_wallet_prices_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<PriceSettings>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/wallet/prices/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<PriceSettings> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<PriceSettings>

}
/**
Zarinpal Callback

*/
export async function api_wallet_zarinpal_cb_get (params: {Status:(string),Authority:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { Status,Authority } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/wallet/zarinpal-cb/`,
        method: 'GET',
        params: { Status,Authority },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Zibal Callback

*/
export async function api_wallet_zibal_cb_get (params: {success:(string),trackId:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { success,trackId } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let [r, p] = await ud.httpx({
        url: `/api/wallet/zibal-cb/`,
        method: 'GET',
        params: { success,trackId },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(), p,
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
